const { PLUS_MONTHLY_CREDITS_DISPLAY, PLUS_PREMIUM_MONTHLY_CREDITS_DISPLAY } = require('../config');

const TRANSLATIONS_ENGLISH = {
  common: {
    retry: 'Try again',
    more: 'More',
    copy: 'Copy',
    copied: 'Copied!',
    cancel: 'Cancel',
    today: 'Today',
    yesterday: 'Yesterday',
    create: 'Create',
    update: 'Update',
    archive: 'Archive',
    loadMore: 'Load more',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    termsOfSale: 'Terms of Sale',
    ccpa: 'CCPA',
    dmca: 'DMCA',
    about: 'About',
    pricing: 'Pricing',
    contact: 'Contact',
    signIn: 'Sign in',
    signUp: 'Sign up',
    save: 'Save',
    delete: 'Delete',
    loading: 'Loading...',
    less: 'Less',
    done: 'Done',
    clear: 'Clear',
    add: 'Add',
    ok: 'OK',
    error: 'Error',
    select: 'Select',
    appLogo: 'Gab AI Logo',
    new: 'NEW',
    viewAllModels: 'View all models',
    viewAllTools: 'View all tools',
    dismiss: 'Dismiss',
  },
  errors: {
    conversationCreation: 'Failed to create conversation',
  },
  shortcuts: {
    toggleSidebar: 'Toggle Sidebar',
    newChat: 'New Chat',
    newWork: 'New Work',
    workSend: 'Send message · queue if running',
    workSendNow: 'Send now · steer the active run',
    workStop: 'Stop the active run',
    newTemporaryChat: 'New Temporary Chat',
    focusChatInput: 'Focus Chat Input',
    focusSearch: 'Focus Search',
    findInChat: 'Find in Chat',
    openFileUpload: 'Open File Upload',
    openShortcuts: 'Open Shortcuts',
    goToHome: 'Go to Home',
    goToAgents: 'Go to Bots',
    goToModels: 'Go to Models',
    goToFiles: 'Go to Files',
    goToSettings: 'Go to Settings',
  },
  dropdowns: {
    regenerate: 'Regenerate',
    bookmark: 'Bookmark',
    preferResponse: 'I prefer this response',
    rejectResponse: "I don't like this response",
    feedback: 'Feedback',
    export: 'Export',
    newChat: 'New chat',
    saveThisChat: 'Save this chat',
    temporaryChatSettings: 'Temporary chat settings',
    doneSelecting: 'Done selecting',
    select: 'Select',
    unpin: 'Unpin',
    pin: 'Pin',
    rename: 'Rename',
    chatDetails: 'Chat details',
    share: 'Share',
    moveToCollection: 'Move to Collection',
    addToCollection: 'Add to Collection',
    back: 'Back',
    newCollection: 'New collection',
    noCollections: 'No collections',
    removeFrom: 'Remove from %NAME%',
    unarchive: 'Unarchive',
    archive: 'Archive',
    report: 'Report',
    changeIcon: 'Change icon',
    renameCollection: 'Rename collection',
    deleteCollection: 'Delete collection',
    newSubcollection: 'New subcollection',
    moveCollection: 'Move collection',
    unsave: 'Unsave',
    seeAgentDetails: 'See Bot Details',
    copyLink: 'Copy link',
    seeModelDetails: 'See Model Details',
    chatRemovedFromCollection: 'Chat removed from collection',
    chatAddedToCollection: 'Chat added to collection',
    viewCollection: 'View Collection',
    collection: 'Collection',
    exportChat: 'Export Chat',
    exportAsPdf: 'PDF',
    exportAsMarkdown: 'Markdown',
    exportAsText: 'Plain Text',
    exportSuccess: 'Conversation exported successfully',
    exportFailed: 'Failed to export conversation',
  },
  chat: {
    archive: {
      title: 'Archive Chat',
      unarchiveTitle: 'Unarchive Chat',
      message: 'Are you sure you want to archive this chat? It will be moved to your archived chats.',
      unarchiveMessage: 'Are you sure you want to unarchive this chat? It will be moved back to your active chats.',
      confirmButton: 'Archive',
      unarchiveButton: 'Unarchive',
      success: 'Chat archived successfully',
      unarchiveSuccess: 'Chat unarchived successfully',
      error: 'Failed to archive chat'
    },
    delete: {
      title: 'Delete Chat',
      message: 'Are you sure you want to delete this chat? This action cannot be undone.',
      confirmButton: 'Delete',
      success: 'Chat deleted successfully',
      error: 'Failed to delete chat'
    },
    saveTemporary: {
      title: 'Save chat?',
      message: 'This chat will now be included in your history. It will follow your memory settings used for regular chats.',
      confirmButton: 'Save',
      success: 'Chat saved to your history',
      error: 'Failed to save chat',
    },
    summaryPill: {
      label: '%COUNT% earlier message%PLURAL% condensed to keep this chat going.',
      expand: 'View summary',
      collapse: 'Hide summary',
    },
    workUpgrade: {
      notice: 'You sent this request to the Work agent.',
    },
    sourcesOutputs: {
      inputs: 'Inputs',
      outputs: 'Outputs',
      sources: 'Sources',
      addSources: 'Add sources',
      uploadFile: 'Upload file',
      fromLibrary: 'From library',
      collapse: 'Hide',
      collapseTooltip: 'Hide Sources & Outputs',
      expand: 'Show Sources & Outputs',
      collapsedLabel: 'Sources',
      cloudBrowser: 'Cloud browser',
      openCloudBrowser: 'Open cloud browser',
            videoStudio: 'Video studio',
            imageStudio: 'Image studio',
            openImageStudio: 'Open image studio',
      openVideoStudio: 'Open video studio',
      tasks: 'Tasks',
      addTask: 'Add task',
      editTask: 'Edit task',
      deleteTask: 'Delete task',
      noSourcesYet: 'Nothing cited yet',
    },
    find: {
      placeholder: 'Find in chat',
      previous: 'Previous match',
      next: 'Next match',
      close: 'Close find',
      noResults: 'No results',
      matchCount: '%CURRENT% of %TOTAL%',
    },
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'We\'d love to hear from you!',
    otherWaysTitle: 'Other Ways to Contact Us',
    selectReason: 'Please select a reason',
    reasonLabel: 'Reason',
    reasons: {
      technicalIssues: 'Technical Issues',
      accountBilling: 'Account/Billing',
      enterprisePricing: 'Enterprise Pricing/Sales Inquiry',
      featureRequest: 'Feature Request',
      bugReport: 'Bug Report',
      generalFeedback: 'General Feedback',
      other: 'Other',
    },
  },
  navigation: {
    home: 'Home',
    agents: 'Bots',
    files: 'Files',
    images: 'Images',
    videos: 'Videos',
    music: 'Music',
    createImages: 'Create images',
    createVideos: 'Create videos',
    createMusic: 'Create music',
    collections: 'Collections',
    library: 'Your Chats',
    search: 'Search Chats',
    models: 'Models',
    tasks: 'Tasks',
    work: 'Work',
    tools: 'Tools',
    prompts: 'Prompt Library',
    toolsSeeAll: 'See all',
    modelsSeeAll: 'See all',
    workflows: 'Workflows',
    memory: 'Memory',
    deck: 'Deck',
    bookmarks: 'Bookmarks',
    explore: 'Explore',
    more: 'More',
    searchResults: 'Search Results',
  },
  explore: {
    title: 'Explore',
    discoveryTopline: 'Hand-picked prompts & outputs',
    discoveryHeadline: 'Browse AI images, video, music & 3D',
    discoverySubtitle:
      'Open any item to read or remix the prompt, save favorites, or start a new generation.',
    searchPlaceholder: 'Search explore...',
    allMedia: 'All',
    images: 'Images',
    videos: 'Videos',
    music: 'Music',
    models3d: '3D',
    featured: 'Featured',
    newest: 'Newest',
    popular: 'Popular',
    trending: 'Trending',
    usePrompt: 'Use This Prompt',
    editRemix: 'Edit & Remix',
    changeModel: 'Change Model',
    copyPrompt: 'Copy Prompt',
    share: 'Share',
    cloneSuccess: 'Prompt copied — starting generation',
    remixSuccess: 'Remix ready — starting generation',
    generate: 'Generate',
    makeVideo: 'Make Video',
    confirmVideoTitle: 'Create this video?',
    confirmVideoCredits: 'This will use about %COUNT% credits. Continue only if you want to start generation now.',
    confirmVideoCreditsUnknown: 'Creating a video uses credits. Continue only if you want to start generation now.',
    confirmVideoConfirm: 'Create Video',
    editLyrics: 'Edit Lyrics',
    noItems: 'No items yet',
    noItemsSubtitle: 'Check back soon for curated AI-generated content',
    favoritesEmptyTitle: 'No favorites yet',
    favoritesEmptySubtitle:
      'Save images, videos, music, and 3D pieces you love — tap the heart on any item in Explore.',
    favoritesEmptyGalleryHint: 'From the gallery',
    favoritesEmptyGalleryHintDesc: 'Browse Explore and tap the heart on any card to save it here.',
    favoritesEmptyDetailHint: 'From an open item',
    favoritesEmptyDetailHintDesc:
      'Open any piece to view details, then use the heart to add or remove it from favorites.',
    favoritesEmptyBrowse: 'Browse Explore',
    loadMore: 'Load more',
    typeToImagine: 'Type to imagine...',
    musicDescriptionPlaceholder: 'Describe the music style (genre, mood, tempo)...',
    lyricsLabel: 'LYRICS',
    lyricsPlaceholder: 'Write or paste lyrics (or leave blank for instrumental)...',
    plusRequired: 'Unlock this model',
    plusRequiredSubtitle: 'This creation uses a premium model. Buy credits or upgrade to Plus to use it.',
    limitReached: 'Generation Limit Reached',
    limitReachedSubtitle: 'You\'ve hit your free generation limit. Upgrade to Plus for unlimited creations.',
    browseCategories: 'Categories',
    allCategories: 'All categories',
    moreCategories: 'More categories',
    scrollForMore: 'Scroll for more',
    categoriesTitle: 'Explore Categories',
    categoriesSubtitle: 'Browse curated AI-generated content by category',
    backToExplore: 'BACK TO EXPLORE',
    relatedItems: 'More to explore',
    variationsLabel: 'Variations',
    goToExplorePage: 'Go to explore',
    categoryItems: '%COUNT% items',
    categoryItemSingle: '1 item',
    noCategoriesFound: 'No categories found',
  },
  images: {
    inputPlaceholder: 'Describe a new image',
    tryAStyle: 'Try a Style',
    tryOurModels: 'Try Our Image Generation Models',
    tryOurTools: 'Try Our Image Tools',
    discoverNew: 'Discover Something New',
    myImages: 'My Images',
    noImages: 'No images yet',
    noImagesSubtitle: 'Create your first image to see it here',
    createFirst: 'Create your first image',
  },
  videos: {
    inputPlaceholder: 'Describe a new video',
    tryAStyle: 'Try a Style',
    tryOurModels: 'Try Our Video Generation Models',
    tryOurTools: 'Try Our Video Tools',
    discoverNew: 'Discover Something New',
    myVideos: 'My Videos',
    noVideos: 'No videos yet',
    noVideosSubtitle: 'Create your first video to see it here',
    createFirst: 'Create your first video',
  },
  music: {
    lyricsPlaceholder: 'Enter your lyrics',
    tryAStyle: 'Try a Style',
    tryAStyleSubtitle: 'Select a style below and add your lyrics to create music',
    tryOurTools: 'Try Our Music Tools',
    discoverNew: 'Discover Something New',
    myMusic: 'My Music',
    noMusic: 'No music yet',
    noMusicSubtitle: 'Create your first track to see it here',
    createFirst: 'Create your first track',
  },
  models3d: {
    inputPlaceholder: 'Describe a 3D model',
    imageToThreeDPlaceholder: 'Describe the 3D model (optional)',
    tryAStyle: 'Try a Style',
    tryOurModels: 'Try Our 3D Generation Models',
    discoverNew: 'Discover Something New',
    myModels: 'My 3D Models',
    noModels: 'No 3D models yet',
    noModelsSubtitle: 'Create your first 3D model to see it here',
    createFirst: 'Create your first 3D model',
    tapToView: 'Tap to view in 3D',
    viewInAR: 'View in AR',
    downloadFormats: 'Download',
    loading: 'Loading 3D model...',
    unsupported: '3D viewer is not supported on this device',
    loadError: 'Failed to load 3D model',
    rotate: 'Drag to rotate',
    format: 'Format',
    polyCount: 'Polygons',
    textured: 'Textured',
    rigged: 'Rigged',
    pbrMaterials: 'PBR materials',
  },
  search: {
    noResults: 'No results found',
  },
  home: {
    inputPlaceholder: 'Ask a question, search the web, or talk an idea through…',
    workTagline: 'What should we work on?',
    workInputPlaceholder: 'Work on anything',
    workToolsSectionTitle: 'Work',
    temporaryChat: 'Temporary Chat',
    temporaryChatSubtitle: "This chat won't appear in history.",
    temporaryChatLearnMore: 'Learn more',
    temporaryChatPersonalized: 'Personalized',
    temporaryChatUnpersonalized: 'Unpersonalized',
    dashboard: 'Dashboard',
    dashboardDescription: 'Start a new conversation with your preferred AI assistant. Get smart suggestions and seamlessly manage your AI interactions.',
    outOfCreditsTitle: 'Out of credits',
    outOfCreditsSubtitle: `You've used all your free credits. Upgrade to Plus for free default model messages and ${PLUS_MONTHLY_CREDITS_DISPLAY} monthly credits.`,
    failedToSend: 'Failed to send message',
    aiToolsSectionTitle: 'AI Tools',
    viewAllTools: 'View all',
    tryTool: 'Try %NAME%',
    tryWorkMode: 'Use Work Mode For This Task',
    taglines: {
      0: 'How may I help you?',
      1: "What's on your mind?",
      2: "Let's create something amazing",
      3: 'Ready when you are',
      4: 'What would you like to explore?',
      5: 'What can I help you with?',
      6: 'Your ideas, amplified',
      7: 'Ask me anything',
      8: 'What do you want to talk about?',
      9: "Let's make something great",
    },
    searchWebPrompts: {
      0: "What's happening in the news today?",
      1: 'Find the best wireless headphones under $200',
      2: 'What are the latest developments in AI?',
      3: 'Check the current weather forecast',
      4: "What are today's stock market updates?",
      5: 'Find recent reviews for the latest smartphones',
    },
    createCategories: {
      'create-image': 'Create an Image',
      'create-video': 'Create a Video',
      'create-music': 'Create Music',
      'search-web': 'Search The Web',
    },
    categoryPrompts: {
      summarize_text: {
        0: 'Summarize this article for me',
        1: 'Give me a bullet-point overview',
        2: 'List the key takeaways from this file',
        3: 'Explain these paragraphs in simpler terms',
        4: 'Provide an executive summary for me',
        5: 'Highlight the main points in this email',
      },
      help_write: {
        0: 'Show me weaknesses in my writing',
        1: 'Create clear technical explanations',
        2: 'Develop step-by-step instructions',
        3: 'Draft a professional case-study outline',
        4: 'Write a persuasive speech draft',
        5: 'Outline a blog post on this topic',
      },
      analyze_data: {
        0: 'Analyze these metrics for trends',
        1: 'Help me understand this dataset',
        2: 'Find patterns in this data',
        3: 'Compare these data points',
        4: 'Summarize the results plainly',
        5: 'Identify key insights from numbers',
      },
      make_plan: {
        0: 'Create a project timeline with milestones',
        1: 'Help me organize my tasks effectively',
        2: 'Build a weekly study schedule',
        3: 'Plan a balanced workout routine',
        4: 'Design a nutritious meal plan',
        5: 'Map out a learning roadmap',
      },
      brainstorm: {
        0: 'Generate creative ideas for my project',
        1: 'Help me brainstorm possible solutions',
        2: 'Brainstorm effective marketing strategies',
        3: 'Suggest engaging blog post topics',
        4: 'Identify fresh business opportunities',
        5: 'Think up innovative product features',
      },
      get_advice: {
        0: 'Give me tailored career advice',
        1: 'Help me decide on this issue',
        2: 'Suggest practical ways to improve',
        3: 'Advise me on my situation',
        4: 'Recommend my next best steps',
        5: 'Guide me through this process',
      },
      write_code: {
        0: 'Help me debug this code snippet',
        1: 'Explain what this function does',
        2: 'Optimize this algorithm for speed',
        3: 'Write comprehensive unit tests',
        4: 'Refactor this code for clarity',
        5: 'Implement this feature step by step',
      },
    },
    categoryRichPrompts: {
      summarize_text: {
        0: 'Please summarize this article for me. If you need the full text or extra context, ask me to upload it. Limit yourself to two brief follow-up questions and request files when useful. Keep replies friendly and concise.',
        1: "Give me a bullet-point overview of this content. Ask me for the source text if it's missing. Pose no more than two clarifying questions and request uploads as needed. Respond in a concise, conversational style.",
        2: 'List the key takeaways from this file. Let me know if I should upload the document. Ask up to two short follow-up questions and request files when helpful. Keep answers brief and friendly.',
        3: "Explain these paragraphs in simpler terms. If the text isn't attached, ask me to provide it. Ask a maximum of two clarifying questions and request uploads as required. Respond succinctly and conversationally.",
        4: "Provide an executive summary of this material. Request the document if you don't have it. Limit clarifications to two questions and ask for uploads when useful. Keep your tone friendly and concise.",
        5: 'Highlight the main points in this email thread. If you need the full thread, ask me to paste or upload it. Ask at most two brief questions and request files as helpful. Respond in a short, conversational manner.',
      },
      help_write: {
        0: "Identify weaknesses in my writing sample. Ask me to share the text if it's missing. Pose up to two concise follow-up questions and request uploads as needed. Keep replies friendly and brief.",
        1: 'Create clear technical explanations for this topic. Tell me if you need source material or specs. Ask no more than two clarifying questions and request files when useful. Respond succinctly and conversationally.',
        2: 'Develop step-by-step instructions for this task. Request any missing details or reference documents. Limit clarifications to two questions and ask for uploads as needed. Keep it brief and friendly.',
        3: 'Draft a professional case-study outline. Let me know what data or files you require. Ask up to two short clarifying questions and request uploads when useful. Respond in a concise, conversational tone.',
        4: 'Write a persuasive speech draft on this topic. Ask me for audience, length, or other details if absent. Pose no more than two clarifying questions and request uploads as needed. Keep answers friendly and brief.',
        5: 'Outline a blog post on this topic. Request goals, audience info, or examples if missing. Ask a maximum of two follow-up questions and request uploads when helpful. Respond concisely and conversationally.',
      },
      analyze_data: {
        0: 'Analyze these metrics for trends. If you need the dataset, ask me to upload it. Ask no more than two clarifying questions and request files as required. Keep replies friendly and concise.',
        1: "Help me understand this dataset. Request the file or schema if it isn't provided. Pose up to two brief questions and ask for uploads when useful. Respond in a short, conversational style.",
        2: 'Find patterns in this data. Let me know if you need the raw file. Limit clarifications to two questions and request uploads as needed. Keep answers concise and friendly.',
        3: 'Compare these data points. Ask for the data file or context if missing. Ask a maximum of two follow-up questions and request uploads when useful. Respond succinctly and conversationally.',
        4: "Summarize the results plainly. If the data isn't attached, ask me to share it. Pose no more than two clarifying questions and request files when helpful. Keep replies brief and friendly.",
        5: "Identify key insights from these numbers. Request the dataset if you don't have it. Limit clarifications to two questions and ask for uploads when useful. Respond in a concise, conversational tone.",
      },
      make_plan: {
        0: 'Create a project timeline with milestones. Ask me for scope, deadlines, or files if needed. Ask up to two brief clarifying questions and request uploads as helpful. Keep replies friendly and concise.',
        1: 'Help me organize my tasks effectively. Request objectives, resources, or reference docs if missing. Limit clarifications to two questions and ask for uploads as needed. Respond succinctly and conversationally.',
        2: 'Build a weekly study schedule. Ask for my goals, subjects, and availability if not provided. Pose no more than two clarifying questions and request uploads when useful. Keep answers brief and friendly.',
        3: 'Plan a balanced workout routine. Ask about fitness goals, equipment, or constraints. Ask up to two concise questions and request uploads if helpful. Respond in a short, conversational tone.',
        4: 'Design a nutritious meal plan. Request dietary preferences, restrictions, or sample foods if missing. Limit clarifications to two questions and request uploads when useful. Keep replies friendly and concise.',
        5: 'Map out a learning roadmap. Ask for my current level, goals, and timeframe. Pose no more than two clarifying questions and request uploads as needed. Respond succinctly and conversationally.',
      },
      brainstorm: {
        0: 'Generate creative ideas for my project. Ask me for project context or constraints if missing. Limit yourself to two brief clarifying questions and request uploads as helpful. Keep responses friendly and concise.',
        1: 'Help me brainstorm possible solutions. Request problem details or supporting files if needed. Ask no more than two clarifying questions and request uploads when useful. Respond in a short, conversational manner.',
        2: 'Brainstorm effective marketing strategies. Ask for product info, audience, or reference docs if absent. Pose up to two brief questions and request uploads as needed. Keep answers concise and friendly.',
        3: 'Suggest engaging blog post topics. Request the niche, goals, or examples if missing. Ask a maximum of two clarifying questions and request uploads when helpful. Respond succinctly and conversationally.',
        4: 'Identify fresh business opportunities. Ask for industry, resources, or constraints if not provided. Limit clarifications to two questions and request uploads as needed. Keep replies brief and friendly.',
        5: 'Think up innovative product features. Request product details or user feedback if absent. Ask up to two short follow-up questions and request uploads when useful. Respond in a concise, conversational tone.',
      },
      get_advice: {
        0: "Give me tailored career advice. Ask for my background, goals, or résumé if missing. Pose no more than two clarifying questions and request uploads as needed. Keep replies friendly and brief.",
        1: 'Help me decide on this issue. Request the necessary context or files if absent. Ask up to two concise questions and request uploads when helpful. Respond in a short, conversational style.',
        2: 'Suggest practical ways to improve. Ask which area I\'m focusing on and any constraints. Limit clarifications to two questions and request uploads when useful. Keep answers succinct and friendly.',
        3: 'Advise me on my situation. Request relevant details or documents if needed. Ask no more than two follow-up questions and request uploads when helpful. Respond briefly and conversationally.',
        4: 'Recommend my next best steps. Ask for context, goals, or supporting files if missing. Pose up to two clarifying questions and request uploads as needed. Keep replies friendly and concise.',
        5: 'Guide me through this process. Ask what stage I\'m at and any reference docs. Limit clarifications to two questions and request uploads when useful. Respond in a short, conversational tone.',
      },
      write_code: {
        0: "Help me debug this code snippet. Ask me to paste the code or error if it's missing. Ask up to two brief clarifying questions and request files as needed. Keep replies friendly and concise.",
        1: 'Explain what this function does. Request the function code if not provided. Pose no more than two clarifying questions and request uploads when useful. Respond succinctly and conversationally.',
        2: 'Optimize this algorithm for speed. Ask for the code and performance constraints if absent. Limit clarifications to two questions and request uploads when helpful. Keep answers brief and friendly.',
        3: 'Write comprehensive unit tests for this code. Ask me for the code or specs if missing. Ask up to two concise follow-up questions and request uploads as needed. Respond in a short, conversational style.',
        4: "Refactor this code for clarity. Ask me to share the code if it isn't provided. Pose no more than two clarifying questions and request uploads when useful. Keep replies friendly and concise.",
        5: 'Implement this feature step by step. Request the current codebase or requirements if missing. Ask a maximum of two clarifying questions and request uploads as needed. Respond succinctly and conversationally.',
      },
    },
  },
  auth: {
    login: {
      title: 'Welcome back to %APP_NAME%',
      subtitle: 'Enter your email and password to continue.',
      emailLabel: 'Email address',
      passwordLabel: 'Password',
      submitButton: 'Log In',
      noAccount: "Don't have an account?",
      signupLink: 'Sign up',
      forgotPassword: 'Forgot password?',
      errors: {
        invalidEmail: 'Please enter a valid email address',
        emailRequired: 'Please enter your email address',
        passwordRequired: 'Please enter your password',
        passwordTooShort: 'Password must be at least 8 characters long',
        loginFailed: 'Failed to login. Please try again.',
        wrongPassword: 'Incorrect password. Please try again or reset your password.',
        accountNotFound: 'No account found with that email address.',
        captchaRequired: 'Please complete the verification to continue.',
      }
    },
    signup: {
      title: 'Create your %APP_NAME% account',
      subtitle: 'Enter your email and password to get started.',
      emailLabel: 'Email address',
      passwordLabel: 'Password',
      submitButton: 'Sign Up',
      haveAccount: 'Already have an account?',
      loginLink: 'Log in',
      errors: {
        emailRequired: 'Please enter your email address',
        invalidEmail: 'Please enter a valid email address',
        passwordRequired: 'Please enter your password',
        passwordTooShort: 'Password must be at least 8 characters long',
        signupFailed: 'Failed to sign up. Please try again.',
        captchaRequired: 'Please complete the verification to continue.',
      }
    },
    forgotPassword: {
      title: 'Reset your password',
      subtitle: 'Enter your email address and we\'ll send you instructions to reset your password.',
      emailLabel: 'Email address',
      submitButton: 'Send Reset Instructions',
      backToLogin: 'Back to login',
      rememberPassword: 'Remember your password?',
      success: 'Reset instructions have been sent to your email.',
      ssoOnlyMessage: 'This account uses social login. Please sign in with Google or Apple instead.',
      errors: {
        captchaRequired: 'Please verify you are human by completing the captcha.',
        emailRequired: 'Please enter your email address',
        invalidEmail: 'Please enter a valid email address',
        resetFailed: 'Failed to send reset instructions. Please try again.',
      },
    },
    resetPassword: {
      title: 'Reset your password',
      subtitle: 'Enter your new password to continue.',
      emailLabel: 'Email address',
      passwordLabel: 'New password',
      confirmPasswordLabel: 'Confirm new password',
      submitButton: 'Reset Password',
      verifyingToken: 'Verifying reset link...',
      pleaseWait: 'Please wait while we verify your reset link.',
      errorTitle: 'Reset link invalid',
      rememberYourPassword: 'Remember your password?',
      loginLink: 'Log in',
      successTitle: 'Password reset successfully',
      successMessage: 'Your password has been reset successfully. You can now log in to your account.',
      goToLogin: 'Go to Login',
      errors: {
        noToken: 'Invalid reset link. No token provided.',
        invalidToken: 'Invalid or expired reset link.',
        verificationFailed: 'Failed to verify reset link. Please try again.',
        emailRequired: 'Please enter your email address',
        invalidEmail: 'Please enter a valid email address',
        passwordRequired: 'Please enter your new password',
        passwordTooShort: 'Password must be at least 8 characters long',
        passwordsDoNotMatch: 'Passwords do not match',
        captchaRequired: 'Please verify you are human by completing the captcha.',
        resetFailed: 'Failed to reset password. Please try again.'
      },
    },
    verifyEmail: {
      title: 'Verify your email',
      loadingTitle: 'Verifying your email...',
      loadingSubtitle: 'Please wait while we verify your email address.',
      successTitle: 'Email verified!',
      successTitleReward: '%CREDITS% credits added',
      successSubtitle: 'Your email has been verified successfully. You can now log in to your account.',
      successSubtitleReward: 'Thanks for confirming it\'s you. Your %CREDITS% bonus credits are in your account — log in to use them.',
      successSubtitleLoggedIn: 'Thanks for confirming it\'s you. You\'re all set.',
      successSubtitleRewardLoggedIn: 'Thanks for confirming it\'s you. Your %CREDITS% bonus credits are already in your account.',
      errorTitle: 'Verification failed',
      errors: {
        noToken: 'Invalid verification link. No token provided.',
        invalidToken: 'Invalid or expired verification link.',
        verificationFailed: 'Failed to verify email. Please try again.',
      },
      buttons: {
        goToLogin: 'Go to Login',
        backToApp: 'Back to Gab AI',
      }
    },
    sso: {
      signUpWithGoogle: 'Sign up with Google',
      signInWithGoogle: 'Sign in with Google',
      signUpWithApple: 'Sign up with Apple',
      signInWithApple: 'Sign in with Apple',
      or: 'or',
      errors: {
        googleFailed: 'Google sign-in failed. Please try again.',
        appleFailed: 'Apple sign-in failed. Please try again.',
      },
    },
  },
  themes: {
    white: 'White',
    ocean: 'Ocean',
    pastel: 'Pastel',
    mint: 'Mint',
    paper: 'Paper',
    sepia: 'Sepia',
    muted: 'Muted',
    night: 'Night',
    smoke: 'Smoke',
    black: 'Black',
  },
  pets: {
    chooseTitle: 'Choose your chat companion',
    chooseShortTitle: 'Choose a companion',
    chooseSubtitle: 'Pick a companion to join new chats and keep you company while Gab is thinking.',
    changeAnytime: 'You can change or hide your companion anytime in Appearance settings.',
    settingsTitle: 'Chat companion',
    settingsSubtitle: 'Choose a companion for new chats and the start of responses.',
    none: 'No companion',
    notNow: 'Not now',
    saved: 'Chat companion updated',
    saveFailed: 'Could not update your chat companion',
    heroAccessibility: '%NAME%, your chat companion. Press to change companion.',
    themes: {
      animals: 'Animals',
      robots: 'Robots',
      pixels: 'Pixels',
    },
  },
  settings: {
    appearance: {
      theme: 'Theme',
      accentBackgroundColor: 'Accent Background Color',
      accentTextColor: 'Accent Text Color',
      messageLayout: {
        title: 'Message Layout',
        bubble: 'Bubble',
        minimal: 'Minimal',
        wide: 'Wide',
        slim: 'Slim'
      },
      messageWidth: {
        title: 'Message Width',
        narrow: 'Narrow',
        medium: 'Medium',
        full: 'Full'
      },
      tagsLayout: {
        title: 'Tags Layout',
        list: 'List',
        grid: 'Grid'
      },
      chatInputStyle: {
        title: 'Chat Input Style',
        fixed: 'Fixed',
        floating: 'Floating',
        detailed: 'Detailed'
      },
      increaseBorderContrast: {
        title: 'Increase Border Contrast',
        subtitle: 'Add contrast to borders around windows and sections'
      },
      showTagCounts: {
        title: 'Show Tag Counts',
        subtitle: 'Display the number of chats in each tag'
      },
      showTimestamps: {
        title: 'Show Timestamps',
        subtitle: 'Display conversation time since last message'
      },
      showMessageActions: {
        title: 'Show Message Actions',
        subtitle: 'Always display buttons below the message without hovering'
      },
      showSourcesOutputsPanel: {
        title: 'Show Sources & Outputs',
        subtitle: 'Display the sources and outputs sidebar beside desktop chats'
      },
      showFollowUpSuggestions: {
        title: 'Show Follow-up Suggestions',
        subtitle: 'Display suggested follow-up prompts after each assistant reply',
        enabled: 'Follow-up suggestions enabled',
        disabled: 'Follow-up suggestions disabled',
        updateFailed: 'Could not update follow-up suggestions preference'
      },
      showCollectionSuggestions: {
        title: 'Suggest Collections for Chats',
        subtitle: 'Occasionally suggest moving a chat into one of your collections when it clearly fits',
        enabled: 'Collection suggestions enabled',
        disabled: 'Collection suggestions disabled',
        updateFailed: 'Could not update collection suggestions preference'
      },
      showStockCharts: {
        title: 'Show Stock Charts',
        subtitle: 'Display interactive stock quote charts when you ask about market prices',
        enabled: 'Stock charts enabled',
        disabled: 'Stock charts disabled',
        updateFailed: 'Could not update stock charts preference'
      },
      enterToSend: {
        title: 'Press Enter to send',
        subtitle: 'On: Enter sends the message. Off: Enter inserts a newline.',
      },
      keepScreenAwake: {
        title: 'Keep Screen On',
        subtitle: 'Prevent the phone from auto-locking while Gab AI is open',
      },
      style: 'Style',
      width: 'Width',
    },
    general: {
      notificationSounds: {
        title: 'Agent notification sounds',
        subtitle: 'Play a gentle chime when Work finishes or needs your input. Saved for this browser.',
        preview: 'Preview sound',
      },
      language: {
        title: 'Language',
      },
      verifyEmail: {
        title: 'Verify email',
        subtitle: 'Verify your email to unlock all features',
        button: 'Send Verification Email',
      },
      dataExport: {
        title: 'Download your data',
        subtitle: 'Export a ZIP archive of your account — profile, chats, memories, files, custom bots, collections, voice sessions, bookmarks, and purchases. Includes per-conversation markdown files and a README. Excludes deleted and temporary chats. Developers can fetch the same data via GET /v1/account/export.',
        button: 'Download ZIP',
        successToast: 'Account data ready — check your downloads.',
        successToastNative: 'Account data exported.',
        errorToast: 'Could not export account data. Please try again.',
      },
      dangerZone: {
        title: 'DANGER ZONE',
        archiveAll: {
          title: 'Archive all chats',
          button: 'Archive all',
          confirmTitle: 'Archive All',
          confirmMessage: 'Please enter your password to archive all conversations'
        },
        unarchiveAll: {
          title: 'Unarchive all chats',
          button: 'Unarchive all',
          confirmTitle: 'Unarchive All',
          confirmMessage: 'Please enter your password to move all archived conversations back to your chat history'
        },
        deleteAll: {
          title: 'Delete all chats',
          button: 'Delete all',
          confirmTitle: 'Delete All',
          confirmMessage: 'Please enter your password to delete all conversations'
        },
        deleteAccount: {
          title: 'Delete account',
          button: 'Delete',
          confirmTitle: 'Delete Account',
          confirmMessage: 'Are you sure you want to delete your account? This action cannot be undone.'
        }
      },
      logout: {
        title: 'Log out',
        button: 'Log out',
        confirmTitle: 'Log Out',
        confirmMessage: 'Are you sure you want to log out?'
      },
      errors: {
        operationFailed: 'Operation failed'
      },
      installApp: 'Install App',
      installAppSubtitle: 'Install Gab AI as an app on your device for quick access',
      install: 'Install',
      allArchivedSuccess: 'All conversations archived successfully',
      allUnarchivedSuccess: 'All conversations unarchived successfully',
      allDeletedSuccess: 'All conversations deleted successfully',
      accountDeletedSuccess: 'Account deleted successfully',
      enterPassword: 'Enter your password',
      verificationEmailSent: "Verification email sent successfully. If you don't see it, check your spam folder or email us at ai@gab.com.",
      verificationEmailError: 'Error sending verification email',
      upgradeToArchive: 'Instantly archive all chats, receive unlimited chat history and more features by upgrading to an Gab AI Plus plan!',
      upgradeToDelete: 'Instantly delete all chats, receive unlimited chat history and more features by upgrading to an Gab AI Plus plan!',
    },
    subscription: {
      fetchFailed: 'Failed to fetch subscription details',
      historyFetchFailed: 'Failed to fetch purchase history',
      noActive: 'No Active Subscription',
      inactive: 'Inactive',
      expired: 'Expired',
      upgradeDescription: 'Upgrade to Gab AI Plus to unlock unlimited conversations and premium features.',
      viewPlans: 'View Plans',
      upgradeNow: 'Upgrade Now',
      planFeatures: 'Plan Features',
      paymentMethod: 'Payment Method',
      canceled: 'Canceled',
      active: 'Active',
      started: 'Started',
      accessUntil: 'Access Until',
      nextBillingDate: 'Next Billing Date',
      expires: 'Expires',
      amount: 'Amount',
      canceledWarning: 'Your subscription has been canceled. You will have access until',
      resubscribe: 'Re-subscribe',
      extendOrUpgrade: 'Extend or Upgrade Plan',
      manageInGooglePlay: 'Manage in Google Play',
      manageInAppStore: 'Manage in App Store',
      managedThroughStore: 'This subscription is managed through',
      openMobileToManage: 'Open the Gab AI app on your mobile device to manage your plan.',
      billingIssue: 'Billing Issue',
      billingGracePeriod: 'There was a problem with your payment. Your subscription will remain active until',
      billingUpdatePayment: 'Please update your payment method to avoid losing access.',
      billingRenewalProblem: 'There was a problem renewing your subscription. Please update your payment method to continue your subscription.',
      updatePaymentInGooglePlay: 'Update Payment in Google Play',
      updatePaymentInAppStore: 'Update Payment in App Store',
      updatePaymentMethod: 'Update Payment Method',
      openMobileToUpdatePayment: 'Open the Gab AI app on your mobile device to update your payment method.',
      cancelSubscription: 'Cancel Subscription',
      manageSubscription: 'Manage Subscription',
      manageViaWhop: 'Manage your subscription, update payment method, cancel, or view invoices through the Whop billing portal.',
      canceledSuccess: 'Subscription canceled successfully. You will have access until the end of your current billing period.',
      paymentHistory: 'Payment History',
      loadingPaymentHistory: 'Loading payment history...',
      noPaymentHistory: 'No payment history',
      purchasesAppearHere: 'Your purchases will appear here',
      update: 'Update',
      managedVia: 'Managed via',
      updatePaymentInStore: 'Update your payment method in your',
      nextBillOn: 'Next bill on',
      endingIn: 'ending in',
      expiry: 'Expiry',
      sharingNotAvailable: 'Sharing is not available on this device',
      failedToSaveReceipt: 'Failed to save receipt',
      receiptNotAvailable: 'Receipt not available',
      failedToDownloadReceipt: 'Failed to download receipt',
      manageWebPayment: 'Please manage your payment method on the web',
      failedToUpdatePayment: 'Failed to update payment method',
      failedToOpenPortal: 'Failed to open subscription management portal',
      opening: 'Opening...',
      redeemOfferCode: 'Redeem Offer Code',
      restorePurchases: 'Restore Purchases',
      annual: 'Annual',
      monthly: 'Monthly',
      weekly: 'Weekly',
      paid: 'Paid',
      date: 'Date',
      description: 'Description',
      status: 'Status',
      autoTopUp: 'Auto Top-Up',
      creditPack: 'Credit Pack',
      credits: 'Credits',
      unlimited: 'Unlimited',
      messagesWithDefaultModel: 'messages with default AI model',
      superchargedLimits: 'Supercharged limits',
      forConversations: 'for conversations, custom bots, and collections',
      monthlyCredits: '2000 credits',
      toUseWith: 'to use with',
      other: 'other',
      aiModelsAndTools: 'AI models & tools',
      lightningFast: 'Lightning-fast',
      responsesWithZeroWait: 'responses with',
      zeroWaitingTime: 'zero waiting time',
      noChangesToSave: 'No changes to save',
    manageSubscriptionTitle: 'Manage Subscription',
    loadingSubDetails: 'Loading subscription details...',
    subscribeToPlusBtn: 'Subscribe to Plus',
    upgradeToPlusBtn: 'Upgrade to Plus',
    needActiveSubscription: 'You need an active Plus subscription to extend or upgrade your plan.',
    subscriptionExpiredMsg: 'Your Plus subscription has expired. Please subscribe to a new plan.',
    subscriptionExpiredMsgPremium: 'Your Plus Premium subscription has expired. Please subscribe to a new plan.',
    resubscribeToPlusTitle: 'Re-subscribe to Plus',
    resubscribeToPlusPremiumTitle: 'Re-subscribe to Plus Premium',
    extendOrUpgradeTitle: 'Extend or Upgrade Subscription',
    previousPlan: 'Previous Plan',
    currentPlan: 'Current Plan',
    planLabel: 'Plan',
    remainingLabel: 'Remaining',
    daysLabel: 'days',
    choosePlan: 'Choose a Plan',
    resubscribeMonthlyBilling: 'Re-subscribe with monthly billing',
    extendCurrentPlan: 'Extend your current plan',
    switchToMonthlyBilling: 'Switch to monthly billing',
    resubscribeAnnualSave: 'Re-subscribe with annual billing — save $40/yr',
    save40Year: 'Save $40/year vs monthly',
    save17Percent: 'SAVE 17%',
    remainingDaysAdded: 'remaining days will be added to your new subscription.',
    purchaseSuccessUpdated: 'Purchase successful! Your subscription has been updated.',
    purchaseFailedRetry: 'Purchase failed. Please try again.',
    unableToOpenCheckout: 'Unable to open checkout. Please try again.',
    processingBtn: 'Processing...',
    upgradeToAnnual: 'Upgrade to Annual',
    switchToMonthlyBtn: 'Switch to Monthly',
    resubscribeAnnualBtn: 'Re-subscribe Annual',
    resubscribeMonthlyBillingBtn: 'Re-subscribe Monthly',
    extendAnnualBtn: 'Extend Annual',
    extendMonthlyBtn: 'Extend Monthly',
    continueLabel: 'Continue',
    },
    api: {
      accessTitle: 'Access the Gab AI API',
      accessSubtitle: 'Build powerful AI applications with our API. Use credits to access all our models.',
      restfulAccess: 'RESTful API Access',
      restfulAccessDesc: 'OpenAI-compatible API endpoints for easy integration',
      multipleModels: 'Multiple Models',
      multipleModelsDesc: 'Access to all our AI models through a single API',
      rateLimit: '10,000 requests/day',
      rateLimitDesc: 'Generous rate limits for Plus subscribers',
      accessOurApi: 'Access Our API',
      upgradeForApi: 'Upgrade to Plus to get API access and build with our AI models.',
      documentation: 'Documentation',
      documentationSubtitle: 'View comprehensive API documentation including all endpoints, parameters, and code examples.',
      viewApiDocs: 'View API Documentation',
      apiKeys: 'API Keys',
      apiKeysSubtitle: 'Manage your API keys. You can have up to 10 API keys. Keep them secret and secure.',
      rateLimits: 'Rate Limits',
      rateLimitsSubtitle: 'Your API usage limits and current status.',
      requestsPerDay: 'requests per day',
      requestsPerDayDesc: 'High throughput for production use',
      resetsDaily: 'Resets daily at',
      midnightUtc: 'midnight UTC',
      apiCapabilities: 'API Capabilities',
      apiCapabilitiesSubtitle: 'Available endpoints you can access with your API key.',
      quickDocumentation: 'Quick Documentation',
      quickDocumentationSubtitle: "You can use this API key with OpenAI-compatible libraries to access our API. Here's a quick example:",
      quickDocSubtitle: "You can use this API key with OpenAI-compatible libraries to access our API. Here's a quick example:",
      enterprise: 'Enterprise',
      enterpriseSubtitle: 'Need higher rate limits or custom solutions?',
      enterpriseContact: 'Enterprise developers should reach out to us at',
      codeCopied: 'Code copied to clipboard',
      codeCopyFailed: 'Failed to copy code',
      keyCreated: 'API key created successfully',
      revokeKey: 'Revoke API Key',
      revokeKeyMessage: 'Are you sure you want to revoke this API key? This action cannot be undone and any applications using this key will no longer work.',
      unnamedKey: 'Unnamed Key',
      revoke: 'Revoke',
      keyRevoked: 'API key revoked successfully',
      cannotRevokeCurrent: 'Cannot revoke the API key currently in use',
      revokeKeyFailed: 'Failed to revoke API key',
      never: 'Never',
      loadingApiKeys: 'Loading API keys...',
      retry: 'Retry',
      noApiKeys: 'No API keys yet',
      createNewKey: 'Create New Key',
      securityNote: 'For security, full API keys are only shown once when created. Create a new key if you need to copy one.',
      name: 'Name',
      key: 'Key',
      created: 'Created',
      revoked: 'Revoked',
      copyCode: 'Copy Code',
      chatCompletions: 'Chat Completions',
      imageGeneration: 'Image Generation',
      videoGeneration: 'Video Generation',
      textToSpeech: 'Text-to-Speech',
      creditBalance: 'Credit Balance',
      apiKeyManagement: 'API Key Management',
      listModels: 'List Models',
      apiKeysCount: 'API Keys (%COUNT%/10)',
      apiNote: 'Only Gab AI Plus users can make API requests. Every API request draws from your credit balance, with a one-credit floor.',
      apiNoteModels: 'Use "arya" for our default bot, or any of the other bots available (check /v1/models with an authorized curl request).',
    },
    usage: {
      cachedRefreshFailed: 'Showing saved usage. Could not refresh; try again.',
      refreshingCached: 'Showing saved usage while refreshing in the background.',
      fullTaskBreakdown: 'Model and service costs across the full task',
      browserUsage: 'Browser usage',
      unattributedTaskCosts: 'Other task charges (model unavailable)',
      taskTotal: 'Task total',
      taskTotalsMismatch: 'Some model records do not yet reconcile with the task receipt.',
      unlinkedApi: 'Other API activity',
      expandTaskCosts: 'Show costs for %TITLE%',
      apiGroupSummary: '%COUNT% API charges',
      workGroupSummary: 'Work task · %COUNT% charges',
      taskPeriodBreakdown: 'Model spending in the selected period and filters',
      unlinkedApiExplanation: 'These records do not have a verified task link. They are kept separate from named Work tasks.',
      showIndividualCharges: 'Show individual charges',
      hideIndividualCharges: 'Hide individual charges',
      viewTaskBreakdown: 'View model costs',
      hideTaskBreakdown: 'Hide model costs',
      breakdownmodels: 'By model',
      activityExplanation: 'See the credit cost of your chats and completed Work tasks.',
      noLoadedSpending: 'No charges in the records loaded so far',
      breakdownchats: 'By chat',
      breakdownwork: 'Completed Work tasks',
      recentlyCompleted: 'Most recently completed',
      workReceiptExplanation: 'Full task costs for Work tasks completed in this period, including model calls, media, and browser usage. Totals cover the entire task and may include earlier spending. These are task receipts, not extra charges to add to model spending.',
      chatSpendExplanation: 'Credits spent in each normal chat during the selected period. Open a chat or view its individual charges.',
      untitledWork: 'Untitled Work task',
      untitledChat: 'Untitled chat',
      completedOn: 'Completed %DATE%',
      chatModels: '%COUNT% charges · Models: %MODELS%',
      filterChat: 'View charges for %TITLE%',
      openWork: 'Open Work task ↗',
      openChat: 'Open chat ↗',
      loadingWorkCosts: 'Loading Work task costs',
      workCostsFailed: 'Could not load Work task costs. Your model usage and recent transactions are still available.',
      moreWorkTasks: 'Load more completed tasks',
      showMoreChats: 'Show more chats',
      noCompletedWork: 'No completed Work tasks in this period.',
      loadingChatCosts: 'Loading chat details…',
      noChatCosts: 'No chat spending details are available for this period.',
      selectedChat: 'Selected chat',
      spendingOverview: 'Your credit spending',
      calculating: 'Calculating complete period totals',
      partialHistoryFailed: 'Could not load the full period. Showing %COUNT% recent records; model spending and totals are partial. Refresh to try again.',
      partialHistory: 'Loading more activity · %COUNT% records loaded. Model spending and totals below are partial until loading finishes.',
      overviewDescription: 'Understand what you use, what it costs, and where your credits go.',
      refresh: 'Refresh',
      availableNow: 'CREDIT BALANCE · AVAILABLE NOW',
      balanceFailed: 'Could not refresh your balance. Try again.',
      allowanceExplanation: 'Monthly allowance used this billing cycle',
      lastDays: 'Last %DAYS% days',
      periodSpent: 'Credits spent',
      spentDescription: 'Model and voice charges in this period',
      dailyAverage: 'Average credits / day',
      averageDescription: 'Across all %DAYS% days, including inactive days',
      paidActivity: 'Charged transactions',
      modelCount: 'Across %COUNT% models and services',
      loadingCompleteHistory: 'Loading complete history · %COUNT% transactions received',
      insightsFailed: 'Usage insights could not be loaded',
      insightsFailedDescription: 'We could not retrieve the full history. Retry to see accurate totals.',
      retry: 'Try again',
      whereCreditsGo: 'Where your credits go',
      modelExplanation: 'Charges grouped by model, including associated services. Select a row to filter activity below.',
      rankedBySpend: 'Highest spend first',
      topModelInsight: '%MODEL% accounts for %PERCENT% of your spending — %CREDITS% credits.',
      spendingDistribution: 'Share of credit spending across models and services',
      filterModel: 'Filter transactions for %MODEL%',
      shareOfSpend: '%PERCENT% of spend',
      modelDetail: '%COUNT% charges · %AVERAGE% credits / charge',
      voiceSpend: '%CREDITS% credits via voice',
      clearModel: 'Clear selection',
      viewCharges: 'View charges ↓',
      showFewer: 'Show fewer models',
      showAllModels: 'Show all %COUNT% models & services',
      noSpending: 'No credits spent in this period',
      noSpendingDescription: 'Your charged activity will appear here as you use models and services.',
      dailySpending: 'Daily spending',
      selectDay: 'Select a day to see its credits and filter activity.',
      creditsAdded: '%CREDITS% credits added this period',
      searchActivity: 'Search models or activity',
      filterall: 'All activity',
      filterspent: 'Credits spent',
      filteradded: 'Credits added',
      clearFilters: 'Clear filters',
      matchingTransactions: '%COUNT% matching transactions · credits shown below',
      noMatchingActivity: 'No activity matches this date range and filters.',
      loadMoreActivity: 'Load more · %COUNT% remaining',
      earned: 'Earned credits',
      otherUsage: 'Other usage',
      creditsUsed: 'Credits Used (this cycle)',
      creditsRemaining: 'Credits Remaining',
      totalTransactions: 'Total Transactions',
      monthlyAllotment: 'Monthly Allotment',
      creditsRemaining2: 'credits remaining',
      voiceModeUsage: 'Voice Mode Usage',
      voiceConversations: 'Voice conversations',
      voiceTriggeredActions: 'Voice-triggered actions',
      voiceModeCharges: 'Voice Mode charges 35 credits per minute (time-based). Actions triggered during voice conversations (like image generation) are charged separately at their standard rates.',
      dailyUsage: 'Daily Usage (Past 14 Days)',
      usageByModel: 'Usage by Model (Past 30 Days)',
      transactionHistory: 'Transaction History',
      noTransactions: 'No transactions yet',
      loadingUsageData: 'Loading usage data...',
      failedToLoadUsage: 'Failed to load usage data',
      failedToLoadMore: 'Failed to load more usage data',
      today: 'Today',
      moreModels: 'more models',
      purchase: 'Purchase',
      voiceMode: 'Voice Mode',
      viaVoice: 'via Voice',
      modelOrMemo: 'Model or Memo',
      date: 'Date',
      creditsColumn: 'Credits',
      resets: 'Resets %DATE%',
      monthlyPlusPurchased: '%MONTHLY% monthly + %PURCHASED% purchased',
    },
    memory: {
      title: 'Memory Settings · Add Memory',
      subtitle: 'Control how AI remembers information about you. Store information about yourself that the AI can reference',
      placeholder: "Enter something you'd like the AI to remember...",
      addMemory: 'Add Memory',
      yourMemories: 'Your Memories',
      memoriesStored: 'memories stored',
      noMemoriesYet: 'No memories yet',
      noMemoriesStored: 'No memories stored yet. Add your first memory above!',
      memoryDisabled: 'Memory is currently disabled. Enable it above to start storing memories.',
      memoryCreated: 'Memory created successfully',
      memoryCreateFailed: 'Failed to create memory',
      memoryUpdated: 'Memory updated successfully',
      memoryUpdateFailed: 'Failed to update memory',
      memoryDeleted: 'Memory deleted successfully',
      memoryDeleteFailed: 'Failed to delete memory',
      memoryEmpty: 'Memory content cannot be empty',
      failedToLoad: 'Failed to load memories',
      memoryEnabled: 'Memory enabled for new conversations',
      memoryDisabledMsg: 'Memory disabled for new conversations',
      memoryPrefFailed: 'Failed to update memory preference',
      autoGenEnabled: 'Auto-generation of memories enabled',
      autoGenDisabled: 'Auto-generation of memories disabled',
      autoGenFailed: 'Failed to update learning preference',
      learnEnabled: 'Learning from conversations enabled',
      learnDisabled: 'Learning from conversations disabled',
      learnFromConversationsDesc: 'Automatically save durable facts from your chats in the background. Saying "remember …" in a conversation always saves instantly, even when this is off.',
      learnFromConversationsDescFree: 'Say "remember" to save facts instantly. Background review of your chats is included with Gab AI Plus.',
      learnPlusUpsell: 'Upgrade to Plus for background learning',
      editPlaceholder: 'Enter your memory...',
      characters: 'characters',
      saveChanges: 'Save Changes',
      editMemory: 'Edit Memory',
      deleteMemory: 'Delete Memory',
      autoGenerated: 'Auto-generated',
      sourceAuto: 'Auto-saved',
      sourceDream: 'Learned by Gab AI',
      sourceExplicit: 'Saved by request',
      sourceImport: 'Imported',
      charLimit: 'Memory must be %LIMIT% characters or less',
      memoriesStoredCount: '%COUNT% memories stored',
      deleteConfirmTitle: 'Delete Memory',
      deleteConfirmMessage: 'Are you sure you want to delete this memory? This action cannot be undone.',
    },
    profile: {
      profilePhoto: 'Profile Photo',
      profilePhotoSubtitle: 'Upload a photo to personalize your profile. This will be visible to other users.',
      changePhoto: 'Change photo',
      remove: 'Remove',
      pngOnly: 'PNG only, max 5MB',
      fullName: 'Full Name',
      fullNameSubtitle: 'Your name as it will appear across the platform',
      professionalRole: 'Professional Role',
      professionalRoleSubtitle: 'Select the role that best describes your work',
      saveChanges: 'Save Changes',
      noChanges: 'No changes to save',
      profileUpdated: 'Profile updated successfully',
      profileUpdateFailed: 'Failed to update profile',
      photoAccessDisabled: 'Photo access is disabled. Open Settings to enable access.',
      photoAccessOpening: 'Photo access is disabled. Opening Settings...',
      photoPermissionDenied: 'Permission to access photos was denied',
      fileSizeLimit: 'File size must be less than 5MB',
      pngOnlyError: 'Only PNG files are allowed. Please select a PNG image.',
      failedToLoadImage: 'Failed to load image',
      failedToPickImage: 'Failed to pick image',
    },
    credits: {
      monthly: 'Monthly',
      purchased: 'Purchased',
      neverExpires: 'Never expires',
      autoTopUp: 'Auto Top-Up',
      autoBuyCredits: 'Auto-buy credits when low',
      setUp: 'Set up',
      whenBelow: 'When below',
      purchase: 'Purchase',
      monthlyLimit: 'Monthly limit',
      noLimit: 'No limit',
      setLimit: 'Set limit',
      save: 'Save',
      saved: 'Saved',
      buyCredits: 'Buy Credits',
      autoTopUpEnabled: 'Auto top-up enabled',
      autoTopUpDisabled: 'Auto top-up disabled',
      settingsSaved: 'Settings saved',
      validThreshold: 'Enter a valid threshold',
      limitExceed: 'Monthly spending limit cannot exceed $3,000',
      spentThisMonth: 'spent this month',
      buyToSaveCard: 'Buy credits to save a card for auto top-up',
      failedToUpdate: 'Failed to update',
      failedToSave: 'Failed to save',
      resets: 'Resets',
      credits: 'credits',
      select: 'Select...',
    },
    account: {
      email: 'Email',
      password: 'Password',
      twoFA: '2FA',
      updateEmail: 'Update email',
      updateEmailSubtitle: 'Update your email address',
      changePassword: 'Change Password',
      setPassword: 'Set Password',
      updatePassword: 'Update your password',
      setPasswordSubtitle: 'Create a password to sign in with your email',
      twoFactorTitle: 'Two-Factor Authentication (TOTP)',
      twoFactorSubtitle: 'Add an extra layer of security to your account',
      connectedAccounts: 'Connected Accounts',
    },
    connectedAccounts: {
      title: 'Connected Accounts',
      subtitle: 'Link your social accounts for easier sign-in.',
      connected: 'Connected',
      notConnected: 'Not connected',
      link: 'Link',
      unlink: 'Unlink',
      googleLinked: 'Google account linked successfully.',
      appleLinked: 'Apple account linked successfully.',
      providerUnlinked: '%PROVIDER% account unlinked.',
      cannotUnlinkOnly: 'You cannot unlink your only sign-in method. Add another method first.',
      errors: {
        googleNotAvailable: 'Google sign-in is not available right now.',
        linkFailed: 'Failed to link account. Please try again.',
        unlinkFailed: 'Failed to unlink account. Please try again.',
      },
    },
    help: {
      documentation: 'Documentation',
      documentationSubtitle: 'Guides, tutorials, and API reference',
      getHelp: 'Get Help',
      contactSupport: 'Contact Support',
      contactSupportSubtitle: 'Get help from our team',
      submitFeedback: 'Submit Feedback',
      submitFeedbackSubtitle: 'Share ideas and suggestions',
      legal: 'Legal',
      termsOfService: 'Terms of Service',
      privacyPolicy: 'Privacy Policy',
      termsOfSale: 'Terms of Sale',
      version: 'Version',
    },
    shortcuts: {
      general: 'General',
      deck: 'Deck',
      work: 'Work mode',
      workDescription: 'New Work is available throughout the app. Send, queue, and stop shortcuts apply to the focused Work composer. Send now and Stop require an active run.',
      addNewColumn: 'Add new column',
      removeFocusedColumn: 'Remove focused column',
      focusColumn: 'Focus column 1–9',
      moveColumnLeft: 'Move column left',
      moveColumnRight: 'Move column right',
    },
    referral: {
      referAFriend: 'Refer a Friend',
      shareDescription: 'Share your link with friends. When they sign up and subscribe to Gab AI Plus, you both get %CREDITS% credits!',
      yourReferralLink: 'Your Referral Link',
      loading: 'Loading...',
      copied: 'Copied!',
      copy: 'Copy',
      failedToCopy: 'Failed to copy link',
      failedToLoad: 'Failed to load referral data',
      shareMessage: 'Try Gab AI! Sign up with my link and we both get 250 free credits when you go Plus: %LINK%',
      emailSubject: 'Try Gab AI - All the top AI models in one place',
      yourStats: 'Your Stats',
      successful: 'Successful',
      pending: 'Pending',
      creditsEarned: 'Credits Earned',
      referralHistory: 'Referral History',
      noReferrals: 'No referrals yet. Share your link to get started!',
      referralNumber: 'Referral #%ID%',
      howItWorks: 'How it works',
      step1: 'Share your unique referral link with friends',
      step2: 'They sign up using your link and subscribe to Gab AI Plus',
      step3: 'You both receive %CREDITS% credits — it\'s that simple!',
      maxReferrals: 'Maximum %MAX% referrals allowed per account',
    },
    import: {
      title: 'Import Conversations',
      subtitle: 'Import your conversation history from Gab AI, ChatGPT, Claude, or Grok.',
      fromGabAI: 'From Gab AI:',
      gabAIStep1: '1. On the account you are moving from, go to Settings > Download your data',
      gabAIStep2: '2. Download the ZIP or JSON export when it is ready',
      gabAIStep3: '3. Upload conversations.json from the ZIP, or the full JSON export file',
      fromChatGPT: 'From ChatGPT:',
      chatGPTStep1: '1. Go to chatgpt.com > Settings > Data Controls > Export Data',
      chatGPTStep2: '2. Download the ZIP from your email (may take up to 24 hours to arrive), then unzip it',
      chatGPTStep3: '3. Find the conversations.json file(s) inside — you can select several JSON files at once',
      fromClaude: 'From Claude:',
      claudeStep1: '1. Go to claude.ai > Settings > Account > Export Data',
      claudeStep2: '2. Download the file from your email (may take up to 24 hours to arrive), then unzip it if it\'s a ZIP',
      claudeStep3: '3. Find the JSON file with your conversations inside and upload below',
      fromGrok: 'From Grok:',
      grokStep1: '1. Go to accounts.x.ai/data and sign in to your xAI account',
      grokStep2: '2. Click "Download" under "Download account data" and wait for it to process',
      grokStep3: '3. Download the ZIP file — you can upload the entire ZIP below, or unzip it and find the prod-grok-backend.json file inside (it may be nested in subfolders) and upload that directly',
      uploadNote: 'For Gab AI, upload conversations.json from your account export ZIP or the full JSON export. For ChatGPT and Claude, uploading the JSON file(s) is usually faster than the full ZIP. For Grok, you can upload the full ZIP or prod-grok-backend.json. Large ChatGPT exports may split into several JSON files — select them all in one go.',
      multiSelectHint: 'Tip: On web and most devices you can choose multiple files in the picker (same export, different chunks).',
      selectExportFile: 'Select export file(s)',
      readingFile: 'Reading file...',
      readingFileProgress: 'Reading file %CURRENT% of %TOTAL%...',
      parsingConversations: 'Parsing conversations...',
      parsingFileProgress: 'Parsing file %CURRENT% of %TOTAL%...',
      preparingUpload: 'Preparing upload for large exports…',
      preparingUploadProgress: 'Splitting conversations for upload (%CURRENT% / %TOTAL%)…',
      importingProgress: 'Importing %CURRENT% of %TOTAL% conversations...',
      invalidFileType: 'Please select a ZIP or JSON file from a Gab AI, ChatGPT, Claude, or Grok data export.',
      invalidFileInSelection: '"%NAME%" is not a ZIP or JSON export file. Remove it and try again.',
      invalidJsonInFile: 'Could not read "%NAME%" as JSON. The file may be corrupted or not a conversation export.',
      parseFileFailed: 'Could not understand "%NAME%": %REASON%',
      mixedSourcesError: 'All files in one import must be from the same service (Gab AI, ChatGPT, Claude, or Grok — pick one per import).',
      errorFailedToFetch: 'We could not read this file in the browser. Try again, use the iOS/Android app, or select fewer/large files one at a time.',
      noConversationsFound: 'No conversations with messages found in this file. Make sure this is a data export from Gab AI, ChatGPT, Claude, or Grok.',
      importResults: 'Import Results',
      detectedSource: 'Detected source: %SOURCE%',
      conversationsImported: '%COUNT% conversation(s) imported',
      duplicatesSkipped: '%COUNT% duplicate(s) skipped',
      errorsCount: '%COUNT% error(s)',
      importMore: 'Import More',
      error: 'Error',
      cancel: 'Cancel Import',
      tryAgain: 'Try Again',
      importSuccess: 'Successfully imported %COUNT% conversation(s) from %SOURCE%',
      importOnlyDuplicates: 'Nothing new was imported — remaining chats were already imported or had errors. Check the details below.',
      importFailedNothingImported: 'Import finished but no new conversations were saved. See details below.',
      filesCombined: 'Merged %COUNT% export files in this run',
      unexpectedError: 'An unexpected error occurred during import.',
      importFailed: 'Import failed',
      supportedSources: 'Supported Sources',
      supportedSourcesSubtitle: 'Supports Gab AI account exports and data exports from ChatGPT, Claude, and Grok. For Gab AI, upload conversations.json from your account export ZIP or the full JSON export. For ChatGPT and Claude, upload conversations.json for best results. For Grok, upload the full ZIP or prod-grok-backend.json.',
    },
    personalization: {
      defaultTextModel: 'Default Text Model',
      defaultTextModelSubtitle: 'Choose a model to use by default when you open a new chat',
      chatModeScope: 'Choose the default model for new conversations in Chat mode. This does not apply to Work mode.',
      chooseDefaultModel: 'Choose default model',
      closeModelPicker: 'Done',
      selectedModel: 'Selected model',
      autoSelect: 'Auto (recommended)',
      autoSelectDescription: 'Uses the intent engine to pick the best model',
      intentEngineNotice: 'Choosing any model other than "Auto" will disable Gab AI\'s intent engine and only use the selected text model for all new chats. You will need to manually switch to an image, video, or music model with the model switcher in order to generate media.',
      currentDefault: 'Current',
      searchModels: 'Search models...',
      noResults: 'No models match your search',
      defaultTextModelUpdated: 'Default text model updated',
      defaultTextModelRemoved: 'Default text model reset to Auto',
      failedToSetTextModel: 'Failed to set default text model',
      failedToRemoveTextModel: 'Failed to remove default text model',
    },
    tasks: {
      createTask: 'Create Task',
      createTaskSubtitle: 'Schedule prompts to run automatically on your conversations',
      createNewTask: 'Create New Task',
      yourTasks: 'Your Tasks',
      tasksConfigured: '%COUNT% task(s) configured',
      noTasksYet: 'No tasks yet',
      errorLoadingTasks: 'Error loading tasks. Please try again.',
      noTasksCreated: 'No tasks created yet. Create your first task to automate your AI workflows!',
      deleteTask: 'Delete Task',
      deleteTaskConfirm: 'Are you sure you want to delete this task? This action cannot be undone.',
      deleteTaskSuccess: 'Task deleted successfully',
      deleteTaskFailed: 'Failed to delete task',
    },
    autoTopUp: {
      title: 'Auto Top-Up',
      subtitle: 'Automatically add credits when low',
      noPaymentMethod: 'No saved payment method. Auto top-up requires a saved card. Purchase a credit pack to save your card.',
      enabled: 'Auto top-up enabled',
      disabled: 'Auto top-up disabled',
      failedToToggle: 'Failed to update auto top-up',
      settingsSaved: 'Settings saved',
      failedToUpdate: 'Failed to update setting',
      invalidThreshold: 'Please enter a valid credit threshold',
      limitExceeded: 'Monthly spending limit cannot exceed $3,000',
      invalidAmount: 'Please enter a valid amount',
      whenBelowCredits: 'When credits fall below',
      creditPackToPurchase: 'Credit pack to purchase',
      monthlySpendingLimit: 'Monthly spending limit',
      noLimit: 'No limit',
      setLimit: 'Set Limit',
      save: 'Save',
      saved: 'Saved',
      willCharge: 'Will charge: %CARD% .... %LAST4%',
      spentThisMonth: 'Spent this month',
      lastAutoTopUp: 'Last auto top-up: %DATE% - %CREDITS% credits ($%AMOUNT%)',
      emailNotification: 'You\'ll receive an email notification each time auto top-up is triggered.',
      limitBelowPackPrice: 'Auto top-up can\'t run right now: your monthly limit is below the $%PRICE% pack you chose. Raise it to at least $%LIMIT%, or pick a smaller pack.',
      thresholdAbovePack: 'A %CREDITS%-credit pack can\'t lift you past %THRESHOLD% credits in one top-up, so it would charge again straight away. Lower the trigger or choose a larger pack.',
      viewTermsOfSale: 'View Terms of Sale',
      enableDescription: 'Enable auto top-up to automatically add credits when your balance gets low.',
      configureAutoTopUp: 'Configure Auto Top-Up',
      select: 'Select...',
    },
    profileRoles: {
      product_management: 'Product Management',
      engineering: 'Engineering',
      human_resources: 'Human Resources',
      finance: 'Finance',
      marketing: 'Marketing',
      sales: 'Sales',
      operations: 'Operations',
      data_science: 'Data Science',
      design: 'Design',
      legal: 'Legal',
      other: 'Other',
    },
  },
  feedback: {
    title: "We'd Love to Hear From You",
    subtitle: "Your feedback helps us improve our service and create a better experience for everyone",
    form: {
      name: {
        label: "Your Name",
      },
      email: {
        label: "Your Email",
      },
      message: {
        label: "Message",
      },
      errors: {
        nameRequired: "Please enter your name",
        emailRequired: "Please enter your email",
        messageRequired: "Please enter a message to send.",
        messageTooShort: "Message must be at least 10 characters long.",
        invalidEmail: "Please enter a valid email address",
        captchaRequired: "Please complete the verification to continue.",
      },
      submit: "Send Message",
      submitting: "Sending...",
      success: "Message sent successfully!",
      error: "Failed to send message. Please try again.",
      captchaRequired: "Please verify you are human by completing the captcha.",
      feedbackRequired: "Please enter a message to send.",
      feedbackTooShort: "Message must be at least 10 characters long."
    },
  },
  suggestions: {
    create_image: 'Create image',
    summarize_text: 'Summarize',
    help_write: 'Write',
    analyze_data: 'Analyze',
    make_plan: 'Plan',
    analyze_images: 'Analyze images',
    brainstorm: 'Brainstorm',
    get_advice: 'Advice',
    write_code: 'Code'
  },
  starters: {
    blog_post_internet: 'Write an engaging blog post about internet technology trends',
    workout_plan: 'Design a personalized workout plan for my fitness goals',
    time_travel_story: 'Write a captivating short story about time travel adventures',
    business_proposal: 'Create a compelling business proposal for my startup idea',
    product_description: 'Write persuasive product descriptions that drive customer engagement',
    meal_prep: 'Plan healthy and delicious meals for the entire week',
    marketing_strategy: 'Develop an effective digital marketing strategy for my business',
    cover_letter: 'Write a standout cover letter for my dream job',
    birthday_party: 'Plan an unforgettable birthday party with unique theme ideas',
    content_calendar: 'Create an engaging social media content calendar for marketing',
    explainer_video: 'Write an engaging script for my product explainer video',
    budget_spreadsheet: 'Create a comprehensive monthly budget spreadsheet with smart formulas',
    book_outline: 'Develop a detailed chapter outline for my novel idea',
    social_media_strategy: 'Create an effective social media strategy for brand growth',
    presentation_deck: 'Design an impactful business presentation that captures attention',
    interview_prep: 'Prepare winning answers for common job interview questions',
    garden_planning: 'Design a productive vegetable garden layout for my space',
    fitness_goals: 'Create achievable fitness goals with a monthly progress plan',
    meditation_guide: 'Design a simple daily meditation routine for beginners',
    language_practice: 'Create effective conversation exercises for language learning practice',
    resume_update: 'Transform my resume with powerful achievements and skills',
    event_planning: 'Plan a successful community event with engaging activities',
    business_name: 'Generate unique and memorable names for my business',
    email_template: 'Write professional email templates for business communication',
    podcast_outline: 'Create an engaging outline for my next podcast episode',
    diet_plan: 'Design a balanced weekly meal plan for healthy living',
    home_workout: 'Create an effective home workout without special equipment',
    story_children: 'Write an imaginative bedtime story for young children',
    photo_tips: 'Learn essential photography techniques for stunning travel photos',
    music_playlist: 'Create the perfect playlist for any mood or occasion',
    art_project: 'Design an inspiring art project using everyday materials',
    public_speech: 'Write a powerful speech that captivates your audience',
    productivity_tips: 'Discover practical ways to boost your daily productivity',
    wedding_planning: 'Plan a beautiful wedding ceremony within your budget',
    career_advice: 'Get expert guidance for your next career move',
    home_organization: 'Create an efficient organization system for your entire home',
    pet_care: 'Learn essential care tips for your beloved pet',
    financial_goals: 'Set achievable financial goals with a clear action plan',
    coding_project: 'Start a beginner-friendly coding project with step-by-step guidance',
    mindfulness_routine: 'Build a mindful daily routine for better mental health',
    fashion_advice: 'Get personalized fashion tips for your body type',
    zero_waste: 'Create an actionable plan for a zero-waste lifestyle',
    book_club: 'Start an engaging book club with monthly themes',
    family_activities: 'Plan fun and educational activities for the whole family',
    self_improvement: 'Develop a personalized plan for continuous self-improvement',
    knowledge_test_prep: 'Create practice questions about ancient civilizations and history',
    python_script_automation: 'Write a Python script to automate daily tasks',
    wedding_plus_one: 'Craft a thoughtful message inviting a wedding plus-one',
    plan_nashville_trip: 'Plan an unforgettable music festival weekend in Nashville',
    analyze_research_paper: 'Help me understand and summarize a complex scientific research paper',
    personal_brand_strategy: 'Create a comprehensive personal branding strategy for my professional career',
    learn_programming_path: 'Design a structured learning path for becoming a full-stack developer',
    sustainability_home_tips: 'Suggest practical ways to make my home more environmentally sustainable',
    book_recommendation: 'Recommend books based on my favorite genres and recent reading history',
    travel_photography_guide: 'Create a detailed guide for taking better travel photos with my phone',
    healthy_meal_substitutes: 'Find healthy alternatives for my favorite comfort food ingredients',
    interview_questions: 'Generate thoughtful questions to ask at the end of a job interview',
    data_visualization: 'Help me create effective visualizations for my business presentation data',
    creative_writing_prompt: 'Generate a unique writing prompt combining three random genres or themes',
    home_office_setup: 'Design an ergonomic and productive home office setup within my budget',
    startup_pitch: 'Help me write a compelling pitch deck for my startup idea',
    business_plan_financial: 'Create a detailed financial projection for my business plan',
    customer_survey: 'Design an effective customer feedback survey for my product',
    sales_strategy: 'Develop a B2B sales strategy for my enterprise software product',
    investor_presentation: 'Create an investor presentation highlighting our growth metrics',
    academic_research: 'Help me structure my thesis and develop research questions',
    study_schedule: 'Create a study schedule for my upcoming final exams',
    literature_review: 'Help me organize and summarize academic papers for my research',
    grant_proposal: 'Write a compelling grant proposal for my research project',
    team_building: 'Design team building activities for a remote software development team',
    hiring_strategy: 'Develop interview questions and hiring criteria for senior roles',
    process_optimization: 'Identify ways to optimize our customer service workflow',
    risk_assessment: 'Create a risk assessment matrix for my business project',
    expansion_strategy: 'Develop a market expansion strategy for entering Asian markets',
    board_presentation: 'Help me prepare a quarterly board meeting presentation',
    improve_english_grammar: 'Master essential English grammar rules through practical exercises',
    morning_routing: 'Create a morning routing plan to boost productivity',
  },
  share: {
    title: 'Share public link to chat',
    shareLink: 'Share Link',
    makePublic: {
      title: 'Make chat public',
      description: 'Anyone with the link can view this chat without signing in'
    }
  },
  customAgent: {
    title: 'Create Custom Bot',
    titleEdit: 'Edit Bot',
    archiveWarning: 'This removes the bot from your list. Existing chats are kept.',
    avatar: {
      error: 'Avatar must be a PNG or JPG file',
      helper: 'PNG or JPG. Max file size: 5MB',
      fileSizeError: 'File size must be less than 5MB',
      pickError: 'Failed to pick image'
    },
    type: {
      label: 'Type',
      text: 'Text',
      imageGeneration: 'Image Generation'
    },
    name: {
      label: 'Bot name',
      placeholder: 'e.g. Code Reviewer, Brand Strategist, Sermon Helper'
    },
    description: {
      label: "What's its job?",
      placeholder: 'e.g. Review code, explain trade-offs, and suggest fixes.'
    },
    systemPrompt: {
      label: 'How should it work?',
      subtitle: 'Set its approach, tone, and rules. Add the context it needs and describe a useful result.',
      placeholder: 'You are a travel assistant. Provide travel recommendations for destinations, hotels, and activities in a friendly and informative manner.'
    },
    stylePrompt: {
      label: 'Style Prompt',
      subtitle: 'Guide your bot on the artistic style and specific elements to incorporate when generating images. The style prompt should be worded as a description of the desired image, not as an instruction to the bot.',
      placeholder: 'e.g. Blurry brushstrokes, pastel colors'
    },
    conversationStarters: {
      label: 'Conversation Starters',
      subtitle: 'Add quick prompts that users can click to start a conversation with your bot. Maximum 4 starters.',
      placeholder: 'Enter a conversation starter prompt',
      addButton: 'Add starter',
    },
    errors: {
      createFailed: 'Failed to create bot',
      archiveFailed: 'Failed to delete bot',
      nameRequired: 'Bot name is required',
      descriptionRequired: 'A job description is required',
      systemRequired: 'Instructions are required'
    },
    deleteConfirmTitle: 'Delete bot?',
    toasts: {
      createSuccess: 'Bot created successfully',
      updateSuccess: 'Bot updated successfully',
      deleteSuccess: 'Bot deleted successfully'
    },
    shareUrl: {
      label: 'Shareable link',
      subtitle: 'Direct chat URL for this bot. Copy it into bookmarks or a registry. Private bots only open for you.',
    },
  },
  customInstructions: {
    title: 'Custom Instructions',
    description: 'Add custom instructions for Gab AI when working with files in %COLLECTION%. These instructions will be included in every chat that references files from this collection.',
    placeholder: 'Example: Focus on code quality and best practices. Highlight potential security issues.',
    saveButton: 'Save Instructions'
  },
  collectionSettings: {
    chip: 'Chat defaults',
    title: 'Collection settings',
    description: 'Instructions and memory apply to Chat and Work. Chat defaults only apply when you start a new chat — not Work.',
    instructionsDescription: 'Included in every chat and Work thread in this collection.',
    memoryDescription: 'Use your saved memories in Chat and Work in this collection.',
    chatDefaultsTitle: 'Chat defaults',
    chatDefaultsDescription: 'Pre-applied when you start a new chat here. Work ignores these — it picks its own models and tools.',
    modelTitle: 'Default model',
    modelDescription: 'The model new chats in this collection start with.',
    autoSelect: 'Auto',
    selectedModel: 'Selected model',
    lockedSettingsTitle: 'Locked settings',
    lockedSettingsDescription: 'Default parameters applied whenever this model is used.',
    webSearchTitle: 'Web search',
    webSearchDescription: 'Turn web search on by default for new chats here.',
    saveButton: 'Save',
    saved: 'Collection settings saved',
    saveFailed: 'Failed to save collection settings',
  },
  media: {
    saveToPhotos: 'Save to Photos',
    savedToPhotos: 'Saved to Photos',
    share: 'Share',
    downloading: 'Downloading...',
    downloadFailed: 'Download failed',
    downloadComplete: 'Download complete',
    saveFailed: 'Failed to save to Photos',
  },
  chatDetails: {
    searchPlaceholder: 'Search messages',
    details: 'Details',
    photos: 'Photos',
    videos: 'Videos',
    audio: 'Audio',
    links: 'Links',
    files: 'Files',
    savedMessages: 'Saved Messages',
    media: 'Media',
    information: 'Information',
    created: 'Created',
    messages: 'Messages',
    modelsUsed: 'Models used',
    noMessagesFound: 'No messages found',
    noPhotosFound: 'No photos found',
    noVideosFound: 'No videos found',
    noAudioFound: 'No audio found',
    noFilesFound: 'No files found',
    noLinksFound: 'No links found',
    noSavedMessagesFound: 'No saved messages found',
    externalLink: 'External Link',
    externalLinkMessage: 'You are about to visit an external website. Please be careful with links from unknown sources.',
    openLink: 'Open Link',
    nonTextMessage: '[Non-text message]',
  },
  cards: {
    bookmark: 'Bookmark',
    bookmarked: 'Saved',
    saveImage: 'Image',
    preparingImage: 'Preparing…',
  },
  messages: {
    copied: 'Message copied to clipboard',
    copyFailed: 'Failed to copy message',
    unsaved: 'Message unsaved',
    saved: 'Message saved',
    queuedOffline: "Will send when you're back online",
    queuedWorkFollowUp: 'Queued — sends after this task finishes',
    addToFolder: 'Add to Folder',
    viewBookmarks: 'View Bookmarks',
    bookmarkUpdateFailed: 'Failed to update bookmark',
    markedPreferred: 'Response marked as preferred',
    markPreferredFailed: 'Failed to mark response as preferred',
    responseRejected: 'Response rejected',
    rejectFailed: 'Failed to reject response',
    exported: 'Message exported',
    exportFailed: 'Failed to export message',
    exportDialogTitle: 'Export Message',
    modelResponses: '%COUNT% model responses',
    collapseAll: 'Collapse All',
    expandAll: 'Expand All',
    showMore: 'Show more',
    showLess: 'Show less',
    connectionError: 'Please check your internet connection and try again.',
    regenerateWithPlus: 'Regenerate Messages with Plus',
    bookmarkFailed: 'Failed to update bookmark',
    waitForSending: 'Please wait for the message to finish sending',
    deleteTitle: 'Delete Message',
    deleteMessage: 'Are you sure you want to delete this message? This cannot be undone.',
    deleted: 'Message deleted',
    deleteFailed: 'Failed to delete message',
    forkedSideBySide: 'Fork opened beside the original',
    forkWorkspaceUnavailable: 'Could not create a side-by-side workspace; opening the fork as a chat',
    forkFailed: 'Failed to fork conversation',
    cannotExportExpiredImage: 'Cannot export expired image',
    cannotExportExpiredFile: 'Cannot export expired file',
    noDownloadableImage: 'No downloadable image found',
    imageDownloaded: 'Image downloaded',
    imageDownloadFailed: 'Image download failed',
    noDownloadableFile: 'No downloadable file found',
    fileDownloaded: 'File downloaded',
    fileDownloadFailed: 'File download failed',
    creatingPdf: 'Creating your document…',
    creatingPresentation: 'Preparing your presentation…',
    creatingSpreadsheet: 'Building your spreadsheet…',
    noPriorContentForPdf: "I'd be happy to make a PDF for you. Ask me something first, and then I'll convert my answer into one for you.",
    exportedAsText: 'Message exported as text',
    responsePreferred: 'Response marked as preferred',
    responsePreferredFailed: 'Failed to mark response as preferred',
    responseRejected: 'Response rejected',
    responseRejectFailed: 'Failed to reject response',
    accessibilityLabel: 'message from',
    accessibilityLabelError: 'Error message',
    // Shown on responses only while an editor is open beside the chat.
    addToEditor: {
      addToDocument: 'Add text to document',
      addToSpreadsheet: 'Add text to spreadsheet',
      addToPresentation: 'Add text to presentation',
      // Desktop-web overflow menu: create/open an editor from a reply.
      openInDocument: 'Add to document',
      openInSpreadsheet: 'Add to spreadsheet',
      addedToDocument: 'Added to document',
      addedToSpreadsheet: 'Added to spreadsheet',
      addedToPresentation: 'Added to presentation',
      openedDocument: 'Opened in document editor',
      openedSpreadsheet: 'Opened in spreadsheet editor',
      addedFallback: 'Added to editor',
      empty: 'Nothing to add',
      emptyTable: 'No table found in this message',
      desktopOnly: 'Editors are available on desktop web',
      openFailed: 'Could not open the editor',
    },
    actions: {
      viewPrompt: 'View prompt',
      viewModelDetails: 'View model details',
      viewAllModelsBy: 'View all models by %NAME%',
      startNewChatModel: 'Start a new chat with this model',
      viewAllAgents: 'View all bots',
      startNewChat: 'Start a new chat',
      exportDownload: 'Export / Download',
      plainText: 'Plain text',
      regenerate: 'Regenerate',
      tryAgain: 'Try again',
      addDetails: 'Add details',
      moreConcise: 'More concise',
      more: 'More',
      moreActions: 'More actions',
      copy: 'Copy',
      share: 'Share',
      edit: 'Edit',
      fork: 'Branch chat',
      forkSideBySide: 'Open branch side by side',
      forkNewChat: 'Branch in new chat',
      bookmark: 'Bookmark',
      removeBookmark: 'Remove bookmark',
      feedback: 'Feedback',
      download: 'Download',
      report: 'Report',
      delete: 'Delete',
      details: 'Details',
      back: 'Back',
      duration: 'Duration: %VALUE%',
      totalCreditCost: 'Total credit cost: %VALUE%',
      runByTask: 'Run by Task',
      refunded: 'Refunded',
      parameters: 'Parameters',
      models: 'Models',
      noDetailsAvailable: 'No details available',
      preferResponse: 'I prefer this response',
      rejectResponse: 'I don\'t like this response',
      model: 'Model',
      agent: 'Bot',
      speak: 'Read aloud',
    },
    speak: {
      title: 'Play response',
      generating: 'Generating audio…',
      generatingRest: 'Playing now while the rest generates…',
      generatingRestProgress: 'Playing now · %READY% of %TOTAL% parts ready',
      failed: 'Failed to generate speech. Please try again.',
      cancelled: 'Speech generation was cancelled. Please try again.',
      timeout: 'Generation timed out. Please try again.',
      providerFailed: 'The speech provider had a temporary problem. Please try again.',
      empty: 'This message has no text to speak.',
      retry: 'Try again',
      download: 'Download full audio',
      downloading: 'Downloading…',
      downloaded: 'Full audio downloaded',
      downloadFailed: 'Failed to download full audio',
      creditsCharged: '%COUNT% credits used',
      cacheHit: 'Loaded from cache · no new generation charge',
      outOfCreditsTitle: 'Not enough credits',
      outOfCreditsSubtitle: 'Speaking a response uses the standard text-to-speech credit cost.',
      plusRequiredTitle: 'Plus required',
      plusRequiredSubtitle: 'Text-to-speech requires Gab AI Plus.',
    },
    memorySuggestion: {
      title: 'Memory Suggestion',
      updateExisting: 'Update Existing',
      highConfidence: 'High confidence',
      mediumConfidence: 'Medium confidence',
      lowConfidence: 'Low confidence',
      whatIsThis: 'What is this?',
      currentMemory: 'Current Memory:',
      updatedMemory: 'Updated Memory:',
      mergedMemory: 'Merged Memory:',
      editPlaceholder: 'Edit memory content...',
      updatePrompt: 'Would you like to update this memory? The AI will use the updated information across all conversations.',
      updatePromptWithOptions: 'This suggestion is similar to an existing memory. You can replace it (Update), combine both (Merge), or keep them as separate memories (Add as New).',
      savePrompt: 'Would you like to save this as a memory? The AI will remember this across all conversations.',
      edit: 'Edit',
      dismiss: 'Dismiss',
      updateMemory: 'Update Memory',
      saveMemory: 'Save Memory',
      mergeMemory: 'Merge',
      addAsNew: 'Add as New',
      emptyError: 'Memory content cannot be empty',
      charLimitError: 'Memory must be %LIMIT% characters or less',
      updatedSuccess: 'Memory updated successfully',
      savedSuccess: 'Memory saved successfully',
      mergedSuccess: 'Memories merged successfully',
      expiredError: 'This suggestion has expired. Please try again with a new suggestion.',
      updateFailed: 'Failed to update memory',
      saveFailed: 'Failed to save memory',
      mergeFailed: 'Failed to merge memory',
      dismissed: 'Memory suggestion dismissed',
      dismissFailed: 'Failed to dismiss suggestion',
    },
    imageToolSuggestion: {
      title: 'Try these image tools',
    },
    workModeSuggestion: {
      choiceSubtitle: 'This task would get better results using Work mode. Would you like to send the request to the work agent or continue in normal chat?',
      continueChat: 'Get a faster answer with quick chat',
      title: 'This task would be better in Work mode',
      subtitle: 'Send this prompt to a Work agent for a potentially better outcome — it can keep going across files, research, and multi-step work.',
      send: 'Send to Work mode',
      sending: 'Starting Work…',
      plusSubtitle: 'Work mode can handle files, media, and multi-step jobs. Upgrade to Plus to unlock it.',
      plusSend: 'Upgrade to Plus',
    },
    mediaModelSuggestion: {
      title: 'Try with another model',
      toolsSecondaryTitle: 'Or try these image tools',
      tryModel: 'Try %NAME%',
    },
    creditsDepleted: {
      outOfCredits: 'You\'re out of credits',
      notEnoughCredits: 'Not enough credits',
      balanceEmpty: 'Your credit balance is empty',
      needMoreCredits: 'You have %COUNT% credit%S%, but this request requires more',
      yourMessage: 'Your message',
      chooseAPack: 'Choose a credit pack:',
      credits: 'credits',
      popular: 'Popular',
      bestValue: 'Best Value',
      seeAllOptions: 'See all options',
      or: 'OR',
      upgradePlus: 'Upgrade to Plus',
      freeDefaultMessages: 'Free default model messages (not included in API)',
      monthlyCredits: `${PLUS_MONTHLY_CREDITS_DISPLAY} monthly credits included`,
      memoryPersonalization: 'Memory & personalization',
      whatAreCredits: 'What are credits?',
      upgradeTitle: 'Upgrade to Plus',
      upgradeSubtitle: `Get ${PLUS_MONTHLY_CREDITS_DISPLAY} monthly credits and free default model messages in the app (not included in API).`,
      purchaseError: 'Purchase Error',
      purchaseErrorMsg: 'Failed to purchase credit pack. Please try again.',
    },
    cardExpiration: {
      expired: 'Your card has expired',
      expiredSubtitle: 'Update your payment method to continue using premium features without interruption.',
      expiresTomorrow: 'Your card expires tomorrow',
      expiresTomorrowSubtitle: 'Update your payment method to avoid any service interruption.',
      expiresInDays: 'Your card expires in %DAYS% days',
      expiresInDaysSubtitleUrgent: 'Update your payment method soon to avoid any service interruption.',
      expiresInDaysSubtitle: 'Consider updating your payment method to ensure uninterrupted service.',
      expiringSoon: 'Your card is expiring soon',
      expiringSoonSubtitle: 'Update your payment method to continue using premium features.',
      remindMeLater: 'Remind me later',
      updatePayment: 'Update Payment',
      exp: 'Exp: %DATE%',
    },
    moderation: {
      cantHelp: 'I can\'t help with that request.',
      unableToProcess: 'Unable to process request',
      couldNotComplete: 'This message could not be completed',
    },
    buttons: {
      verificationSent: 'Verification email sent successfully. If you don\'t see it, check your spam folder or email us at ai@gab.com.',
      actionFailed: 'Action failed',
    },
  },
  sidebar: {
    accountMenu: 'Account menu',
    upgradePlan: 'Upgrade plan',
    personalization: 'Personalization',
    help: 'Help',
    logOut: 'Log out',
    settings: 'Settings',
    newChat: 'New chat',
    newCollection: 'New collection',
    newAgent: 'New bot',
    shortcuts: 'Shortcuts',
    tryPlus: 'Try Plus',
    upgradeSubtitle: 'Upgrade for higher limits, smarter AI, and more features.',
    learnMore: 'Learn More',
    dontLoseProgress: "Don't Lose Your Progress",
    createAccountPrompt: 'Create an account to make sure your chats are always here when you come back.',
    signInToSaveWork: 'Sign in to use your library',
    signInToSaveWorkBody: 'Create a free account to save files, bookmarks, memory, and generated media. You need an account before you can upgrade or buy credits.',
    signInToSearchChatsSubtitle: 'Sign in to search your chats, files, and saved items.',
    signInForSettings: 'Sign in to manage settings',
    signInForSettingsSubtitle: 'Create an account to customize your experience, theme, and preferences.',
    signInToStartChat: 'Sign in to start a new chat',
    signInToStartChatSubtitle: 'Create a free account so we can save your conversation and history across devices.',
    signUpOrLogIn: 'Sign Up or Log In',
    logIn: 'Log in',
    connectEmail: 'Connect your email',
    accessFeatures: 'Access all features of Gab AI.',
    alreadyHaveAccount: 'Already have an account? Log in',
    outOfCredits: 'Out of credits',
    outOfCreditsMessage: "You've used all your free credits. Sign up for a free account to get more.",
    getFreeMessages: 'Get Free Messages',
    upgradeOrBuy: 'Upgrade to Plus or buy more credits to continue.',
    runningLow: 'Running low!',
    buyCredits: 'Buy Credits',
    upgradeNow: 'Upgrade Now',
    filters: 'Filters',
    actions: 'Actions',
    doneSelecting: 'Done selecting',
    selectMultiple: 'Select multiple',
    sort: 'Sort',
    selected: 'selected',
    addToCollection: 'Add to collection',
    noCollections: 'No collections',
    done: 'Done',
    viewCollection: 'View Collection',
  },
  collections: {
    rename: {
      title: 'Rename Collection',
      subtitle: 'Enter a new name for this collection',
      placeholder: 'Collection name',
      error: 'Failed to rename collection',
    },
    delete: {
      message: 'This will permanently delete all collection chats. To save chats, move them to your chat list or another collection before deleting.',
      error: 'Failed to delete collection',
    },
    iconUpdated: 'Collection icon updated',
    iconUpdateError: 'Failed to update icon',
    defaultName: 'Collection',
    suggestion: {
      prompt: 'Move this chat to %TITLE%?',
      move: 'Move',
      dismiss: 'No thanks',
      moved: 'Chat moved to %TITLE%',
      moveFailed: 'Failed to move chat to collection',
    },
  },
  tasks: {
    createScheduledTask: 'Create scheduled task',
    attachedBot: 'Bot: %NAME%',
    attachedChat: 'Chat: %NAME%',
    untitledWorkChat: 'Untitled Work chat',
    aiModel: 'AI model',
    aiModelDescription: 'The model that plans and orchestrates this task.',
    workChatAiModel: 'This task uses the AI model of its Work chat.',
    failedToLoadModels: 'Could not load AI models. Retry',
    editAiModel: 'Edit AI model',
    botOptional: 'Bot (optional)',
    botOptionalDescription: 'Choose a bot to run this task using its saved instructions.',
    noBot: 'No bot',
    failedToLoadBots: 'Could not load your bots. You can retry or continue without one.',
    runsWithBot: 'Runs with %NAME% using this bot’s saved instructions.',
    selectedBot: 'the selected bot',
    once: 'Once',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    enabled: 'Task enabled',
    paused: 'Task paused',
    updateFailed: 'Failed to update task',
    started: 'Task started! Results will appear in a new conversation.',
    runFailed: 'Failed to run task',
    enabledStatus: 'Enabled',
    pausedStatus: 'Paused',
    runsInWorkChatDescription: 'Each run is delivered inside the Work chat',
    runsInColon: 'Runs in: ',
    thisWorkChat: 'this Work chat',
    runsInWorkChat: 'Runs in Work chat',
    manageWorkChatTasks: 'Manage tasks',
    untitled: 'Untitled Task',
    email: 'Email',
    running: 'Running...',
    runNow: 'Run Now',
    results: 'Results',
    stepConfigure: 'Configure',
    stepSchedule: 'Schedule',
    stepReview: 'Review',
    createTitle: 'Create Task',
    editTitle: 'Edit Task',
    setScheduleTitle: 'Set Schedule',
    emailDeliveryTitle: 'Email Delivery',
    reviewCreateTitle: 'Review & Create',
    taskCreatedBanner: 'Task Created!',
    setUpTaskTitle: 'Set Up Task',
    configureTaskTitle: 'Configure Task',
    configureYourTask: 'Configure Your Task',
    configureDescription: 'Set up the basic details for your automated task.',
    taskName: 'Task Name',
    taskNamePlaceholder: 'Give your task a clear, descriptive name',
    instructionsLabel: 'Instructions',
    instructionsPlaceholder: 'Describe what this task should do when it runs',
    taskInstructions: 'Task instructions',
    taskNameInput: 'Task name',
    whenShouldRun: 'When should this run?',
    whenShouldRunDesc: 'Pick a rhythm. Gab will take it from here.',
    stepNavigationLabel: 'Step %STEP% of %TOTAL%: %LABEL%',
    scheduleTimezone: 'Your time zone: %TIMEZONE%',
    chooseDateAndTime: 'Choose a date and time for your one-time task.',
    chooseScheduleDetails: 'Choose the details below to complete your schedule.',
    onceSchedulePreview: 'Runs once on %DATE%',
    dailySchedulePreview: 'Every day at %TIME%',
    weeklySchedulePreview: 'Every %DAY% at %TIME%',
    monthlySchedulePreview: 'Monthly on the %DAY% at %TIME%',
    selectFutureDateTime: 'Choose a date and time in the future.',
    selectValidDateTime: 'Choose a valid date and time in your time zone.',
    editSection: 'Edit',
    editInstructions: 'Edit task instructions',
    editSchedule: 'Edit task schedule',
    editEmail: 'Edit email delivery',
    runOneTimeOnly: 'Run one time only',
    runEveryDay: 'Run every day',
    runOnceAWeek: 'Run once a week',
    runOnceAMonth: 'Run once a month',
    dateLabel: 'Date',
    dayOfWeek: 'Day of Week',
    dayOfMonth: 'Day of Month',
    timeLabel: 'Time',
    selectDay: 'Select day',
    selectTime: 'Select time',
    emailDeliveryDesc: 'Get task results delivered directly to your inbox.',
    sendResultsToEmail: 'Send results to my email',
    receiveSummary: 'Receive a summary when the task completes',
    whenReceiveEmail: 'When should I receive the email?',
    morningOption: 'Morning (7 AM)',
    afternoonOption: 'Afternoon (12 PM)',
    eveningOption: 'Evening (6 PM)',
    immediatelyOption: 'Immediately',
    immediatelyAfterOption: 'Immediately after task runs',
    nameMin3Chars: 'Task name must be at least 3 characters',
    instructionsRequired: 'Instructions are required',
    selectDateForTask: 'Please select a date for your task',
    selectTimeForTask: 'Please select a time for your task',
    selectDayAndTime: 'Please select a day and time for your task',
    updatedSuccess: 'Task updated successfully',
    createdSuccess: 'Task created successfully',
    createdSuccessExclaim: 'Task created successfully!',
    failedToSave: 'Failed to save task',
    failedToCreate: 'Failed to create task',
    taskStatistics: 'Task Statistics',
    totalRuns: 'Total Runs',
    successful: 'Successful',
    failedLabel: 'Failed',
    lastRunLabel: 'Last run:',
    viewResults: 'View Results',
    testYourTask: 'Test Your Task',
    testDescription: 'Run this task immediately to test it. Results will appear in a new conversation.',
    dangerZone: 'Danger Zone',
    deleteTaskDesc: 'Deleting this task will stop all future scheduled runs. This action cannot be undone.',
    deleteTask: 'Delete Task',
    reviewYourTask: 'Review Your Task',
    reviewDescription: 'Make sure everything looks correct before creating.',
    reviewDescTemplate: 'Make sure everything looks correct before creating your task.',
    taskSummary: 'Task Summary',
    scheduleColon: 'Schedule: ',
    emailColon: 'Email: ',
    disabledValue: 'Disabled',
    back: 'Back',
    continueBtn: 'Continue',
    updateTaskBtn: 'Update Task',
    infoResultsAppear: 'Results will also appear in your chat conversations. Each run creates a new message in the selected conversation.',
    infoResultsTemplate: 'Results will also appear in your chat conversations. Each run creates a new conversation with a dated title.',
    emailMeResults: 'Email me the results',
    taskNameOptional: 'Task Name (optional)',
    enterCustomName: 'Enter a custom name',
    neverRan: 'Never',
    justNow: 'Just now',
    customizeYourTask: 'Customize Your Task',
    customizeDesc: 'Configure the options below to personalize how this task works for you.',
    howOftenRun: 'How often should this run?',
    howOftenRunDesc: 'Choose when you want this task to automatically run.',
    viewMyTasks: 'View My Tasks',
    setUpAnother: 'Set Up Another',
    taskCreatedSuccessTitle: 'Task Created Successfully!',
    loadingTaskTitle: 'Loading task...',
    errorTitle: 'Error',
    taskNotFound: 'Task not found',
    failedToLoadTask: 'Failed to load task',
    fieldRequired: 'is required',
    eachRunCreatesConversation: 'Each run creates a new conversation you can find in your chat history.',
    scheduleDisplay: 'Schedule',
    taskTemplatesTitle: 'Task templates',
    taskTemplate: 'Task template',
    setUpThisTask: 'Set up this task',
    uses: 'uses',
    whatsTaskTemplateTitle: "What's a task template?",
    whatsTaskTemplateBody:
      'Task templates are ready-made schedules you can add in one step. Gab runs them on your cadence and keeps everything in your task list.',
    relatedTemplates: 'Related templates',
    loadingTemplate: 'Loading template…',
    templateNotFound: 'Template not found',
    templateRemovedUnavailable:
      'This template may have been removed or is unavailable.',
    browseTemplates: 'Browse templates',
    allTaskTemplates: 'All task templates',
    howItRuns: 'How it runs',
    defaultSchedule: 'Default schedule',
    scheduleDetailsWhenSetup:
      'Schedule details appear when you set up this task.',
    whatYouConfigure: 'What you configure',
    aboutThisTemplate: 'About this template',
    aboutThisTemplateFallback:
      'Enable this template to add it to your tasks with the recommended schedule. You can adjust timing and inputs before saving.',
    readyToAutomate: 'Ready to automate this?',
    oneTapAddsDescription:
      'One tap adds it to your list with the default schedule.',
    setUpShort: 'Set up',
    missingTemplate: 'Missing template',
    templateMetaDescriptionFallback:
      'Browse recurring task templates you can enable in one tap.',
    scheduleIt: 'Schedule it',
  },
  upgrade: {
    title: 'Unlock Work mode with Plus',
    subtitle: 'Give Gab a goal and let its AI agents plan, research, use tools, and deliver finished work.',
    button: 'Upgrade Now',
  },
  // Shared "you're out of credits" choices for Plus / Plus Premium subscribers.
  plusOutOfCredits: {
    refreshOn: 'Your %TOTAL% monthly credits refresh on %DATE% (in %DAYS% days).',
    refreshTomorrow: 'Your %TOTAL% monthly credits refresh tomorrow, %DATE%.',
    refreshToday: 'Your %TOTAL% monthly credits refresh today.',
    refreshOnRenewal: 'Your %TOTAL% monthly credits refresh on your next renewal date.',
    aryaTitle: 'Keep chatting with Arya',
    aryaSubtitle: 'Arya, our default model, never uses credits. Chat as much as you like until your credits refresh.',
    freeBadge: 'FREE',
    chatWithArya: 'Chat with Arya',
    buyTitle: 'Buy more credits',
    topUpOnce: 'A little more for this project',
    topUpOnceSubtitle: 'One-time payment. Credits never expire.',
    explorePremium: 'Explore Plus Premium',
    refreshShort: '%TOTAL% plan credits refresh on %DATE%.',
    buySubtitle: 'Purchased credits never expire and stack on top of your monthly allotment.',
    checkoutError: 'Checkout couldn’t open. Please try again, or choose another credit pack.',
    aryaWorkAlternative: 'Everyday chats with Arya are still included',
    premiumMonthlySubtitle: '%CREDITS% credits each month — 6× Plus. $%PRICE%/month, billed monthly.',
    buyCredits: 'Buy credits',
    seeAllPacks: 'See all credit packs',
    premiumTitle: 'Upgrade to Plus Premium',
    premiumSubtitle: '%CREDITS% credits every month (6× more) for $%PRICE%/mo billed annually.',
    upgradePremium: 'Upgrade to Plus Premium',
    premiumFootnote: 'You\'re on Plus Premium, our highest tier. Top up now or pick up where you left off when your credits refresh.',
    // Short banner / inline copy
    bannerOutOfCredits: 'You\'re out of credits until %DATE%.',
    bannerOutOfCreditsNoDate: 'You\'re out of credits for this month.',
    bannerChatArya: 'Chat with Arya free',
    bannerSeeOptions: 'See options',
    modalTitlePlus: 'Keep creating with Gab AI',
    modalSubtitlePlus: 'Add credits now, or make room for more every month.',
    inlineTitle: 'You\'ve used this month\'s credits',
    inlineSubtitle: 'Pick how you\'d like to continue',
    inlineNotEnough: 'You have %COUNT% credit%S% left, but this request needs more',
  },
  work: {
    launchFailed: 'Failed to start work',
    unavailable: 'Work mode is currently unavailable. It will be back soon.',
    outOfCredits: {
      title: 'Out of credits',
      titlePlus: 'Keep your project moving',
      subtitle: 'Work mode is included with Plus and runs on credits. Upgrade to continue this task with monthly credits.',
      subtitlePlus: 'Add credits for this project, or get more every month with Plus Premium. Your chats and files stay right here.',
      subtitlePremium: 'Add credits to keep creating with Work. Your chats and files stay right here.',
    },
    plusRequired: {
      title: 'Put your ideas to Work',
      subtitle: 'Describe what you need. With Plus, your AI researches, creates and delivers work you can use.',
    },
  },
  lightbox: {
    discardTitle: 'Discard inpainting changes?',
    discardMessage: 'You have unsaved inpainting edits. Closing will discard them.',
    discardButton: 'Discard',
    discardSwitchMessage: 'You have unsaved inpainting edits. Switch image and discard changes?',
    discardCloseMessage: 'You have unsaved inpainting edits. Close and discard changes?',
    keepEditing: 'Keep Editing',
    deleteNotFound: 'Cannot delete: file not found',
    imageDeleted: 'Image deleted',
    deleteImageFailed: 'Failed to delete image',
    deleteImageConfirm: 'Are you sure you want to delete this image?',
    deleteImage: 'Delete Image',
    untitled: 'Untitled',
    trackRenamed: 'Track renamed successfully',
    trackRenameFailed: 'Failed to rename track',
    maskDownloaded: 'Mask downloaded',
    maskCopied: 'Mask copied to clipboard',
    maskFailed: 'Failed to create mask',
    connectionError: 'Please check your internet connection and try again.',
    noConversation: 'No conversation selected.',
    captureMaskFailed: 'Failed to capture mask',
    close: 'Close',
    editSelection: 'Edit selection',
    downloadVideo: 'Download video',
    downloadAudio: 'Download audio',
    downloadImage: 'Download image',
    downloadModel: 'Download 3D model',
    inpaintingTool: 'Inpainting tool',
    viewInChat: 'View in chat',
    feedbackButton: 'Feedback',
    undo: 'Undo',
    redo: 'Redo',
    switchToBrush: 'Switch to brush',
    switchToEraser: 'Switch to eraser',
    exitInpainting: 'Exit inpainting',
    saveInpainting: 'Save inpainting',
    describeEdits: 'Describe your edits...',
    describeChanges: 'Describe what you want to add, remove or replace...',
    renameTrack: 'Rename Track',
    trackName: 'Track name',
    saveToFiles: 'Save to Files',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
  },
  store: {
    selectLimit: 'You can select up to 20 chats',
    voiceConversation: 'Voice Conversation',
    unableToVerifyFile: 'Unable to verify file type. Please refresh the page and try again.',
    uploadError: 'Error, please try uploading again.',
    needCreditsForUpload: 'You need credits to upload files. Please purchase credits to continue.',
  },
  socket: {
    memorySaved: 'Memory saved:',
    memoryUpdated: 'Memory updated:',
    memoryDeleted: 'Memory deleted:',
    memoryCapReached: "Couldn't save — your memory is full. Delete a few memories to make room.",
    memoryAlreadySaved: 'Already in your memories — nothing new to save.',
    memorySaveThrottled: "You're saving memories very quickly. Try again in a minute.",
    memoryNothingToSave: "Couldn't find anything specific to save. Try telling me what to remember.",
    memoryTemporaryChat: "Temporary chats don't save memories. Save this chat first if you want me to remember that.",
    memoryCollectionOff: "Memory is turned off for this collection, so nothing was saved. Turn it on in the collection's settings.",
    memorySaveFailed: "Couldn't save that to memory. Please try again.",
    undo: 'Undo',
    viewMemories: 'View memories',
    fileProcessFailed: 'Failed to process',
    fastModeError: 'Failed to toggle fast mode',
    referralCredit: 'Referral bonus! You earned',
    referralCreditSuffix: 'credits.',
    waitForUploads: 'Please wait for all files to finish uploading before sending your message.',
    messageProcessing: 'You have a message already processing. Please wait...',
    fastModeNotConnected: 'Unable to toggle fast mode - not connected',
    messageQueuedOffline: "You're offline — the message will send when you're back online.",
  },
  settingsMobile: {
    settings: 'Settings',
    account: 'Account',
    preferences: 'Preferences',
    helpSection: 'Help',
    version: 'Version',
    logOut: 'Log Out',
    profile: 'Profile',
    email: 'Email',
    changePassword: 'Change Password',
    credits: 'Credits',
    billing: 'Billing',
    tasks: 'Tasks',
    memory: 'Memory',
    defaultModel: 'Default Model',
    upgradeToPlus: 'Upgrade to Plus',
    restorePurchases: 'Restore Purchases',
    restoringPurchases: 'Restoring...',
    restorePurchasesSuccess: 'Purchases restored.',
    restorePurchasesNone: 'No purchases to restore.',
    restorePurchasesFailed: 'Failed to restore purchases. Please try again.',
    upgradeToPremium: 'Upgrade to Plus Premium',
    referAFriend: 'Refer a Friend',
    api: 'API',
    usage: 'Usage',
    dataControls: 'Data Controls',
    connectedAccounts: 'Connected Accounts',
    importChats: 'Import Chats',
    helpAndSupport: 'Help & Support',
    archivedChats: 'Archived Chats',
    noArchivedChats: 'No archived chats yet',
    plusRequired: 'This feature requires Gab AI Plus',
    passwordRequired: 'Password is required',
    allChatsArchived: 'All chats archived successfully',
    allChatsUnarchived: 'All chats unarchived successfully',
    allChatsDeleted: 'All chats deleted successfully',
    accountDeleted: 'Account deleted successfully',
    operationFailed: 'Operation failed',
    archiveAllChats: 'Archive All Chats',
    archiveAllMessage: 'This will move all your chats to archived chats.',
    unarchiveAllChats: 'Unarchive All Chats',
    unarchiveAllMessage: 'This will move all archived chats back to your chat history.',
    deleteAllChats: 'Delete All Chats',
    deleteAllMessage: 'This will permanently delete all your chats. This action cannot be undone.',
    dataDisclaimer: 'Your data is stored securely and never shared with third parties. You can delete your data at any time.',
    deleteAccount: 'Delete Account',
    deleteAccountMessage: 'This will permanently delete your account and all associated data. This action cannot be undone.',
    deleteAccountDisclaimer: 'Permanently deletes your account and all associated data. This action cannot be undone.',
    enterPasswordConfirm: 'Enter your password to confirm',
    password: 'Password',
    confirm: 'Confirm',
    currentEmail: 'Current Email',
    newEmail: 'New Email',
    newEmailPlaceholder: 'New email',
    currentPassword: 'Current Password',
    currentPasswordPlaceholder: 'Current Password',
    updateEmail: 'Update Email',
    enterEmailAddress: 'Please enter an email address',
    enterCurrentPassword: 'Please enter your current password',
    emailUpdatedSuccess: 'Email updated successfully. Please check your new email for verification.',
    failedUpdateEmail: 'Failed to update email',
    fillAllPasswordFields: 'Please fill in all password fields',
    passwordsNoMatch: 'New passwords do not match',
    passwordUpdatedSuccess: 'Password updated successfully',
    failedUpdatePassword: 'Failed to update password. Please try again.',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'New password',
    confirmNewPassword: 'Confirm New Password',
    confirmNewPasswordPlaceholder: 'Confirm New password',
    changePasswordButton: 'Change Password',
    setPasswordButton: 'Set Password',
    setPasswordSuccess: 'Password set successfully. You can now sign in with your email and password.',
    failedSetPassword: 'Failed to set password. Please try again.',
    ssoNoPassword: 'Your account was created with social login and does not have a password yet. Set one below to also sign in with your email and password.',
  },
  settingsPage: {
    earnLoadFailed: 'We couldn’t load your credit rewards. Please try again.',
    title: 'Settings', back: 'Back to app', allSettings: 'All settings',
    search: 'Find a setting', clearSearch: 'Clear search', noResults: 'No settings found. Try a different search.',
    unsaved: 'Unsaved changes', unsavedTitle: 'Discard unsaved changes?',
    unsavedMessage: 'Your profile has changes that haven’t been saved.', discard: 'Discard changes',
    signInTitle: 'Make Gab AI your own', signInDescription: 'Sign in to manage your account, preferences, and billing.', signIn: 'Sign in',
    groups: { preferences: 'Your preferences', account: 'Account & billing', tools: 'Tools & support' },
    searchTerms: {
      appearance: 'theme dark light color timestamp font layout companion enter contrast',
      general: 'language default model chat personalization auto archive export delete account data logout notification sound audio chime mute agent',
      account: 'profile name photo avatar role email password security 2fa totp google apple connected accounts',
      subscription: 'billing plan subscription upgrade premium payment card invoice receipt cancel',
      credits: 'balance buy purchase refill automatic top up auto top-up spending limit',
      usage: 'history spending charges transactions usage models work',
      earn: 'rewards earn credits daily claim', 'default-model': 'default model personalization auto',
      memory: 'remember learn personalization saved memories', keyboard: 'keyboard shortcuts hotkeys',
      referral: 'referral refer friend share rewards', tasks: 'scheduled tasks automation recurring',
      import: 'import conversations chatgpt claude export zip json', api: 'developer api key token code integration',
      help: 'help support contact docs documentation terms privacy',
    },
    descriptions: {
      appearance: 'Make yourself at home. Choose how Gab AI looks and feels.',
      general: 'Manage your language, default chat model, and account data.',
      account: 'Your profile, sign-in details, and account security in one place.',
      subscription: 'Manage your plan, payment details, and invoices.',
      credits: 'See your balance, add credits, and manage automatic top-ups.',
      usage: 'Understand where your credits go, down to each conversation and task.',
      earn: 'Discover ways to earn more credits for your next idea.',
      'default-model': 'Choose the model you prefer for new conversations.',
      memory: 'Choose what Gab AI remembers and how it learns about you.',
      keyboard: 'Move faster with shortcuts for everyday actions.',
      referral: 'Share Gab AI with a friend and track your rewards.',
      tasks: 'Create and manage your scheduled tasks.',
      import: 'Bring your conversations with you from another AI service.',
      api: 'Manage API keys and connect Gab AI to your own applications.',
      help: 'Find answers, explore the documentation, or get in touch.',
    },
  },
  settingsWeb: {
    appearance: 'Appearance',
    general: 'General',
    profile: 'Profile',
    account: 'Account',
    shortcuts: 'Shortcuts',
    api: 'API',
    earn: 'Earn Credits',
    credits: 'Credits',
    billing: 'Billing',
    upgrade: 'Upgrade',
    usage: 'Usage',
    tasks: 'Tasks',
    memory: 'Memory',
    defaultModel: 'Default Model',
    referrals: 'Referrals',
    importLabel: 'Import',
    help: 'Help',
    logOut: 'Log Out',
    logOutConfirm: 'Are you sure you want to log out?',
    close: 'Close',
    keyboardShortcuts: 'Keyboard Shortcuts',
    apiSettings: 'API Settings',
    usageHistory: 'Usage History',
    referAFriend: 'Refer a Friend',
  },
  modals: {
    createApiKey: {
      title: 'Create API Key',
      createdTitle: 'API Key Created',
      description: 'Create a new API key to access the Gab AI API. You can have up to 10 API keys.',
      keyNameLabel: 'Key Name (optional)',
      keyNamePlaceholder: 'e.g., Production App',
      failedToCreate: 'Failed to create API key',
      copiedToClipboard: 'API key copied to clipboard',
      failedToCopy: 'Failed to copy API key',
      createdSuccess: 'Your new API key has been created successfully.',
      nameLabel: 'Name',
      apiKeyLabel: 'API Key',
      saveWarning: 'Save this key now. You won\'t be able to see it again. Store it securely and never share it publicly.',
      savedSecurely: 'I have saved this API key securely',
      createKeyBtn: 'Create Key',
    },
    voicePermission: {
      cameraRequired: 'Camera Access Required',
      cameraNeeded: 'Camera access is needed for the AI to see what you\'re looking at.',
      clickCameraIcon: 'Click the camera icon in your browser\'s address bar',
      selectAllow: 'Select "Allow" for camera access',
      tryAgain: 'Try again',
      openSettings: 'Open Settings',
      enableCamera: 'Enable camera access for Gab AI',
      returnToApp: 'Return to the app and try again',
      screenShareCancelled: 'Screen Share Cancelled',
      screenShareMessage: 'Screen sharing was cancelled. You can try again when you\'re ready.',
      noCameraFound: 'No Camera Found',
      noCameraMessage: 'We couldn\'t detect a camera on your device.',
      makeSureConnected: 'Make sure your camera is connected',
      checkNoOtherApp: 'Check that no other app is using the camera',
      tryRefreshing: 'Try refreshing the page',
      notAvailable: 'Not Available',
      notAvailableMessage: 'Camera and screen sharing are currently only available on the web version.',
      visionError: 'Vision Error',
      visionErrorMessage: 'Something went wrong with the camera. Please try again.',
      close: 'Close',
      gotIt: 'Got It',
    },
    voiceMediaError: {
      notEnoughCredits: 'Not Enough Credits',
      notEnoughCreditsMsg: 'You don\'t have enough credits to generate this %TYPE%. Add more credits to continue creating.',
      plusFeature: 'Plus Feature',
      plusFeatureMsg: '%TYPE% generation is a Plus feature. Upgrade to unlock this and more.',
      generationFailed: 'Generation Failed',
      generationFailedMsg: 'We couldn\'t generate your %TYPE%. Please try again.',
      videoImageMusic: 'Video, image & music generation',
      voiceModeMemory: 'Voice mode & memory features',
      monthlyCredits: `${PLUS_MONTHLY_CREDITS_DISPLAY} monthly credits`,
      close: 'Close',
      buyCredits: 'Buy Credits',
      maybeLater: 'Maybe Later',
    },
    voiceCreditsDepleted: {
      title: 'Voice Chat Ended',
      message: 'Your credit balance is too low to continue. Voice Mode charges 35 credits per minute based on conversation time. Purchase more credits to keep chatting.',
      close: 'Close',
      buyMore: 'Buy More Credits',
      messagePlus: 'Your credit balance is too low to continue. Voice Mode charges 35 credits per minute. Your monthly credits refresh on %DATE% — until then you can top up, upgrade, or keep chatting with Arya by text for free.',
      messagePlusNoDate: 'Your credit balance is too low to continue. Voice Mode charges 35 credits per minute. Until your monthly credits refresh you can top up, upgrade, or keep chatting with Arya by text for free.',
      seeOptions: 'See My Options',
      chatWithArya: 'Chat with Arya',
    },
    webSearch: {
      title: 'Search the Web',
      description: 'Search the web for real-time information. Ask about news, products, or anything else.',
      whatToSearch: 'What do you want to search for?',
      placeholder: 'What\'s happening in the news today?',
      orTrySuggestion: 'OR TRY A SUGGESTION',
      search: 'Search',
    },
    videoPrompt: {
      title: 'Create a Video',
      description: 'Describe the video you want to create. Include details about motion and scenes.',
      sectionTitle: 'Describe your video',
      placeholder: 'Calm ocean waves gently rolling onto a sandy beach at sunset...',
      orTrySuggestion: 'OR TRY A SUGGESTION',
      generate: 'Generate Video',
    },
    imagePrompt: {
      title: 'Create an Image',
      description: 'Describe the image you want to create. Be as detailed as you like!',
      sectionTitle: 'Describe your image',
      placeholder: 'A majestic dragon guarding a mountain of treasure...',
      orTrySuggestion: 'OR TRY A SUGGESTION',
      generate: 'Generate Image',
    },
    threeDPrompt: {
      title: 'Create 3D',
      description: 'Describe the 3D model you want to create. Mention shape, materials, and style.',
      sectionTitle: 'Describe your 3D model',
      placeholder: 'A cute rounded robot companion with expressive eyes...',
      orTrySuggestion: 'OR TRY A SUGGESTION',
      generate: 'Generate 3D',
    },
    musicStylePicker: {
      title: 'Create Music',
      subtitle: 'Choose a style to get started',
    },
    musicLyrics: {
      title: 'Create Music',
      description: 'Add lyrics to generate your track in the %STYLE% style',
      writeOwn: 'Write your own lyrics',
      placeholder: 'Enter your lyrics here...',
      orSelectExample: 'OR SELECT AN EXAMPLE',
      generate: 'Generate Music',
      modelNotAvailable: 'Music model \'%MODEL%\' not available',
    },
    saveImage: {
      title: 'Save Image',
      openFullImage: 'Open Full Image',
      close: 'Close',
      step1: 'Tap and hold on the image above (or tap \'Open Full Image\')',
      step2: 'When the menu appears, select \'Add to Photos\' or \'Save Image\'',
      tip: 'Safari on iOS doesn\'t support direct downloads. This is the fastest way to save images to your device.',
    },
    report: {
      messageTitle: 'Report a Message',
      conversationTitle: 'Report a Conversation',
      messageSubtitle: 'Help us keep conversations safe by reporting harmful or inappropriate messages.',
      conversationSubtitle: 'Help us keep the platform safe by reporting harmful or inappropriate conversations.',
      submitReport: 'Submit Report',
    },
    quickPurchase: {
      title: 'Quick Top-Up',
      confirmTitle: 'Confirm Purchase',
      noPaymentMethod: 'No saved payment method found. Please add a card to use quick top-up.',
      goToSettings: 'Go to Settings',
      creditsAdded: 'Credits Added!',
      creditsAddedMsg: '%COUNT% credits have been added to your account.',
      autoTopUpOptIn: 'Also keep my credits topped up automatically',
      autoTopUpOptInDetail: 'When my balance falls below %THRESHOLD% credits, charge this card $%AMOUNT% for %CREDITS% credits, up to $%LIMIT% per month. I\'ll get an email for every charge and can turn this off anytime in Settings.',
      autoTopUpEnabled: 'Auto top-up is on: $%AMOUNT% for %CREDITS% credits whenever you fall below %THRESHOLD%. Change or cancel it in Settings.',
      autoTopUpFailed: 'Your credits were added, but we couldn\'t turn on auto top-up. You can enable it in Settings.',
      backToChat: 'Back to Chat',
      confirmPurchase: 'Confirm Purchase',
      seeAllPacks: 'See all credit packs',
      paymentMethod: 'Payment Method',
      change: 'Change',
      total: 'Total',
      cardDeclined: 'Your card was declined. Please update your payment method in Settings.',
      cardExpired: 'Your card has expired. Please update your payment method in Settings.',
      noPaymentMethodFirst: 'No saved payment method found. Please add a card first.',
      failedToProcess: 'Failed to process purchase. Please try again.',
      purchaseComplete: 'Purchase Complete',
    },
    outOfCredits: {
      title: 'Out of credits',
      subtitle: 'Choose how you\'d like to continue',
      buyCreditsTab: 'Buy Credits',
      upgradeTab: 'Upgrade to Plus',
      popular: 'Popular',
      bestValue: 'Best Value',
      seeAllPacks: 'See all credit packs',
      orUpgrade: `Or upgrade to Plus for ${PLUS_MONTHLY_CREDITS_DISPLAY} monthly credits`,
      buyAPack: 'buy a credit pack',
      freeMessages: 'Free default model messages (not included in API)',
      monthlyCredits: `${PLUS_MONTHLY_CREDITS_DISPLAY} credits/month`,
      memoryPersonalization: 'Memory & personalization',
      videoGeneration: 'Video generation',
      socialProof: 'Join 10,000+ users who upgraded to Plus',
    },
    onboardingComplete: {
      getMoreTitle: 'Unlock Work mode with Plus',
      getMoreSubtitle: 'Turn bigger prompts into finished work',
      unlimitedMessages: 'Free default model messages in app (not included in API)',
      monthlyCredits: `${PLUS_MONTHLY_CREDITS_DISPLAY} credits every month`,
      memoryFeature: 'Memory — AI remembers you',
      collectionsFeature: 'Collections & file management',
      maybeLater: 'Maybe later',
    },
    memoryBuilder: {
      title: 'Build Your AI Memory',
      introTitle: 'Make Gab AI Yours',
      introSubtitle: 'Answer a few quick questions to help your AI give you more relevant, personalized responses in every conversation.',
      remembersYou: 'Remembers You',
      remembersYouDesc: 'Your AI learns your preferences and background',
      betterResponses: 'Better Responses',
      betterResponsesDesc: 'Get answers tailored to your expertise and needs',
      trulyPersonal: 'Truly Personal',
      trulyPersonalDesc: 'Every conversation feels like talking to your own AI',
      timeEstimate: 'Takes about 1-2 minutes \u2022 Skip any question',
      aboutYou: 'About You',
      workQuestion: 'What do you do for work or study?',
      workPlaceholder: 'e.g., Software engineer, Medical student...',
      commStyle: 'Communication Style',
      commQuestion: 'How do you prefer to receive information?',
      expertise: 'Your Expertise',
      expertiseQuestion: 'What topics are you most knowledgeable about?',
      learningGoals: 'Learning Goals',
      learningQuestion: 'What are you currently trying to learn or improve?',
      currentProjects: 'Current Projects',
      projectsQuestion: 'What projects are you currently working on?',
      personalPrefs: 'Personal Preferences',
      prefsQuestion: 'Any other preferences for how I should assist you?',
      quickSuggestions: 'Quick suggestions (tap to add)',
      letsGetStarted: 'Let\'s Get Started',
      next: 'Next',
      skip: 'Skip',
      reviewTitle: 'Review Your Memories',
      reviewDescription: 'You\'re about to create %COUNT% to help personalize your AI experience.',
      noAnswers: 'You haven\'t answered any questions yet. Go back to add some memories.',
      noMemories: 'No memories to create yet.',
      creating: 'Creating your memories...',
      noMemoriesToSave: 'No memories to save. Please answer at least one question.',
      memoriesCreated: '%COUNT% memories created successfully!',
      memoriesPartialCreated: '%SUCCESS% of %TOTAL% memories created.',
      partialCreated: '%CREATED% of %TOTAL% memories created.',
      failedToCreate: 'Failed to create memories. Please try again.',
      createFailed: 'Failed to create memories. Please try again.',
      saveMemories: 'Save %COUNT% Memories',
      questionProgress: 'Question %CURRENT% of %TOTAL%',
      savingProgress: 'Saved %SAVED% of %TOTAL%...',
      commPlaceholder: 'e.g., Keep it brief, give examples...',
      expertisePlaceholder: 'e.g., JavaScript, Marketing, Data Science...',
      learningPlaceholder: 'e.g., Machine learning, Spanish, Leadership...',
      projectsPlaceholder: 'e.g., Building a mobile app, Writing a book...',
      prefsPlaceholder: 'e.g., Use my name, include code examples...',
    },
    memoryInfo: {
      title: 'About Memory',
      description: 'Memory helps the AI provide more personalized responses by remembering context you choose to save.',
      whatIsTitle: 'What is Memory?',
      whatIsDesc: 'Memory lets the AI remember important details about you across conversations.',
      suggestionsTitle: 'Learns as You Chat',
      suggestionsDesc: 'Gab AI saves durable facts automatically — instantly when you say "remember", and in the background as it reviews your conversations. Everything lands on your Memory page.',
      controlTitle: 'You Are in Control',
      controlDesc: 'You can view, edit, or delete any stored memory at any time, or turn off learning entirely.',
      privateTitle: 'Private & Secure',
      privateDesc: 'Your memories are private to your account.',
    },
    temporaryChatSettings: {
      title: 'Temporary chat settings',
      description: 'Temporary chats never create new memories and stay out of your sidebar unless you save them.',
      personalized: 'Personalized',
      personalizedDesc: 'Gab will use your memories and custom instructions when replying.',
      unpersonalized: 'Unpersonalized',
      unpersonalizedDesc: 'Gab will ignore your memories and custom instructions when replying.',
      updateFailed: 'Failed to update temporary chat settings',
    },
    temporaryChatInfo: {
      title: 'About Temporary Chat',
      description: 'Use a temporary chat when you want a one-off conversation that stays out of your history.',
      historyTitle: 'Stays out of history',
      historyDesc: 'Temporary chats are hidden from your sidebar and cleaned up when you leave — unless you choose to save them.',
      memoryTitle: 'No new memories',
      memoryDesc: 'Temporary chats never create new memories. You can still opt in to using existing memories and custom instructions.',
      saveTitle: 'Save if it matters',
      saveDesc: 'If a temporary chat becomes something worth keeping, save it from the menu. It then follows your regular memory settings.',
    },
    importMemory: {
      title: 'Import Memories',
      introTitle: 'Import Your Memories',
      introSubtitle: 'Bring your preferences and context from another AI provider. Your first conversation will feel like your hundredth.',
      step1Title: 'Copy the Export Prompt',
      step1Desc: 'We provide a prompt you paste into your old AI to export your memories',
      step2Title: 'Paste the Results',
      step2Desc: 'Copy the output from your old AI and paste it here',
      step3Title: 'Review and Save',
      step3Desc: 'Review parsed memories, toggle any off, then save them all at once',
      worksWithProviders: 'Works with ChatGPT, Claude, Gemini, and others',
      stepProgress: 'Step %CURRENT% of %TOTAL%',
      copyPromptTitle: 'Copy this prompt',
      copyPromptDesc: 'Paste this prompt into a conversation with your previous AI (ChatGPT, Claude, Gemini, etc.) to export your memories:',
      copyPromptBtn: 'Copy Prompt to Clipboard',
      copiedBtn: 'Copied to Clipboard!',
      afterCopyTip: 'After copying, open your old AI provider, paste this prompt, and copy the response it gives you. Then come back here and tap "Next".',
      pasteTitle: 'Paste the exported memories',
      eachLineMemory: 'Each line becomes a separate memory',
      pasteDesc: 'Paste the full response from your previous AI below. Each line will become a separate memory.',
      pastePlaceholder: 'Paste the exported memories here...',
      pasteHint: 'Paste the code block output from your other AI',
      linesDetected: 'lines detected',
      parseBtn: 'Parse Memories',
      reviewMemoriesTitle: 'Review memories',
      ofSelected: 'of %TOTAL% selected',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      noMemoriesSelected: 'No Memories Selected',
      importing: 'Importing your memories...',
      getStarted: 'Get Started',
      nextPaste: 'Next: Paste Results',
      promptCopied: 'Prompt copied to clipboard',
      failedToCopy: 'Failed to copy prompt',
      noMemoriesFound: 'No memories found. Make sure you pasted the AI output correctly.',
      selectAtLeastOne: 'No memories selected. Please select at least one.',
      importSuccess: '%COUNT% memories imported successfully!',
      partialImport: '%IMPORTED% of %TOTAL% memories imported.',
      failedToImport: 'Failed to import memories. Please try again.',
    },
    createMemory: {
      title: 'Create memory',
      createBtn: 'Create memory',
    },
    createCollection: {
      title: 'Create new collection',
      createBtn: 'Create collection',
      nameLabel: 'Collection name',
      nameRequired: 'Collection name is required',
      nameMin3: 'Collection name must be at least 3 characters',
      chooseIcon: 'Choose an icon',
      whatIsTitle: 'What\'s a collection?',
      whatIsDesc: 'Collections keep chats, files, and custom instructions in one place.',
      createdSuccess: 'Collection created successfully',
      failedToCreate: 'Failed to create collection',
      nestedIn: 'Inside %NAME%',
    },
    downloadApps: {
      title: 'Download Gab AI',
      kicker: 'Get the app',
      headline: 'Gab AI, everywhere you go',
      subtitle: 'Scan the code with your phone camera to install. Sign in once and everything you have here follows you.',
      scanPrompt: 'Point your camera at the code',
      iosLabel: 'iPhone & iPad',
      androidLabel: 'Android',
      featureSyncTitle: 'Stay in sync',
      featureSync: 'Chats, files, and memory follow you.',
      featureCreditsTitle: 'One credit balance',
      featureCredits: 'The same pool on every device.',
      featureVoiceTitle: 'Voice and camera',
      featureVoice: 'Hands-free chat, photos, and alerts.',
      featureModelsTitle: 'Same models everywhere',
      featureModels: 'Chat, images, video, and music on any device.',
      featureAgentsTitle: 'Bots and tasks',
      featureAgents: 'Custom bots and scheduled work travel with you.',
      macTitle: 'Also on macOS',
    },
    installApp: {
      title: 'Install Gab AI',
      gotIt: 'Got it',
      introDesc: 'Install Gab AI on your device for a faster, app-like experience with easy access from your home screen.',
      iosTab: 'iPhone / iPad',
      androidTab: 'Android',
      shareButton: 'Tap the Share button',
      shareDesc: 'Look for the share icon at the bottom of Safari...',
      addToHomeScreen: 'Scroll down and tap "Add to Home Screen"',
      tapAdd: 'Tap "Add"',
      tapMenu: 'Tap the menu button',
      addOrInstall: 'Tap "Add to Home screen" or "Install app"',
      tapAddOrInstall: 'Tap "Add" or "Install"',
      whyInstall: 'Why install the app?',
      fasterLoad: 'Faster load times',
      easyAccess: 'Easy access from home screen',
      fullScreen: 'Full screen experience',
      optionalNotifications: 'Optional notifications',
    },
    input: {
      defaultTitle: 'Rename',
      defaultPlaceholder: 'Enter name',
      defaultCreateBtn: 'Create',
      nameEmpty: 'Name cannot be empty',
    },
    editMessage: {
      title: 'Edit Message',
      placeholder: 'Enter your message',
      saving: 'Saving...',
      messageEmpty: 'Message cannot be empty',
      failedToEdit: 'Failed to edit message',
      messageEdited: 'Message edited',
    },
    fileEdit: {
      title: 'File Preview',
      loadingFile: 'Loading file...',
      unableToLoad: 'Unable to load file',
      nameUpdated: 'File name updated successfully',
      nameUpdateFailed: 'Failed to update file name',
      deleteTitle: 'Delete File',
      deleteMessage: 'Are you sure you want to delete this file? This action cannot be undone.',
      fileDeleted: 'File deleted successfully',
      failedToDelete: 'Failed to delete file',
      notAvailable: 'File not available for download',
      downloadStarted: 'Download started',
      downloaded: 'File downloaded successfully',
      downloadFailed: 'Failed to download file',
      addedToCollection: 'File added to collection',
      chatBtn: 'Chat',
      moveBtn: 'Move',
      downloadBtn: 'Download',
      deleteBtn: 'Delete',
      details: 'Details',
      created: 'Created',
      originalName: 'Original Name',
      type: 'Type',
      editName: 'Edit name',
    },
    files: {
      selectFile: 'Select File',
      searchPlaceholder: 'Search for files',
      loadingFiles: 'Loading files...',
      errorLoading: 'Error loading files:',
      retry: 'Retry',
      noFilesMatching: 'No files found matching',
      noFiles: 'No files found.',
      includeGenerated: 'Include generated files',
    },
    addFilesToCollection: {
      myFiles: 'My Files',
      uploadNew: 'Upload New',
      noFilesMatching: 'No files found matching',
      noFilesAvailable: 'No files available to add. Upload some files first.',
      uploadNewFiles: 'Upload New Files',
      uploadDesc: 'Upload new files to your library and add them to this collection',
      selectFiles: 'Select files to add',
      searchPlaceholder: 'Search your files...',
      filesAvailable: 'file(s) available',
      addedToCollection: 'file(s) to collection',
      failedToAdd: 'Failed to add files to collection',
    },
    moveToCollection: {
      title: 'Add to Collection',
      selectCollection: 'Select a collection',
      noCollections: 'No collections yet.\nCreate one to organize your files.',
      createNew: 'Create New Collection',
      selectAtLeastOne: 'Please select at least one collection',
      failedToAdd: 'Failed to add files to collection',
    },
    moveChatsToCollection: {
      title: 'Move to Collection',
      selectCollection: 'Select a collection',
      headerText: 'Move %COUNT% chats to another collection. They will be removed from this one.',
      headerTextSingle: 'Move this chat to another collection. It will be removed from this one.',
      noCollections: 'No other collections yet.\nCreate one to move these chats.',
      createNew: 'Create New Collection',
      selectOne: 'Please select a collection',
      failedToMove: 'Failed to move chats to collection',
    },
    creditsRequired: {
      title: 'Get More Credits',
      subtitle: `Upgrade to Plus for free default model messages and ${PLUS_MONTHLY_CREDITS_DISPLAY} monthly credits.`,
      getMoreBtn: 'Get More Credits',
      buyCreditsBtn: 'Buy Credits',
    },
    creditsPurchase: {
      myCreditsTab: 'My Credits',
      buyCreditsTab: 'Buy Credits',
      upgradeTab: 'Upgrade to Plus',
      orDivider: 'OR',
      close: 'Close',
    },
    creditsInfo: {
      title: 'How Credits Work',
      description: 'Credits pay for third-party AI. Providers set their prices; we convert those costs into credits.',
      whatAreTitle: 'Third-party prices',
      whatAreDesc: 'Google, OpenAI, Anthropic, and other providers set their own rates. We convert that cost into credits so every model uses the same balance.',
      freeDefaultTitle: 'Free default model',
      freeDefaultDesc: 'Our default AI model does not cost credits in the app. The developer API is billed separately.',
      contextTitle: 'Longer chats cost more',
      contextDesc: 'Each model has a starting price and a size threshold. When a conversation crosses that threshold, the estimate steps up — the context multiplier. A long thread can cost several times the listed price.',
      holdTitle: 'Estimate vs. reserve',
      holdDesc: 'The composer shows the estimate for this turn. We may temporarily reserve extra credits for a long reply. Unused credits come back. You only pay for what was used.',
      monthlyResetTitle: 'Monthly credits reset',
      monthlyResetDesc: `Plus subscribers receive ${PLUS_MONTHLY_CREDITS_DISPLAY} credits monthly.`,
      monthlyResetDescPremium: `Plus Premium subscribers receive ${PLUS_PREMIUM_MONTHLY_CREDITS_DISPLAY} credits monthly.`,
      buyMoreTitle: 'Buy more anytime',
      buyMoreDesc: 'Purchased credit packs never expire.',
      faqModels: 'How many credits do different models use?',
      faqModelsAnswer: 'Each model lists its starting price. The composer estimate uses that price plus the current size of your chat. Image, video, and other media have their own provider prices.',
      faqHold: 'Why can the reserved amount be higher?',
      faqHoldAnswer: 'A long reply can cost more than the estimate. We hold that extra until Gab finishes, then refund what you did not use. Tap the coin in the composer to see both numbers for this turn.',
      faqRunOut: 'What happens if I run out?',
      faqRunOutAnswer: 'You can keep using our default model for free. For other models, wait for your monthly credits to refresh or buy a credit pack.',
    },
    subscriptionCheckout: {
      extendedSuccess: 'Subscription extended successfully!',
      unableToLoad: 'Unable to load checkout. Please try again.',
      close: 'Close',
      loading: 'Loading secure checkout...',
    },
    cancelSubscription: {
      title: 'Cancel Subscription First',
      description: 'To delete your account, you need to cancel your Gab AI Plus subscription first.',
      close: 'Close',
      openGooglePlay: 'Open Google Play Settings',
      openAppStore: 'Open App Store Settings',
      directLink: 'Or tap here to go directly to your subscriptions',
      afterCancel: 'After cancelling, your Plus benefits remain until the end of your billing period. You can then delete your account.',
    },
    cancelPurchase: {
      title: 'Cancel Subscription',
      neverMind: 'Never mind',
      yesCancel: 'Yes, cancel my subscription',
      warningMessage: 'Are you sure you want to cancel your subscription? You\'ll lose access to unlimited AI conversations.',
      confirmPassword: 'Confirm your password',
      enterPassword: 'Enter your password',
      helpImprove: 'Help us improve (optional)',
      whyCanceling: 'Why are you canceling your subscription?',
      passwordRequired: 'Please enter your password to confirm cancellation',
      failedToCancel: 'Failed to cancel subscription',
    },
    cancellationSave: {
      title: 'Before you go',
      offerTitle: 'Wait — we\'ve got something for you',
      offerPersonalizedTitle: 'Personalized Offer',
      offerStayHeadline: 'Stay to get %LABEL%. We\'d hate to lose you.',
      offerStayHeadlineYearlyDefer: 'Stay on Plus — get %LABEL%. We\'d hate to lose you.',
      offerStayHeadlineYearlyCredit: 'Stay on Plus — we\'ll add %LABEL% to your account.',
      offerEligibleSubheading: 'You\'re eligible for our special discount.',
      offerEligibleSubheadingYearlyDefer: 'No charge today — we\'ll push your renewal date back.',
      offerEligibleSubheadingYearlyCredit: 'Your subscription stays the same — credits are added instantly.',
      offerTimeLimited: 'Time-Limited Deal',
      offerFinalEyebrow: 'Our Best & Final Offer',
      bonusCreditsLine: '+ %COUNT% bonus credits, added instantly',
      acceptOffer: 'Accept Offer',
      declineOffer: 'Decline offer',
      back: 'Back',
      surveyHeading: 'We\'d hate to see you go. What\'s the main reason you\'re canceling?',
      followupHeading: 'Got it — can you tell us a little more?',
      freeformPlaceholder: 'Tell us more (optional)',
      continue: 'Continue',
      cancelNow: 'Cancel Plus now',
      claimOffer: 'Keep Plus — %LABEL%',
      offerSubtitle: 'Stay with Plus and this will be applied to your account right away. You can keep using everything you have today.',
      offerValueHeading: 'You\'ve built a lot here',
      offerValueHeadingNamed: 'You\'ve built a lot here, %NAME%',
      offerValueSubheading: 'Stay on Plus — all of this stays yours.',
      offerValueSubheadingStats: 'Your account at a glance',
      offerValueStatConversations: 'conversations',
      offerValueStatMessages: 'messages sent',
      offerValueStatFiles: 'files',
      offerValueStatMemories: 'saved memories',
      offerValueStatCollections: 'collections',
      offerValueStatAgents: 'custom bots',
      offerValueStatTasks: 'scheduled tasks',
      offerValueStatImages: 'images created',
      offerValueFallbackConversations: 'All your chats & history',
      offerValueFallbackMessages: 'Unlimited default-model messages',
      offerValueFallbackFiles: 'File upload & analysis',
      offerValueFallbackMemories: 'AI Memory that knows you',
      offerValueFallbackCollections: 'Collections & saved work',
      offerValueFallbackAgents: 'Custom bots you\'ve built',
      offerValueFallbackTasks: 'Scheduled tasks & automations',
      offerValueFallbackImages: 'Image & video generation',
      churn: {
        ledgerHeadline: 'Everything you\'ve built stays yours',
        ledgerSub: 'Accept this offer and nothing below gets touched — you just pay less.',
        totalSave: 'You keep $%AMOUNT% over the offer period',
        ctaKeepAll: 'Keep it all — accept offer',
        footprintEyebrow: 'Your Gab footprint',
        footprintEyebrowNamed: '%NAME%\'s Gab footprint',
        footprintLabel: 'weighted interactions in your workspace',
        workspaceBuilt: 'Workspace built',
        footprintOffer: 'Protect it all for %PRICE%/mo — save %SAVE% total',
        ctaProtect: 'Protect my workspace',
        regret_memories: '%COUNT% memories trained on you — they go dormant without Plus',
        regret_agents: '%COUNT% custom bots you built — frozen on the free plan',
        regret_collections: '%COUNT% collections you curated — harder to organize without Plus',
        regret_conversations: '%COUNT% conversations of context — out of easy reach',
        regret_tasks: '%COUNT% scheduled tasks — stopped without Plus',
        regret_files: '%COUNT% uploaded files — limited access on free',
        regret_images: '%COUNT% images you created — generation caps return',
        regret_messages: '%COUNT% messages of history — throttled on free',
        regretFallback: 'Your Plus workspace is built around you — it changes without it',
        regretSub: 'Plus keeps your setup intact. Free doesn\'t.',
        reliefEyebrow: 'One way to avoid that',
        reliefLine: '%PCT%% off for %DURATION% — was %STRUCK%/mo',
        roiHeadline: 'The math is on your side',
        roiSub: 'Based on ~%USES% sessions a month on Gab AI',
        roiToday: 'Today',
        roiWithOffer: 'With offer',
        roiPerUse: 'per session',
        roiBanner: 'Save %SAVE% over %DURATION% — same product, fraction of the cost',
        ctaSmart: 'Take the smarter deal',
        unlockBadge: 'Retention offer',
        unlockTitle: 'We unlocked a deal just for you',
        unlockTitleNamed: '%NAME%, we unlocked a deal just for you',
        unlockSub: 'Not shown to everyone — only members who\'d get the most from staying',
        unlockSave: 'Save %AMOUNT% total',
        unlockProtected: 'What stays protected',
        unlockFine: 'Applied instantly · cancel anytime after the offer period',
        ctaUnlock: 'Unlock my offer',
        unlockV2: {
          stayBadge: 'Member offer',
          stayTitle: 'Stay on Plus for less',
          stayTitleNamed: '%NAME%, stay on Plus for less',
          staySub: 'Same Gab AI you use today — just a lower monthly bill.',
          stayStats: 'What you\'re keeping',
          ctaStay: 'Stay on Plus — %PRICE%/mo',
          lossBadge: 'Workspace protection',
          lossTitle: 'Don\'t lose what you\'ve built',
          lossTitleNamed: '%NAME%, don\'t lose what you\'ve built',
          lossSub: 'This offer keeps your files, memories, and bots exactly where they are.',
          lossStats: 'At risk without Plus',
          ctaLoss: 'Keep my workspace',
          gainBadge: 'Savings unlocked',
          gainTitle: 'You\'re leaving money on the table',
          gainTitleNamed: '%NAME%, you\'re leaving money on the table',
          gainSub: 'Members who accept keep full Plus — and pay a fraction of the price.',
          savedOver: 'saved over %DURATION%',
          ctaGain: 'Claim %SAVE% in savings',
          nowBadge: 'Limited window',
          nowTitle: 'Lock in this rate before you go',
          nowTitleNamed: '%NAME%, lock in this rate before you go',
          nowSub: 'This retention rate is tied to your account — it won\'t wait.',
          nowUrgency: 'Offer available only while you\'re on this screen',
          nowFine: 'Rate applies instantly · not saved if you cancel now',
          ctaNow: 'Lock in my rate',
          stackBadge: 'Your Plus stack',
          stackTitle: 'Your stack is worth keeping',
          stackTitleNamed: '%NAME%, your stack is worth keeping',
          stackSub: 'Memories, bots, and collections you\'ve invested in — protected on Plus.',
          stackStats: 'Your Plus stack',
          ctaStack: 'Protect my stack',
        },
      },
      offerApplied: 'Done! Your offer is applied — you\'re still Plus.',
      offerError: 'We couldn\'t apply that offer. Please try again or cancel.',
      gateErrors: {
        no_active_subscription: 'We couldn\'t find an active subscription to attach an offer to.',
        no_cancel_context: 'This offer session expired. Close and open Cancel again from Settings.',
        grant_rate_limit: 'No new offer could be loaded right now.',
        in_cooldown: 'You recently accepted a save offer — it\'s still active on your account.',
        no_offer_for_segment: 'No discount applies for this cancellation reason.',
        offer_not_configured: 'Save offers aren\'t configured on this server yet.',
        not_useful: 'No discount for this answer — you can still cancel below.',
        too_new: 'Your subscription is too new for a save offer yet.',
        yearly_subscriber: 'Save offers for annual plans aren\'t available on this server yet.',
        yearly_defer_disabled: 'We couldn\'t apply this renewal extension. You can still cancel below.',
        default: 'We couldn\'t load a save offer right now.',
      },
      reasons: {
        tooExpensive: 'It\'s too expensive',
        notUsing: 'I\'m not using it enough',
        missingFeature: 'It\'s missing a feature I need',
        foundAlternative: 'I found an alternative',
        somethingElse: 'Something else',
      },
      followups: {
        cantAfford: 'It costs more than I can spend right now',
        notEnoughValue: 'I\'m not getting enough value',
        foundCheaper: 'I found a cheaper alternative',
        tooBusy: 'I\'m too busy right now',
        forgot: 'I forgot I was subscribed',
        notUseful: 'I didn\'t find it useful',
      },
    },
    autoTopUpPrompt: {
      setUpBtn: 'Set Up Auto Top-Up',
      maybeLater: 'Maybe Later',
      noThanks: 'No Thanks',
      disclosure: 'You choose the pack and the monthly limit. Set up with what you just bought and we\'d charge $%AMOUNT% for %CREDITS% credits whenever your balance falls below %THRESHOLD%. Turn it off anytime in Settings.',
      disclosureGeneric: 'You choose the pack, when it triggers, and a monthly limit. Nothing is charged until you set it up, and you can turn it off anytime in Settings.',
      title: 'Never run out again?',
      subtitle: 'Enable auto top-up to automatically add credits when your balance gets low.',
      neverRunOut: 'Never run out',
      neverRunOutDesc: 'Auto-add credits when balance gets low',
      youControl: 'You control it',
      youControlDesc: 'Set your threshold and spending limit',
      stayInformed: 'Stay informed',
      stayInformedDesc: 'Get notified when credits are added',
    },
    autoTopUpOffer: {
      title: 'Never run out of credits',
      subtitle: 'Set up auto top-up — you pick the pack and monthly limit, cancel anytime',
    },
    autoTopUpConfig: {
      title: 'Configure Auto Top-Up',
      whenBelow: 'When credits fall below',
      creditsLabel: 'credits',
      packTooSmall: 'This pack is too small for auto top-up — one top-up has to leave you above your trigger. Pick a larger pack.',
      thresholdTooHigh: 'A %CREDITS%-credit pack can\'t lift you past %THRESHOLD% credits in one top-up, so it would charge again straight away.',
      autoPurchase: 'Automatically purchase',
      bestValue: 'Best Value',
      monthlyLimit: 'Monthly limit',
      noLimit: 'No limit (set one)',
      removeLimit: 'Remove',
      cardToCharge: 'Card to charge',
      enableBtn: 'Enable Auto Top-Up',
      agreeTerms: 'By enabling, you agree to our Terms',
      terms: 'Terms',
      selectPack: 'Please select a credit pack',
      limitExceed: 'Monthly spending limit cannot exceed $3,000',
      limitBelowPack: 'Your monthly limit needs to be at least $%LIMIT% to cover the $%PRICE% pack you selected.',
      enabledSuccess: 'Auto top-up enabled successfully!',
      failedToEnable: 'Failed to enable auto top-up',
      comingSoon: 'Auto top-up is coming soon for international users',
    },
    modelDetails: {
      title: 'Model Details',
      startChat: 'Start Chat',
      removedFromFavorites: 'Model removed from favorites',
      addedToFavorites: 'Model added to favorites',
      failedToUnsave: 'Failed to unsave model',
      failedToSave: 'Failed to save model',
      removeFromFavs: 'Remove from favorites',
      addToFavs: 'Add to favorites',
      accessPremium: 'Access Premium AI Models',
      accessPremiumDesc: 'To use this model, buy credits or upgrade to Plus.',
      keyStrengths: 'Key Strengths',
      stats: 'Stats',
      features: 'Features',
      quickStart: 'Quick Start',
      madeWithThisModel: 'Made with this model',
      seeAll: 'See all',
      tool: 'Tool',
    },
    share: {
      dismiss: 'Dismiss',
      cannotShare: 'Cannot Share This Chat',
      cannotShareDesc: 'Conversations containing images or files cannot be shared or made public for privacy reasons.',
      allMessagesVisible: 'All messages in this chat will be visible to anyone with the link.',
      linkCopied: 'Link copied to clipboard',
      failedToCopy: 'Failed to copy link',
      shareVia: 'Share via',
      shareOn: 'Share on',
      defaultShareTitle: 'Shared chat on Gab AI',
      failedToOpenShare: 'Could not open sharing',
    },
    signup: {
      title: 'Create Account',
    },
    login: {
      title: 'Log In',
    },
    ghostSignup: {
      title: 'Sign Up',
      defaultTitle: 'Ready to unlock all features?',
      defaultSubtitle: 'Join for free to save your progress and access all features.',
      defaultSubmitBtn: 'Create Account',
      defaultFooter: 'Already have an account?',
      defaultFooterLink: 'Log in',
    },
    authCTA: {
      defaultTitle: 'Create an account to continue',
      defaultSubtitle: 'Sign up for free to use %APP%. It only takes a few seconds.',
      primaryLabel: 'Create account',
      secondaryLabel: 'Log in',
      benefits: {
        chats: 'Save your chats, files, and history across devices',
        files: 'Upload files and build a personal library',
        memory: 'Personalize results with memory and saved prompts',
      },
    },
    reviewHold: {
      title: 'Your account is locked down for review',
      subtitle: 'Please email',
      emailSupport: 'Email ai@gab.com',
      dismiss: 'OK',
    },
    verifyEmail: {
      title: 'Verify your email to start chatting',
      subtitle: 'We sent a verification link to your inbox. Click it to unlock messaging.',
      titleReward: '%CREDITS% bonus credits are waiting for you',
      subtitleReward: 'We already sent a link to your inbox. One tap and the credits land in your account — we\'ll notice automatically.',
      step1: 'Open your inbox',
      step2: 'Tap the link from Gab AI',
      step3: 'Watch %CREDITS% credits land here',
      step3NoReward: 'Come back here — you\'re unlocked',
      openInbox: 'Open %PROVIDER%',
      checking: 'Checking…',
      later: 'I\'ll do this later',
      successTitle: 'Email verified!',
      successTitleReward: '%CREDITS% credits added',
      successSubtitle: 'You\'re all set. Thanks for confirming it\'s really you.',
      successCta: 'Keep going',
      resend: 'Resend verification email',
      resendAgain: 'Resend email',
      resendCooldown: 'Resend available in %SECONDS%s',
      checkVerified: "I clicked the link — check now",
      sentConfirmation: 'Verification email sent — check your inbox.',
      sentToast: 'Verification email sent successfully.',
      sendErrorToast: 'Failed to send verification email. Please try again.',
      verifiedToast: 'Email verified — you\'re all set!',
      notVerifiedYetToast: 'Your email isn\'t verified yet. Click the link in the email we sent you, then try again.',
      checkErrorToast: 'Could not check verification status. Please try again.',
      helpText: 'Can\'t find it? Check your spam folder. Still nothing? Email us at',
      helpTextSuffix: 'for manual verification.',
    },
    verifyPhone: {
      title: 'Verify your phone to continue',
      subtitle: 'Enter your mobile number. We\'ll text you a short code.',
      codeSubtitle: 'Enter the code we just texted you.',
      phoneLabel: 'Phone number',
      countryPickerTitle: 'Select country',
      countrySearchPlaceholder: 'Search countries',
      countryAccessibility: 'Country code, %COUNTRY% %CODE%',
      noCountries: 'No countries match your search.',
      codeLabel: 'Verification code',
      sendCode: 'Send code',
      resend: 'Resend code',
      resendCooldown: 'Resend available in %SECONDS%s',
      changeNumber: 'Change number',
      rateLimitedToast: 'Too many attempts. Please wait a moment and try again.',
      verify: 'Verify phone',
      sentToast: 'Verification code sent.',
      sendErrorToast: 'Could not send a verification code. Please try again.',
      verifiedToast: 'Phone verified — you\'re all set!',
      verifyErrorToast: 'That code is incorrect or expired. Please try again.',
      helpText: 'Having trouble? Email us at',
    },
  },
  nav: {
    modelSelector: {
      title: 'Models',
      searchPlaceholder: 'Search models',
      featured: 'Featured Models',
      searching: 'Searching...',
      searchError: 'Error searching models',
      noModels: 'No models found',
      viewAll: 'View All Models',
    },
    agentSelector: {
      title: 'Bots',
      searchPlaceholder: 'Search bots',
      featured: 'Featured Bots',
      searching: 'Searching...',
      searchError: 'Error searching bots',
      noAgents: 'No bots found',
      viewAll: 'View All Bots',
    },
    modelSelectorDetailed: {
      search: 'Search',
      all: 'All',
      multiSelect: 'Multi-select',
      compareModels: 'Compare multiple models',
      searching: 'Searching...',
      searchError: 'Error searching models',
      noModels: 'No models found',
      latestModels: 'Latest models',
      autoSelect: 'Auto-select',
      autoSelectDesc: 'Automatically choose the best model for each task',
      loadMore: 'Load more models',
      loadingMore: 'Loading more...',
      selectedModels: 'Selected Models',
      maxLabel: 'Max:',
      videoModelsPlus: 'Video Models are a Plus Feature',
      videoModelsDesc: `To use video models, buy credits or upgrade to Plus. Free signup credits can't be used for video.`,
      unlockAllModels: 'Unlock All Models',
      unlockAllDesc: 'To use this model, buy credits or upgrade to Plus. Free signup credits only work with Arya and basic image generation.',
      compareTitle: 'Compare Multiple Models',
      compareDesc: 'Upgrade to Plus to select and compare multiple AI models in a single conversation',
      newBadge: 'NEW',
      browseTitle: 'Browse models',
      browseSubtitle: 'Pick a model that matches what you want to make.',
      frequent: 'Frequent',
      favorites: 'Favorites',
      other: 'Other',
      noResultsInCategory: 'No models in this category',
      compareUpTo: 'Compare up to {max}',
      done: 'Done',
      newest: 'Newest',
      moreInfo: 'More info',
      back: 'Back',
      bestFor: 'Best for',
      strengths: 'Strengths',
      stats: 'Stats',
      statsContextWindow: '{count} context window',
      statsMaxOutput: '{count} max output tokens',
      statsCredits: '{count} credits per use',
      statsReleased: 'Released {date}',
      useThisModel: 'Use this model',
      selectedModel: 'Selected',
    },
    agentSelectorDetailed: {
      title: 'Bots',
      search: 'Search',
      unavailable: 'Bot selection unavailable',
      unavailableDesc: 'Bots unavailable in the current context',
      searching: 'Searching...',
      searchError: 'Error searching bots',
      noAgents: 'No bots found',
      favorites: 'Favorites',
      allAgents: 'All Bots',
      viewAll: 'View All Bots',
      newBadge: 'NEW',
    },
    themeSelector: {
      theme: 'Theme',
      accents: 'Accents',
      accentColor: 'Accent Color',
      textColor: 'Text Color',
      exampleButton: 'Example Button',
    },
    infoSelector: {
      title: 'Info',
      about: 'About',
      contact: 'Contact',
      termsOfService: 'Terms of Service',
      termsOfSale: 'Terms of Sale',
      privacyPolicy: 'Privacy Policy',
      feedback: 'Feedback',
    },
    routes: {
      tag: {
        renameTitle: 'Rename Tag',
        tagName: 'Tag name',
        renameSubtitle: 'Enter a new name for this tag',
        archiveSubtitle: 'Are you sure you want to archive this tag? You can access it later in your archived tags.',
        moreOptions: 'More options',
        renameTag: 'Rename tag',
        archiveTag: 'Archive tag',
        tagFallback: 'Tag',
      },
      tags: {
        createTitle: 'Create Tag',
        createSubtitle: 'Enter a name for your new tag',
        tagName: 'Tag name',
        filter: 'Filter',
        tagsTitle: 'Tags',
      },
      collection: {
        renameTitle: 'Rename Collection',
        renameSubtitle: 'Enter a new name for this collection',
        collectionName: 'Collection name',
        deleteMessage: 'This will permanently delete all collection chats. Subcollections will move up one level. To save chats, move them to your chat list or another collection before deleting.',
        failedToRename: 'Failed to rename collection',
        failedToDelete: 'Failed to delete collection',
        iconUpdated: 'Collection icon updated',
        failedToUpdateIcon: 'Failed to update icon',
        moreOptions: 'More options',
        collectionFallback: 'Collection',
      },
      chat: {
        temporaryChat: 'Temporary Chat',
        newChat: 'New Chat',
        logIn: 'Log in',
        signUp: 'Sign up',
        moreOptions: 'More options',
        unpin: 'Unpin',
        pin: 'Pin',
        chatDetails: 'Chat Details',
        findInChat: 'Find in Chat',
        modelFallback: 'Model',
      },
      modelChat: {
        saveFavoriteModels: 'Save More Favorite Models',
        saveFavoriteModelsDesc: 'Upgrade to Plus to save unlimited favorite models and access them quickly anytime.',
        removedFromFavorites: 'Model removed from favorites',
        addedToFavorites: 'Model added to favorites',
        failedToUnsave: 'Failed to unsave model',
        failedToSave: 'Failed to save model',
        moreOptions: 'More options',
        unsave: 'Unsave',
        newChat: 'New Chat',
      },
      agentChat: {
        saveFavoriteAgents: 'Save More Favorite Bots',
        saveFavoriteAgentsDesc: 'Upgrade to Plus to keep more bots in your favorites.',
        removedFromFavorites: 'Bot removed from favorites',
        addedToFavorites: 'Bot added to favorites',
        failedToUnsave: 'Failed to unsave bot',
        failedToSave: 'Failed to save bot',
        moreOptions: 'More options',
        unsave: 'Unsave',
        newChat: 'New Work Chat',
      },
      home: {
        newTemporaryChat: 'New Temporary Chat',
        newTemporaryChatTooltip: 'New temporary chat',
        auto: 'Auto',
        modelsCount: 'models',
      },
      library: {
        filter: 'Filter',
        filterChats: 'Filter chats',
        newChat: 'New Chat',
        newChatTooltip: 'New chat',
        libraryTitle: 'Library',
      },
      files: {
        upload: 'Upload',
        newCollection: 'New collection',
        searchFiles: 'Search files',
        filesTitle: 'Files',
      },
      tasksBrowse: {
        title: 'Browse Task Templates',
        newTask: 'New task',
      },
      tools: {
        title: 'Tools',
        history: 'History',
        historyTitle: 'Tool history',
        backToTools: 'Back to tools',
        backToToolsTitle: 'Return to the tools catalog',
      },
      prompts: {
        title: 'Prompt Library',
        detail: 'Recipe',
        backToPrompts: 'Back to library',
        backToPromptsTitle: 'Return to the Prompt Library',
      },
      taskTemplate: {
        backToTasks: 'Back to tasks',
        backToTasksTitle: 'Return to the task templates catalog',
      },
      agentCatalog: {
        backToAgents: 'Back to bots',
        backToAgentsTitle: 'Return to the bots catalog',
      },
      topics: {
        backToTopics: 'Back to topics',
        backToTopicsTitle: 'Return to the topics catalog',
        viewAllCategories: 'View all categories',
        viewAllCategoriesTitle: 'Browse all topic categories',
        feedbackTitle: 'Send feedback about this topic page',
      },
      topicTags: {
        viewAllTags: 'View all tags',
        viewAllTagsTitle: 'Browse all topic tags',
      },
      deck: {
        title: 'Deck',
        workspaceTitle: 'Deck workspace',
        openRecipes: 'Deck recipes',
        openRecipesTitle: 'Browse deck recipe templates',
      },
      deckRecipes: {
        catalogTitle: 'Deck recipes',
        catalogDescription: 'Browse workflow templates for Gab AI Deck.',
        recipeFallback: 'Deck recipe',
        categoryFallback: 'Recipes by category',
        openDeck: 'Open deck',
        openDeckTitle: 'Go to your deck workspace',
        backToDeck: 'Back to deck',
        backToDeckTitle: 'Return to your deck workspace',
        backToRecipes: 'Back to recipes',
        backToRecipesTitle: 'Return to the deck recipes catalog',
        useThisRecipe: 'Use this recipe',
        useThisRecipeTitle: 'Create a deck from this template',
        creatingDeck: 'Creating deck…',
      },
      workflows: {
        title: 'Workflows',
        edit: 'Edit',
        editTitle: 'Edit workflow',
        history: 'Runs',
        historyTitle: 'Run history',
        backToWorkflows: 'Back to workflows',
      },
      collections: {
        newCollection: 'New Collection',
        newCollectionTooltip: 'New collection',
      },
      agents: {
        newAgent: 'New Bot',
        newAgentTooltip: 'New bot',
      },
      defaultHeader: {
        toggleSidebar: 'Toggle sidebar',
      },
      referral: {
        title: 'Refer a Friend',
      },
    },
  },
  sidebar: {
    accountMenu: 'Account menu',
    upgradePlan: 'Upgrade Plan',
    personalization: 'Personalization',
    help: 'Help',
    logOut: 'Log Out',
    settings: 'Settings',
    newChat: 'New Chat',
    newCollection: 'New Collection',
    newAgent: 'New Bot',
    shortcuts: 'Shortcuts',
    tryPlus: 'Try Plus',
    upgradeSubtitle: 'Upgrade to higher limits, smarter AI, and more features.',
    learnMore: 'Learn More',
    dontLoseProgress: 'Don\'t Lose Your Progress',
    createAccountPrompt: 'Create an account to make sure your chats are always here.',
    signInToSaveWork: 'Sign in to use your library',
    signInToSaveWorkBody: 'Create a free account to save files, bookmarks, memory, and generated media. You need an account before you can upgrade or buy credits.',
    upsellTitle: 'Get responses tailored to you',
    upsellBody: 'Log in to get answers based on saved chats, plus create images and upload files.',
    apiDocumentation: 'API Documentation',
    signInToSearchChatsSubtitle: 'Sign in to search your chats, files, and saved items.',
    signInForSettings: 'Sign in to manage settings',
    signInForSettingsSubtitle: 'Create an account to customize your experience, theme, and preferences.',
    signInToStartChat: 'Sign in to start a new chat',
    signInToStartChatSubtitle: 'Create a free account so we can save your conversation and history across devices.',
    signUpOrLogIn: 'Sign Up or Log In',
    logIn: 'Log In',
    connectEmail: 'Connect Email',
    accessFeatures: 'Access all features of Gab AI.',
    alreadyHaveAccount: 'Already have an account? Log in',
    outOfCredits: 'Out of Credits',
    outOfCreditsMessage: 'You\'ve used all your free credits. Sign up for a free account to get more.',
    getFreeMessages: 'Get Free Messages',
    upgradeOrBuy: 'Upgrade to Plus or buy credits to continue.',
    runningLow: 'Running Low!',
    buyCredits: 'Buy Credits',
    upgradeNow: 'Upgrade Now',
    filters: 'Filters',
    actions: 'Actions',
    doneSelecting: 'Done Selecting',
    selectMultiple: 'Select Multiple',
    sort: 'Sort',
    selected: 'selected',
    addToCollection: 'Add to Collection',
    noCollections: 'No Collections',
    done: 'Done',
    viewCollection: 'View Collection',
    featuredModels: 'Featured Models',
    featuredAgents: 'Featured Bots',
    featuredTools: 'Featured Tools',
    seeAllModels: 'See all models',
    seeAllTools: 'See all tools',
    collapseModels: 'Collapse models',
    expandModels: 'Expand models',
    collapseTools: 'Collapse tools',
    expandTools: 'Expand tools',
    getApp: 'Get the Gab AI App',
    downloadGabAiApp: 'Download Gab AI app',
    downloadIosApp: 'Download iOS App',
    downloadAndroidApp: 'Download Android App',
    downloadMacosApp: 'Download macOS App',
    back: 'Back',
    close: 'Close',
    collapse: 'Collapse',
    expand: 'Expand',
    saveFavoriteModelsTitle: 'Save More Favorite Models',
    saveFavoriteModelsSubtitle: 'Upgrade to Plus to save unlimited favorite models and access them quickly anytime.',
    modelRemovedFromFavorites: 'Model removed from favorites',
    modelAddedToFavorites: 'Model added to favorites',
    failedToUnsaveModel: 'Failed to unsave model',
    failedToSaveModel: 'Failed to save model',
    renameCollection: 'Rename Collection',
    renameCollectionSubtitle: 'Enter a new name for this collection',
    collectionNamePlaceholder: 'Collection name',
    deleteCollectionTitle: 'Delete %NAME%',
    deleteCollectionMessage: 'This will permanently delete all collection chats. Subcollections will move up one level. To save chats, move them to your chat list or another collection before deleting.',
    failedToRenameCollection: 'Failed to rename collection',
    failedToDeleteCollection: 'Failed to delete collection',
    collectionIconUpdated: 'Collection icon updated',
    failedToUpdateIcon: 'Failed to update icon',
  },
  forms: {
    password: {
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      fillAllFields: 'Please fill in all password fields',
      passwordsNoMatch: 'New passwords do not match',
      updatedSuccess: 'Password updated successfully',
      updateFailed: 'Failed to update password. Please try again.',
      changePassword: 'Change Password',
      setPassword: 'Set Password',
      setSuccess: 'Password set successfully. You can now sign in with your email and password.',
      setFailed: 'Failed to set password. Please try again.',
      ssoNoPassword: 'Your account was created with social login and does not have a password yet. Set one below to also sign in with your email and password.',
    },
    email: {
      currentEmail: 'Current Email',
      newEmail: 'New Email',
      newEmailPlaceholder: 'New email',
      currentPassword: 'Current Password',
      enterEmail: 'Please enter an email address',
      enterPassword: 'Please enter your current password',
      updatedSuccess: 'Email updated successfully. Please check your new email for verification.',
      updateFailed: 'Failed to update email',
      updateEmail: 'Update Email',
    },
    twoFactor: {
      currentPassword: 'Current Password',
      enableTitle: 'Enable Two-Factor Authentication',
      disableTitle: 'Disable Two-Factor Authentication',
      scanQrStep: 'Scan the QR code below with your authenticator app (e.g., Authy, Google Authenticator).',
      scanQrToast: 'Scan the QR code with your authenticator app',
      qrUnavailable: 'QR code unavailable. Use this URL in your authenticator app:',
      enterCodeStep: 'Enter the 6-digit code from your app to finish enabling.',
      codeLabel: '6-digit code',
      verifyAndEnable: 'Verify & Enable',
      backupCodes: 'Backup Codes',
      backupCodesWarning: 'These codes are shown only once. Store them securely.',
      savedBackupCodes: 'I saved my backup codes',
      status: 'Status:',
      enterPassword: 'Please enter your current password',
      enterCodeError: 'Please enter the 6-digit code from your authenticator app',
      enabledSuccess: 'Two-factor authentication enabled',
      disabledSuccess: 'Two-factor authentication disabled',
      enrollFailed: 'Failed to start MFA enrollment',
      verifyFailed: 'Failed to verify and enable MFA',
      canceledSuccess: 'Enrollment canceled',
      cancelFailed: 'Failed to cancel enrollment',
      disableFailed: 'Failed to disable MFA',
    },
    mfa: {
      verificationCode: 'Verification code',
      missingSession: 'Missing or expired MFA session. Please login again.',
      enterCode: 'Please enter your verification code.',
      verifyAndLogin: 'Verify and login',
      backToLogin: 'Back to login',
      verifyFailed: 'Verification failed. Please try again.',
    },
    memory: {
      placeholder: 'Tell the AI something about yourself...',
      emptyError: 'Memory content cannot be empty',
      charLimitError: 'Memory must be %LIMIT% characters or less',
      createdSuccess: 'Memory created successfully',
      createFailed: 'Failed to create memory',
    },
    task: {
      infoText: 'Tasks run saved prompts on your existing conversations on a schedule. Use them for recurring summaries, reports, or other automations you want to keep running in the background.',
      taskName: 'Task name',
      taskNamePlaceholder: 'Give your task a clear, descriptive name',
      conversation: 'Conversation',
      selectConversation: 'Select conversation',
      model: 'Model',
      selectModel: 'Select model',
      when: 'When',
      selectSchedule: 'Select schedule',
      selectDay: 'Select day',
      selectTime: 'Select time',
      once: 'Once',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      instructions: 'Instructions',
      instructionsPlaceholder: 'Describe what this task should do when it runs.',
      emailDelivery: 'Email Delivery',
      emailMeResults: 'Email me the results',
      whenReceiveEmail: 'When should I receive the email?',
      morningTime: 'Morning (7 AM)',
      afternoonTime: 'Afternoon (12 PM)',
      eveningTime: 'Evening (6 PM)',
      immediately: 'Immediately',
      dangerZone: 'Danger Zone',
      deleteWarning: 'Deleting this task will stop all future scheduled runs. This action cannot be undone.',
      deleteTask: 'Delete Task',
      nameRequired: 'Task name is required',
      nameMinChars: 'Task name must be at least 3 characters',
      instructionsRequired: 'Instructions are required',
      selectDateOnce: 'Please select a date for once schedule',
      setTimeDaily: 'Please set a time of day for daily schedule',
      selectDayWeekly: 'Please select a day of week for weekly schedule',
      setTimeWeekly: 'Please set a time of day for weekly schedule',
      setDayMonthly: 'Please set a day of month for monthly schedule',
      setTimeMonthly: 'Please set a time of day for monthly schedule',
      updatedSuccess: 'Task updated successfully',
      createdSuccess: 'Task created successfully',
      saveFailed: 'Failed to save task',
    },
  },
  chatInput: {
    placeholderDefault: 'Message Gab AI',
    placeholderSendToModels: 'Send message to models',
    placeholderAgentGenerate: 'Generate image with %NAME%',
    placeholderAgentSend: 'Send message with %NAME%',
    placeholderAgentWithModel: 'Send message to %AGENT% with %MODEL%',
    placeholderAgentWithModels: 'Send message to %NAME% with models',
    placeholderModel: 'Send message to %NAME%',
    placeholderInstrumentalMusic: 'Lyrics optional — instrumental mode is on',
    fillRequiredParameters: 'Please fill in all required parameters: %PARAMS%',
    modelRequiresImage: 'This model requires an image to be attached. Please upload an image first.',
    modelRequiresAudio: 'This model requires an audio file to be attached. Please upload an audio file first.',
    unableToVerifyFileTypes: 'Unable to verify allowed file types. Some uploads may be rejected.',
    maxFilesPerMessage: 'You can attach up to %MAX% files per message',
    fileTypeNotAllowed: 'File type not allowed',
    uploadNoFileReturned: 'Upload succeeded but returned no file',
    uploadFailed: 'Failed to upload file',
    listeningPlaceholder: 'Listening...',
    sendMessage: 'Send message',
    stopGenerating: 'Stop generating',
    openComposerTools: 'Add files, tools and parameters',
    missingRequiredParametersHint: 'Required parameters are missing',
    modelRequiresImageBanner: 'This model requires an image. Please attach an image to continue.',
    modelRequiresAudioBanner: 'This model requires an audio file. Please attach audio to continue.',
    disclaimer: 'Gab AI can make mistakes. Check important info.',
    messageControls: 'Message controls',
    required: 'Required',
    prompt: 'Prompt',
    stop: 'Stop',
    send: 'Send',
    fillRequiredBeforeSend: 'Please fill in all required parameters before sending.',
    contextLength: 'Context Length',
    contextLengthSubtitle: 'Model context window limits',
    currentMessageLength: 'Current Message Length',
    tokens: 'tokens',
    modelInputLimit: 'Model Input Limit',
    overLimit: 'Over Limit',
    contextLengthDescription: 'The selected model has a maximum input length of %MAX% tokens. Reduce your message length or attached content to continue.',
    messageOverLimitPre: 'Your message is %PERCENT%% over the ',
    lengthLimit: 'length limit',
    messageOverLimitAttachment: '. Try replacing the attached file with smaller excerpts.',
    messageOverLimitText: '. Try shortening your input.',
    largePromptWarning: 'Large prompt (~%TOKENS% tokens). It may take several minutes to process. Remove duplicate context or split independent tasks for a faster reply.',
    voice: {
      microphoneAccessTitle: 'Microphone access',
      microphoneMessage: 'Gab AI uses your microphone for real-time voice conversations.',
      askMeLater: 'Ask Me Later',
      deny: 'Deny',
      allow: 'Allow',
      microphoneNeededTitle: 'Microphone access needed',
      microphoneNeededSettings: 'Voice mode needs microphone access. Please enable it in Settings.',
      microphoneNeededPrompt: 'Voice mode needs microphone access. Please allow when prompted.',
      microphoneNeededSettingsIos: 'Voice mode needs microphone access. Please allow in Settings.',
      microphoneRequestFailed: 'Could not request microphone access. Please try again.',
      voiceMode: 'Voice Mode',
      plusRequiredTitle: 'Plus required',
      plusRequiredSubtitle: 'Voice Mode requires Gab AI Plus — it uses realtime audio and burns credits quickly.',
    },
    fastMode: {
      onlyForAuto: 'Fast mode only available for Auto',
      onDescription: 'Fast mode on - skips intent engine for faster replies',
      offDescription: 'Fast mode off - intent engine enabled',
      toggleFailed: 'Unable to toggle fast mode. Please try again.',
      tooltipOn: 'Fast mode on - skips intent engine',
      tooltipOff: 'Fast mode - skip intent engine for faster replies',
      on: 'Fast mode on',
      off: 'Fast mode off',
      label: 'Fast mode',
      skipIntentEngine: 'Skips intent engine for faster replies',
      skipIntentEngineOff: 'Skip intent engine for faster replies',
      onlyForAutoModel: 'Only available for Auto model',
    },
    coworkerMode: {
      chat: 'Chat',
      coworker: 'Work',
      beta: 'Beta',
      chooseTitle: 'Choose a mode',
      chatHint: 'Quick answers and conversation',
      workHint: 'Set a goal and get it done with Plus',
      chatTooltip: 'Live replies for questions, search, and brainstorming. Uses less credits.',
      workTooltip: 'Included with Plus. Give Gab a goal and it keeps going: research, tools, files, and finished deliverables. Uses credits.',
      goodFor: 'Good for',
      chatExamples: [
        'Quick questions',
        'Casual chats',
        'Web searches',
      ],
      workExamples: [
        'Multi-step work with an AI bot',
        'Can do almost any task you can think of',
        'Creating or analyzing a file',
      ],
      helpA11y: 'About Chat and Work',
      authTitle: 'Sign in to use Work',
      authSubtitle: 'Hand Gab a goal and it keeps going in the cloud — research, files, and finished drafts you can review and steer.',
    },
    thinkingPower: {
      triggerA11y: 'Thinking power, %LEVEL%',
      tooltip: 'Sets which models Work uses for writing, coding, research, and subagents.',
      title: 'Thinking power',
      axisLeft: 'Faster, cheaper',
      axisRight: 'Smarter, more expensive',
      caption: 'Choose your intelligence. Faster models are cheaper, but not as smart. Standard models are great for most tasks. High models are smarter, but cost more.',
      switchedNextTurn: 'Intelligence set to %LEVEL%. The current step will finish, then specialist work continues at this level.',
      switchedSaved: 'Intelligence set to %LEVEL% for the next run.',
      switchFailed: 'Could not change intelligence. Try again.',
    },
    dictate: {
      microphoneRequiredTitle: 'Microphone Access Required',
      microphoneMessage: 'Gab AI needs microphone access for dictation. Please enable it in Settings.',
      openSettings: 'Open Settings',
      errorTitle: 'Dictation Error',
      startFailed: 'Failed to start dictation',
      dictate: 'Dictate',
      starting: 'Starting mic…',
      listening: 'Listening',
      transcribing: 'Transcribing…',
      cancel: 'Cancel dictation',
      finish: 'Finish and transcribe',
      finishHint: 'Enter to finish, Esc to cancel',
      timeLeft: '%TIME% left',
      noSpeech: "Didn't catch anything. Try again a bit closer to the mic.",
      tooShort: 'That was too short to transcribe. Hold for a moment longer.',
    },
    files: {
      analyzing: 'Analyzing...',
      processing: 'Processing...',
      failed: 'Failed',
      cameraPermissionRequired: 'Camera permission required',
      cameraDisabled: 'Camera access is disabled. Opening Settings...',
      cameraPermission: 'Camera permission is required to take photos',
      photoLibraryPermissionRequired: 'Photo library permission required',
      photoLibraryDisabled: 'Photo library access is disabled. Opening Settings...',
      photoLibraryPermission: 'Photo library permission is required to select photos',
      pickFromPhotosFailed: 'Failed to pick from photos',
      takePhotoFailed: 'Failed to take photo',
      pickDocumentFailed: 'Failed to pick document',
      pickFileFailed: 'Failed to pick file',
      attachFile: 'Attach file',
      selectFromLibrary: 'Select from library',
      selectFromLibrarySubtitle: 'Choose from your uploaded files',
      selectLabel: 'Select',
      addPhotosAndFiles: 'Add photos & files',
      uploadFile: 'Upload a file',
      uploadSubtitle: 'Documents, photos, audio, or video · Max 50 MB',
      screenCaptureNotSupported: 'Screen capture is not supported in this browser',
      screenshotsNotAllowed: 'Screenshots are not an allowed file type',
      screenshotTypeNotAllowed: 'Screenshot type not allowed',
      screenCaptureCanceled: 'Screen capture was canceled',
      screenshotCaptureFailed: 'Failed to capture screenshot',
      attachmentsUnavailable: 'Attachments unavailable in the current context',
      actionSheetTitle: 'Add to your message',
      actionSheetCancel: 'Cancel',
      actionSheetTakePhoto: 'Take Photo',
      actionSheetTakeVideo: 'Take Video',
      actionSheetChooseFromPhotos: 'Choose from Photos',
      actionSheetChooseFromLibrary: 'Choose from Library',
      actionSheetBrowseFiles: 'Browse Files',
      actionSheetPasteFromClipboard: 'Paste from Clipboard',
      pasteFromClipboard: 'Paste screenshot',
      pasteFromClipboardSubtitle: 'Attach the image currently on your clipboard',
      pastingImage: 'Pasting image…',
      noClipboardImage: 'No image found on the clipboard',
    },
    tools: {
      webSearch: 'Web search',
      webSearchDescription: 'Search the web for current information',
      studyAndLearn: 'Study & learn',
      studyAndLearnDescription: 'Deep research and analysis',
      notAvailableForMedia: 'Not available for image/video/music',
      removeAttachmentsToSearch: 'Remove attachments to search',
      modelsNoTextSupport: 'Selected models don\'t support text generation',
      unavailableInContext: 'Tool unavailable in the current context',
      removeAttachmentsForImage: 'Remove attachments to create an image',
      modelsNoImageSupport: 'Selected models don\'t support image generation',
      toolsUnavailable: 'Tools unavailable in the current context',
      parametersUnavailable: 'Parameters unavailable in the current context',
      notSupported: 'Not supported',
    },
    credits: {
      label: 'credits',
      buyMore: 'Buy more',
      tooltip: 'Credits',
      insufficientCredits: 'You don\'t have enough credits for this message.',
      getMoreCredits: 'Get more credits →',
      creditsLeft: '%COUNT% credits left',
      runningLow: 'Running low: %COUNT% credits remaining',
      getCredits: 'Get Credits',
      getCreditsLink: 'Get Credits →',
      outOfCreditsShort: 'Out of credits!',
      outOfCredits: 'You\'re out of credits',
      orUpgrade: 'or Upgrade',
      upgradeNow: 'Upgrade Now →',
      getFreeMessages: 'Get Free Messages →',
      outOfCreditsUpgrade: 'You\'re out of credits. Upgrade for free default model messages.',
      runningLowPlus: 'Running low: %COUNT% credits remaining. With Plus, default model messages are free!',
      getFreeMessagesTitle: 'Get Free Messages',
      getFreeMessagesSubtitle: `Stop paying 1 credit per message - upgrade to Plus for free default model access and ${PLUS_MONTHLY_CREDITS_DISPLAY} monthly credits.`,
      signInToCreate: 'Sign in to start creating for free',
      signInToCreateShort: 'Sign in to start creating',
      signInToCreateSubtitle: 'Create a free account to chat, generate images, and use every tool.',
      verifyForCredits: 'Verify your email to unlock %BONUS% more free credits.',
      verifyForCreditsShort: 'Unlock %BONUS% more credits — verify your email',
      verifyOutOfCredits: 'You\'re out of credits. Verify your email to unlock %BONUS% more.',
      verifyOutOfCreditsShort: 'Out of credits — verify email for %BONUS% more',
      verifyEmailLink: 'Unlock credits →',
      verifyToStart: 'Verify your email to get your account ready for chatting.',
      verifyToStartLink: 'Verify email →',
    },
    upgradeBanner: {
      isXS: [
        'Unlock Work mode with Plus.',
        'Give bigger jobs to Work mode.',
        'Plus turns prompts into finished work.',
        `Work mode + ${PLUS_MONTHLY_CREDITS_DISPLAY} credits/month.`,
        'Plan, research, and deliver with Work mode.',
      ],
      default: [
        'Unlock Work mode with Plus—AI agents that plan, research, use tools, and deliver.',
        'Have a bigger job? Plus turns on Work mode and keeps going to a finished result.',
        `Work mode + ${PLUS_MONTHLY_CREDITS_DISPLAY} monthly credits. Upgrade to Plus.`,
        'Move from a quick chat to finished work with Work mode, included with Plus.',
        'Give Gab a goal. Work mode researches, uses files and tools, and gets it done.',
      ],
      upgradeLink: 'Unlock Work →',
    },
    conversationContext: {
      ctaTitles: [
        { pre: 'This chat is getting long — older messages will be condensed into a running summary so you can keep going. Prefer a clean slate? Start a ', post: '.' },
        { pre: 'Heads up: we will start summarizing earlier messages soon to keep this chat going. Want a fresh start instead? Open a ', post: '.' },
        { pre: 'You can keep going as long as you want — older messages will be summarized to save space. Or start a ', post: ' anytime.' },
        { pre: 'No need to stop here. Older parts of this chat will be auto-summarized so the gist sticks around. A ', post: ' is also one click away if you prefer.' },
        { pre: 'This thread is getting long. We will compress earlier messages into a summary so nothing important gets lost. Or jump to a ', post: '.' },
      ],
      mobileCta: { pre: 'This chat is getting long — older messages will be summarized so you can keep going. Or open a ', post: '.' },
      newChat: 'new chat',
    },
    ghost: {
      connectEmailMessage: 'Connect your email to save & continue your conversations.',
      connectEmailLink: 'Connect email now →',
    },
    authCta: {
      bannerMessage: 'You\u2019re browsing as a guest \u2014 sign up to keep your chat history.',
      bannerLink: 'Sign up now \u2192',
      modalTitle: 'Sign in to start chatting',
      modalSubtitle: 'Create a free account so we can save your conversation, files, and history across devices.',
      uploadTitle: 'Sign in to upload files',
      uploadSubtitle: 'Create a free account to attach files to your messages and keep a personal library.',
      libraryTitle: 'Sign in to use your library',
      librarySubtitle: 'Create a free account to save files and pick them back up in any chat.',
      creditsTitle: 'Sign in to buy credits',
      creditsSubtitle: 'Create a free account to purchase and use credits across conversations.',
      dictateTitle: 'Sign in to dictate',
      dictateSubtitle: 'Voice-to-text needs an account so we can run transcription securely.',
      voiceTitle: 'Sign in for voice mode',
      voiceSubtitle: 'Voice mode connects to a realtime backend that requires an account.',
      fastModeTitle: 'Sign in to use Fast mode',
      fastModeSubtitle: 'Fast mode is a per-user preference \u2014 sign in to save your choice.',
    },
    toggle: {
      enabled: 'Enabled',
      disabled: 'Disabled',
    },
    dateRange: {
      chooseDateRange: 'Choose a date range',
      start: 'Start',
      end: 'End',
      selectStartDate: 'Select start date',
      selectEndDate: 'Select end date',
    },
    models: {
      tooltip: 'Models',
      auto: 'Auto',
      label: 'Models',
    },
  },
  pages: {
    common: {
      retry: 'Retry',
      searchResults: 'Search Results',
      grid: 'Grid',
      list: 'List',
      newestFirst: 'Newest first',
      oldestFirst: 'Oldest first',
      nameAZ: 'Name (A-Z)',
      nameZA: 'Name (Z-A)',
      allFiles: 'All Files',
      chat: 'Chat',
      move: 'Move',
      remove: 'Remove',
      all: 'All',
      connectionError: 'Please check your internet connection and try again.',
      filesSelected: '%COUNT% files selected',
      fileSelected: '%COUNT% file selected',
      chatsSelected: '%COUNT% chats selected',
      chatSelected: '%COUNT% chat selected',
      select: 'Select',
    },
    messages: {
      actions: {
        startNewChat: 'Start a new chat',
      },
    },
    collections: {
      title: 'Collections',
      description: 'Organize and manage your AI chat collections.',
      viewDescription: 'View and manage your AI chat collection.',
      notFound: 'Collection not found',
      goToFiles: 'Go to Files',
      settings: 'Settings',
      chats: 'Chats',
      sources: 'Sources',
      noChatsYet: 'No chats yet',
      newChatPlaceholderNamed: 'New chat in %NAME%',
      chatsStayOrganized: 'Chats stay organized',
      chatsStayOrganizedDesc: 'Start a chat from this collection to keep it organized here.',
      chatWithFiles: 'Chat with your files',
      chatWithFilesDesc: 'Add files and Gab AI can reference them in any chat.',
      renamed: 'Collection renamed',
      deleteTitle: 'Delete %NAME%',
      deleteMessage: 'This will permanently delete the collection and its chats. Subcollections will move up one level. Files will remain in your library.',
      deleted: 'Collection deleted',
      deleteFailed: 'Failed to delete collection',
      subcollections: 'Subcollections',
      newSubcollection: 'New subcollection',
      moveCollection: 'Move collection',
      moveToRoot: 'Top level',
      moved: 'Collection moved',
      moveFailed: 'Failed to move collection',
      nestedTooDeep: 'Collections can only be nested 5 levels deep.',
      instructionsUpdated: 'Custom instructions updated',
      instructionsUpdateFailed: 'Failed to update instructions',
      customInstructions: 'Custom instructions',
      tailorResponses: 'Tailor AI responses in this collection',
      addFiles: 'Add files',
      attachFiles: 'Attach files for AI to reference',
      filesInCollection: '%COUNT% files in collection',
      fileInCollection: '%COUNT% file in collection',
      files: 'Files',
      noFilesYet: 'No files in this collection yet',
      newChatPlaceholder: 'New chat in this collection',
      startChat: 'Start Chat in Collection',
      createFailed: 'Failed to create conversation',
      removeFilesTitle: 'Remove %COUNT% Files from Collection',
      removeFileTitle: 'Remove %COUNT% File from Collection',
      removeFilesMessage: 'Are you sure you want to remove %COUNT% files from this collection? The files will remain in your library.',
      removeFileMessage: 'Are you sure you want to remove %COUNT% file from this collection? The files will remain in your library.',
      filesRemoved: '%COUNT% files removed from collection',
      fileRemoved: '%COUNT% file removed from collection',
      removeFilesFailed: 'Failed to remove %COUNT% files',
      removeFileFailed: 'Failed to remove %COUNT% file',
      removePartial: 'Removed %SUCCESS% files, %FAIL% failed',
      removePartialSingle: 'Removed %SUCCESS% file, %FAIL% failed',
      noCollections: 'No collections found',
      iconUpdated: 'Collection icon updated',
      iconUpdateFailed: 'Failed to update icon',
      memory: 'Memory',
      memoryOn: 'Memory on',
      memoryOff: 'Memory off',
      memoryDescription: 'Use account memories in this collection',
      memoryEnabled: 'Memory enabled for this collection',
      memoryDisabled: 'Memory disabled for this collection',
      memoryUpdateFailed: 'Failed to update memory setting',
      memoryLoadFailed: 'Failed to load collection memories',
      memorySettings: 'Memory settings',
      memorySettingsDesc: 'Choose what chats in %NAME% can read. Either way, anything they learn is saved here and stays out of your other chats.',
      memoryModeAccount: 'Account memory',
      memoryModeAccountDesc: 'Read your account memories as well as this collection\'s.',
      memoryModeCollection: 'Collection memory',
      memoryModeCollectionDesc: 'Read only this collection\'s memories — nothing personal carries in.',
      memoryModeOff: 'Memory off',
      memoryModeOffDesc: 'Do not use or save memories in this collection.',
      memoryModeCollectionEnabled: 'This collection now uses its own memory',
      collectionMemories: 'Collection memories',
      collectionMemoryPlaceholder: 'Add a fact that should only apply in this collection...',
      noCollectionMemories: 'No collection memories yet. Add one above, or say “remember this” in a chat here.',
      createTask: 'Create task',
      createTaskDescription: 'Schedule an automated task using this collection',
      tasks: 'Tasks',
      selectChats: 'Select chats',
      doneSelecting: 'Done',
      deleteChatsTitle: 'Delete %COUNT% chats?',
      deleteChatTitle: 'Delete %COUNT% chat?',
      deleteChatsMessage: 'These chats will be permanently deleted. This cannot be undone.',
      archiveChatsTitle: 'Archive %COUNT% chats?',
      archiveChatTitle: 'Archive %COUNT% chat?',
      unarchiveChatsTitle: 'Unarchive %COUNT% chats?',
      unarchiveChatTitle: 'Unarchive %COUNT% chat?',
      removeChatsTitle: 'Remove %COUNT% chats from collection?',
      removeChatTitle: 'Remove %COUNT% chat from collection?',
      removeChatsMessage: 'The chats will be removed from this collection. They will remain in your library.',
      chatsRemovedFromCollection: '%COUNT% chats removed from collection',
      chatRemovedFromCollection: '%COUNT% chat removed from collection',
      chatsMovedToCollection: '%COUNT% chats moved to %NAME%',
      chatMovedToCollection: '%COUNT% chat moved to %NAME%',
      moveChatsFailed: 'Failed to move chats to collection',
      moveChatFailed: 'Failed to move chat to collection',
      removeChatsFailed: 'Failed to remove %COUNT% chats from collection',
      removeChatFailed: 'Failed to remove %COUNT% chat from collection',
      removeChatsPartial: 'Removed %SUCCESS% chats, %FAIL% failed',
      chatsArchived: 'Archived %COUNT% chats',
      chatArchived: 'Archived %COUNT% chat',
      chatsUnarchived: 'Unarchived %COUNT% chats',
      chatUnarchived: 'Unarchived %COUNT% chat',
      chatsDeleted: 'Deleted %COUNT% chats',
      chatDeleted: 'Deleted %COUNT% chat',
      noMessages: 'No messages',
    },
    bookmarks: {
      title: 'Bookmarks',
      description: 'Your saved messages from across all conversations.',
      emptyTitle: 'No bookmarks yet',
      emptyDescription: 'Bookmarks let you save important messages from any conversation so you can quickly find them later.',
      emptyHowTitle: 'How to save a bookmark',
      emptyStep1Title: 'Open any conversation',
      emptyStep1Description: 'Find a message you want to come back to later.',
      emptyStep2Title: 'Tap the bookmark icon',
      emptyStep2Description: 'Use the bookmark action under the message to save it.',
      emptyStep3Title: 'Manage them here',
      emptyStep3Description: 'View, search, and organize your saved messages into folders.',
      fromChat: 'From: %TITLE%',
      unsave: 'Remove bookmark',
      unsaveConfirm: 'Are you sure you want to remove this bookmark?',
      viewMessage: 'View message',
      openChat: 'Open conversation',
      savedCount: '%COUNT% saved messages',
      allBookmarks: 'All Bookmarks',
      folders: 'Folders',
      newFolder: 'New Folder',
      folderName: 'Folder name',
      renameFolder: 'Rename Folder',
      changeIcon: 'Change Icon',
      deleteFolder: 'Delete Folder',
      deleteFolderMessage: 'This will delete the folder. Your bookmarks will not be removed. Subfolders will move up one level.',
      addToFolder: 'Add to Folder',
      removeFromFolder: 'Remove from Folder',
      moveToFolder: 'Move to Folder',
      newSubfolder: 'New Subfolder',
      moveFolder: 'Move Folder',
      moveToRoot: 'Top level',
      nestedTooDeep: 'Folders can only be nested 5 levels deep.',
      folderMoved: 'Folder moved',
      moveFolderFailed: 'Failed to move folder',
      noFolders: 'No folders yet',
      newest: 'Newest first',
      oldest: 'Oldest first',
      searchPlaceholder: 'Search bookmarks...',
      noSearchResults: 'No bookmarks found for "%QUERY%"',
      emptyFolderTitle: 'This folder is empty',
      emptyFolderDescription: 'Add bookmarks to this folder to organize them.',
      emptyMagazineKicker: 'YOUR LIBRARY',
      emptyMagazineHeadline: 'Save replies worth keeping.',
      emptyMagazineLead:
        'Bookmark answers, prompts, and snippets from any chat — then search and organize them here.',
      emptyMagazineReason1: 'Keep replies you want to revisit',
      emptyMagazineReason2: 'Build a personal idea library',
      emptyMagazineReason3: 'Group related saves into folders',
      emptyMagazineReason4: 'Jump back to the original chat in one click',
      emptyMagazinePreviewLabel: 'PREVIEW',
      emptyMagazineTapHint: 'In a chat, tap:',
      emptyMagazineTapThis: 'Tap this',
      emptyMagazineSampleTitle: 'How to debounce a search input cleanly',
      emptyMagazineSampleSnippet:
        'Use a tiny `useDebouncedValue` hook backed by `useEffect` + `setTimeout`. Don\'t debounce the state setter directly — debounce the effect that consumes the value.',
      emptyMagazineSampleChat: 'React patterns',
      emptyMagazineSampleModel: 'Claude 3.5 Sonnet',
      emptyMagazineSampleDate: 'May 7',
      itemCount: '%COUNT% items',
      selectFolder: 'Select a folder',
      createNewFolder: 'Create a new Bookmark Folder',
      addedToFolder: 'Added to %FOLDER%',
      addToFolderFailed: 'Failed to add to folder',
    },
    files: {
      title: 'Files',
      description: 'Browse and manage your files. Organize your documents, images, and other files in one place.',
      searchPlaceholder: 'Search files...',
      upload: 'Upload',
      newCollection: 'New Collection',
      loadingFiles: 'Loading files...',
      errorLoading: 'Error loading files: %ERROR%',
      noFilesFound: 'No files found matching "%QUERY%".',
      deleteFilesTitle: 'Delete %COUNT% Files',
      deleteFileTitle: 'Delete %COUNT% File',
      deleteFilesMessage: 'Are you sure you want to delete %COUNT% files? This action cannot be undone.',
      deleteFileMessage: 'Are you sure you want to delete %COUNT% file? This action cannot be undone.',
      deletedFiles: '%COUNT% files deleted successfully',
      deletedFile: '%COUNT% file deleted successfully',
      deleteFilesFailed: 'Failed to delete %COUNT% files',
      deleteFileFailed: 'Failed to delete %COUNT% file',
      deletePartial: 'Deleted %SUCCESS% files, %FAIL% failed',
      deletePartialSingle: 'Deleted %SUCCESS% file, %FAIL% failed',
      addedToCollection: 'Files added to collection',
      allTypes: 'All types',
      includeGenerated: 'Include generated files',
      documents: 'Documents',
      images: 'Images',
      audio: 'Audio',
      code: 'Code',
      searchTitle: 'Search Files',
      searchDescription: 'Search through your uploaded files. Find documents, images, and other files by name or type.',
      searchPlaceholderFull: 'Search Files',
      searchEmptyTitle: 'Find your files',
      searchEmptySubtitle: 'Search by name or type to find documents, images, and more.',
      searchEmptyMessage: 'Search for files',
    },
    memory: {
      title: 'Memory',
      description: 'Manage your AI\'s personalized memory.',
      eyebrow: 'AI Memory & Knowledge',
      headline: 'A little more you.',
      subtitle: 'Your preferences, your context, your way of working. Help Gab remember what matters to you.',
      exportMemories: 'Export memories',
      copiedToClipboard: 'Copied to clipboard',
      allMemoriesExported: 'Copied %COUNT% memories to clipboard',
      totalMemories: 'Total memories',
      learnedCount: 'Learned by AI',
      manualCount: 'Added by you',
      recentCount: 'Past 7 days',
      statusActive: 'Active in chats',
      statusPaused: 'Memory paused',
      statusLearning: 'Learning enabled',
      filterLearned: 'Learned by AI',
      filterRecent: 'Recent (7d)',
      sortAlphabetical: 'Alphabetical',
      preferencesTitle: 'Memory Controls',
      preferencesDesc: 'Choose what Gab remembers and when it learns.',
      showOverview: 'Read full overview',
      showLess: 'Show less',
      savedMemories: 'Your memories',
      resultCount: '%COUNT% of %TOTAL% memories',
      learningPaused: 'Learning paused',
      saveShortcut: '⌘ / Ctrl + Enter to save · Esc to cancel',
      bulkDeletePartial: 'Deleted %SAVED% memories. %FAILED% could not be deleted and remain selected for retry.',
      quickAddTitle: 'Teach Gab something new',
      quickAddSubtitle: 'Add preferences, work background, or specific guidelines you want Gab to remember.',
      inspirationTitle: 'Suggestions to try:',
      inspiration1: 'I prefer concise, bullet-point answers',
      inspiration2: 'I am a software engineer',
      inspiration3: 'Always explain the "why" behind recommendations',
      inspiration4: 'Give practical code examples when explaining concepts',
      inspiration5: 'Avoid fluffy intros and dive right into solutions',
      copyMemory: 'Copy memory',
      copied: 'Copied',
      livingProfile: 'Living Knowledge Profile',
      livingProfileDesc: 'What Gab has learned about you, at a glance.',
      useInConversations: 'Use memories in conversations',
      useInConversationsDesc: 'When enabled, the AI references your saved memories during conversations for more personalized responses.',
      learnFromConversations: 'Learn from conversations',
      learnFromConversationsDesc: 'Automatically save durable facts from your chats in the background. Saying "remember …" in a conversation always saves instantly, even when this is off. Anything it learns shows up below, where you can edit or delete it.',
      learnFromConversationsDescFree: 'Say "remember" to save facts instantly. Background review of your chats — where Gab quietly updates what it knows — is included with Gab AI Plus.',
      learnPlusUpsell: 'Upgrade to Plus for background learning',
      profileSummaryTitle: 'Memory overview',
      profileSummaryHint: 'You’re in control. Edit this overview or update any memory below.',
      profileSummaryPending: 'Gab AI reviews your recent chats in the background and updates your memory within a few hours of a real conversation. Keep chatting, or write your own overview now.',
      profileSummaryEmpty: 'No overview yet. Write a short summary of who you are so Gab can start from your version.',
      profileSummaryEdit: 'Edit overview',
      profileSummaryWrite: 'Write overview',
      profileSummarySave: 'Save overview',
      profileSummarySaved: 'Memory overview updated',
      profileSummarySaveFailed: 'Failed to update memory overview',
      profileSummaryPlaceholder: 'Who you are, what you do, what you care about…',
      profileSummaryBadgeAi: 'AI Consolidated',
      profileSummaryBadgeUser: 'Edited by you',
      profileSummaryBadgePending: 'Synthesizing',
      recentlyLearned: 'Recently learned',
      recentlyLearnedHint: 'Facts Gab saved or updated from your conversations in the last 7 days.',
      selectThese: 'Select these',
      addMemory: 'Add a Memory',
      guidedSetup: 'Guided Setup',
      importFromAI: 'Import from Another AI',
      inputPlaceholder: 'Enter something you\'d like the AI to remember...',
      yourMemories: 'Your Memories',
      manualSection: 'Added by you',
      learnedSection: 'Learned from conversations',
      memoryEnabled: 'Memory enabled for conversations',
      memoryDisabled: 'Memory disabled for conversations',
      memoryPrefFailed: 'Failed to update memory preference',
      autoGenEnabled: 'Auto-generation enabled',
      autoGenDisabled: 'Auto-generation disabled',
      learnEnabled: 'Learning from conversations enabled',
      learnDisabled: 'Learning from conversations disabled',
      prefUpdateFailed: 'Failed to update preference',
      charLimitError: 'Memory must be %LIMIT% characters or less',
      created: 'Memory created successfully',
      createFailed: 'Failed to create memory',
      updated: 'Memory updated successfully',
      updateFailed: 'Failed to update memory',
      deleted: 'Memory deleted successfully',
      deleteFailed: 'Failed to delete memory',
      loadFailed: 'Failed to load memories',
      searchPlaceholder: 'Search memories...',
      filterAll: 'All',
      filterManual: 'Manual',
      filterAutoGenerated: 'Auto-generated',
      deleteConfirmTitle: 'Delete Memory',
      deleteConfirmMessage: 'Are you sure you want to delete this memory? This action cannot be undone.',
      bulkDeleteTitle: 'Delete %COUNT% Memories',
      bulkDeleteMessage: 'Are you sure you want to delete %COUNT% memories? This action cannot be undone.',
      bulkDeleted: '%COUNT% memories deleted',
      bulkDeleteFailed: 'Failed to delete some memories',
      manualMemories: 'Manual',
      autoGeneratedMemories: 'Auto-generated',
      memoriesSelected: '%COUNT% selected',
      memorySelected: '%COUNT% selected',
      selectAll: 'Select All',
      clearSelection: 'Clear',
      bulkDelete: 'Delete',
      fromConversation: 'From conversation',
      quickAddHint: 'Tip: Use Guided Setup or Import for faster setup',
      suggestionsBannerTitle: 'New memory suggestions',
      suggestionsBannerSingle: '1 suggestion awaiting your review',
      suggestionsBannerMultiple: '%COUNT% suggestions awaiting your review',
      suggestionsReview: 'Review',
      suggestionsHide: 'Hide',
      suggestionAccept: 'Accept',
      suggestionDismiss: 'Dismiss',
      suggestionUpdates: 'Updates existing memory',
      suggestionAccepted: 'Memory suggestion accepted',
      suggestionDismissed: 'Suggestion dismissed',
      suggestionActionFailed: 'Something went wrong',
      suggestionMerge: 'Merge',
      suggestionAddNew: 'Add as New',
      suggestionMerged: 'Memories merged successfully',
      emptySearchTitle: 'No memories match your search',
      emptySearchDescription: 'Try a different keyword, or adjust your filters.',
      emptySearchTip1: 'Search matches text inside memories, not labels',
      emptySearchTip2: 'Try shorter or partial words',
      emptySearchTip3: 'Check your filter isn\'t hiding results',
      emptyFilterTitle: 'No memories in this view',
      emptyFilterDescription: 'Try a different filter or clear your search.',
      clearSearchAndFilters: 'Clear search & filters',
    },
    workflows: {
      title: 'AI Workflows',
      description: 'Chain AI models and tools into automated pipelines. No code required.',
      heroTitle: 'Workflows',
      heroSubtitle: 'Connect AI models + tools into powerful automated workflows. Text, image, video, audio — all in one place with no code required.',
      newWorkflow: 'New workflow',
      newWorkflowFromTemplate: 'Start from template',
      newBlankWorkflow: 'Blank workflow',
      noWorkflowsYet: 'You don\'t have any workflows yet.',
      noWorkflowsCta: 'Start from a template or create a blank workflow to begin.',
      browseTemplates: 'Browse templates',
      yourWorkflows: 'Your workflows',
      featuredTemplates: 'Featured templates',
      runNow: 'Run',
      running: 'Running…',
      lastRun: 'Last run',
      neverRun: 'Never run',
      runsCount: '%COUNT% runs',
      runsCountSingle: '%COUNT% run',
      stepsCount: '%COUNT% steps',
      stepsCountSingle: '%COUNT% step',
      cancel: 'Cancel run',
      runHistoryTitle: 'Run history',
      runHistoryEmpty: 'No runs yet — hit Run to start one.',
      runDetailTitle: 'Run #%ID%',
      runStatusPending: 'Pending',
      runStatusRunning: 'Running',
      runStatusCompleted: 'Completed',
      runStatusFailed: 'Failed',
      runStatusCancelled: 'Cancelled',
      stepStatusPending: 'Pending',
      stepStatusRunning: 'Running',
      stepStatusCompleted: 'Completed',
      stepStatusFailed: 'Failed',
      stepStatusSkipped: 'Skipped',
      stepDuration: '%MS% ms',
      stepCreditCost: '%COUNT% credits',
      durationMs: '%MS% ms',
      durationSec: '%SEC% s',
      totalCost: 'Total cost: %COUNT% credits',
      promptToRun: 'Fill in the inputs below, then hit Run.',
      noPublicInputs: 'This workflow runs as-is — no inputs required.',
      saved: 'Saved',
      savedJustNow: 'Saved just now',
      saving: 'Saving…',
      unsavedChanges: 'Unsaved changes',
      saveChanges: 'Save changes',
      deleteWorkflow: 'Delete workflow',
      deleteConfirm: 'Delete this workflow? This can\'t be undone.',
      runFailed: 'Run failed',
      runStarted: 'Run started',
      runCompleted: 'Run completed',
      mobileEditUnavailable: 'The visual editor is web-only',
      mobileEditUnavailableDescription: 'Open this workflow on the web to edit the canvas. You can still run it and view its history here on mobile.',
      openOnWeb: 'Open on web',
      backToWorkflows: 'Back to workflows',
      addNode: 'Add node',
      nodeTypeModel: 'Model',
      nodeTypeTool: 'Tool',
      nodeTypeOutput: 'Output',
      nodeTypeTransform: 'Transform',
      nodeTypeCondition: 'Condition',
      nodeTypeTemplate: 'Template',
      nodeTypeCode: 'Code',
      nodeTypeHttp: 'HTTP',
      nodeTypeDelay: 'Delay',
      nodeTypeNote: 'Note',
      nodeTypeMemory: 'Memory',
      nodeTypeEmail: 'Email',
      nodeTypeFile: 'File',
      nodeTypeConversation: 'Chat',
      nodeTypeParser: 'Parser',
      nodeTypeSwitch: 'Switch',
      nodeTypeMerge: 'Merge',
      nodeTypeLoop: 'Loop',
      autoLayout: 'Auto layout',
      nodeProperties: 'Node properties',
      noNodeSelected: 'Select a node to configure it',
      labelField: 'Label',
      modelField: 'Model',
      promptField: 'Prompt template',
      promptHelp: 'Use {{trigger.fieldName}} for inputs and {{nodeId.text}} for upstream outputs.',
      systemPromptField: 'System prompt',
      paletteTitle: 'Add nodes',
      paletteHint: 'Drag a node onto the canvas, or click to insert at center.',
      pickModel: 'Pick a model',
      pickTool: 'Pick a tool',
      noModelSelected: 'No model selected',
      noToolSelected: 'No tool selected',
      seeRun: 'View run',
      seeAllRuns: 'View all runs',
      gridView: 'Grid',
      listView: 'List',
      premium: 'Plus',
      requiresPlus: 'Requires Gab AI Plus',
    },
    tools: {
      title: 'AI Tools',
      description: 'Single-purpose AI tools for content creation, analysis, and more.',
      heroTitle: 'AI Tools',
      heroSubtitle: 'Specialized assistants for one-off tasks. Fill out the form, get a result, then optionally continue in chat.',
      heroEyebrow: 'Gab AI Tools',
      heroHeadline: 'AI tools that do one job well.',
      heroLead: 'Purpose-built tools for writing, images, video, music, code, and analysis. Fill in a few fields, get a finished result, then keep going in chat.',
      categoryEyebrow: 'Tool category',
      categoryTools: '%NAME% tools',
      featuredSubtitle: 'Hand-picked by the Gab AI team',
      toolsCount: '%COUNT% tools',
      toolsCountSingle: '1 tool',
      searchPlaceholder: 'Search tools…',
      requestTool: 'Request a Tool',
      requestToolPrefill: "I'd like to request a new AI tool for:\n\n(Describe the task, inputs, and output you need.)",
      featured: 'Featured',
      allTools: 'All tools',
      catalogSort: 'Sort tools',
      catalogSortRelevant: 'Relevant',
      catalogSortPopular: 'Popular',
      catalogSortNameAsc: 'Name A–Z',
      catalogSortNameDesc: 'Name Z–A',
      catalogSortCategory: 'By category',
      badgeNew: 'New',
      badgeBeta: 'Beta',
      myFavorites: 'My favorites',
      noFavoriteToolsMatch: 'No saved favorites match this filter.',
      noFavoriteToolsYet: 'Save tools with the heart to see them here.',
      allRuns: 'All runs',
      selectRun: 'Select a run to view its result.',
      noResultsForQuery: 'No tools match your search.',
      noSearchResultsRecommend: 'No results for your search but check these out',
      noToolsYet: 'No tools available yet.',
      notFound: 'Tool not found.',
      browseTools: 'Browse tools',
      recentRuns: 'Recent runs',
      relatedTools: 'Related tools',
      tryPreset: 'Try a preset',
      usePreset: 'Use this preset',
      presetsCount: '%COUNT% presets',
      presetsCountSingle: '%COUNT% preset',
      runsCount: '%COUNT% runs',
      runsCountSingle: '%COUNT% run',
      moreFields: '+ %COUNT% more fields',
      moreFieldsSingle: '+ %COUNT% more field',
      viewing: 'Viewing',
      viewAllRuns: 'View all runs',
      noRunsHint: 'No runs yet. Your past results will appear here so you can revisit, re-run, or continue them in chat.',
      noPresetsAvailable: 'No presets available for this tool.',
      examples: 'Examples',
      example: 'Example',
      preset: 'Preset',
      configureSection: 'Configure',
      resultSection: 'Result',
      howItWorks: 'How it works',
      howStepConfigureTitle: 'Configure',
      howStepConfigureCopy: 'Fill in the inputs — try a preset to see how it works.',
      howStepRunTitle: 'Run',
      howStepRunCopy: 'Tap Run. We\u2019ll handle the model selection and processing.',
      howStepContinueTitle: 'Continue in chat',
      howStepContinueCopy: 'Refine, remix, or build on your result in a fresh chat.',
      fillFormHint: 'Fill in the form and tap Run. You can re-run as many times as you like — every result is saved below.',
      history: 'Tool history',
      historyTitle: 'Tool history',
      historyDescription: 'Past results from every tool you\u2019ve run.',
      historyHeroTitle: 'Your tool history',
      historyHeroSubtitle: 'Every run, in one place. Jump back to any tool with the same inputs to tweak, re-run, or continue where you left off.',
      historyAllTools: 'All tools',
      historyLoading: 'Loading your runs\u2026',
      historyEmptyTitle: 'Nothing here yet',
      historyEmptyCopy: 'Run any tool and your results will land here automatically \u2014 ready to revisit, remix, or re-run with one click.',
      historyNoMatches: 'No runs match these filters.',
      historyNoSearchMatches: 'No runs match \u201c%QUERY%\u201d.',
      historyClearFilters: 'Clear filters',
      historySearchPlaceholder: 'Search by tool, prompt, or result\u2026',
      historyFilters: 'Filters',
      historyFilterByStatus: 'Status',
      historyToolsEyebrow: 'Tools',
      historySort: 'Sort',
      historySortNewest: 'Newest first',
      historySortOldest: 'Oldest first',
      historyViewGrid: 'Grid view',
      historyViewList: 'List view',
      deleteRun: 'Delete run',
      deleteRunTitle: 'Delete this run?',
      deleteRunMessage: 'This removes the run from your history for %TOOL%. You cannot undo this.',
      deleteRunUnknownTool: 'this tool',
      historySectionToday: 'Today',
      historySectionYesterday: 'Yesterday',
      historySectionThisWeek: 'This week',
      historySectionThisMonth: 'This month',
      historySectionEarlier: 'Earlier',
      statTotalRuns: 'Total runs',
      statCompleted: 'Completed',
      statFailed: 'Failed',
      statInFlight: 'In flight',
      statCredits: 'Credits used',
      statusFilter_all: 'All',
      statusFilter_completed: 'Completed',
      statusFilter_failed: 'Failed',
      statusFilter_running: 'In flight',
      openInTool: 'Open in tool',
      chooseModel: 'Choose model',
      chooseModels: 'Choose models',
      modelPickerLabel: 'Run with model',
      modelPickerMultiLabel: 'Pick models to compare',
      modelFieldLabel: 'Model',
      modelsFieldLabel: 'Models',
      modelsPickedCount: '%PICKED% of %MAX%',
      modelExtraPicked: '+%COUNT% more',
      defaultModel: 'Default',
      resetTool: 'Reset',
      modelLabel: 'Model: %NAME%',
      modelsLabel: 'Models: %NAMES%',
      creditsUsedLabel: 'Credits used: %COUNT%',
      runButton: 'Run',
      runningButton: 'Running…',
      estimatedCost: '~%COUNT% credits per run',
      estimatedCostFree: 'Free',
      balanceLabel: 'Balance: %COUNT% credits',
      costExplainer: 'Your request will cost %COUNT% credits per run. Credits are automatically refunded for failed generations (you\u2019re never charged for failures).',
      costExplainerFree: 'This request is free to run. You won\u2019t be charged any credits.',
      buyMoreCredits: 'Buy more credits',
      getCredits: 'Get credits',
      notChargedForFailure: 'You were not charged for this run.',
      // Plus subscriber whose balance can't cover the run
      notEnoughForRun: 'This run needs %COST% credits and you have %COUNT%. Your monthly credits refresh on %DATE%.',
      notEnoughForRunNoDate: 'This run needs %COST% credits and you have %COUNT%.',
      seeOptions: 'See options',
      creditPerRunSuffix: 'credits / run',
      creditPerRunSuffixSingular: 'credit / run',
      creditPerRunSuffixFree: 'no credits used',
      runningStatus: 'Running…',
      inProgressStatus: 'In progress',
      failedStatus: 'Failed',
      resultStatus: 'Result',
      noOutput: 'No output produced.',
      modelResponse: 'Response',
      segmentNoText: 'No text for this model.',
      openingInChat: 'Opening…',
      couldNotContinueInChat: 'Could not continue in chat',
      continueInChat: 'Continue in chat',
      copy: 'Copy',
      copied: 'Copied to clipboard',
      copyFailed: 'Could not copy',
      editAndRerun: 'Edit & re-run',
      download: 'Download',
      downloadCount: 'Download (%COUNT%)',
      downloading: 'Downloading…',
      downloadFailed: 'Download failed',
      // iOS / Android relabel of `download` for runs that produce
      // image / video output. The download flow on native saves through
      // MediaLibrary into the system Photos app — calling that "Download"
      // reads as wrong-platform copy on a phone.
      saveToPhotos: 'Save to Photos',
      savingToPhotos: 'Saving…',
      saveCount: 'Save (%COUNT%)',
      // Native-only OS share-sheet chip (iOS / Android). Web doesn't render
      // this chip, but we still ship the strings here so the English
      // fallback resolves cleanly.
      share: 'Share',
      sharing: 'Sharing…',
      shareFailed: 'Share failed',
      openFile: 'Open file',
      noRunsYet: 'No runs yet. Submit the form to create one.',
      runFailed: 'Tool run failed',
      deleteRunFailed: 'Failed to delete run',
      historyLoadFailed: 'Failed to load history',
      promotedToConversation: 'Opened in chat',
      // Status visuals (short labels used inside chips on cards)
      statusCompleted: 'Completed',
      statusFailed: 'Failed',
      statusCancelled: 'Cancelled',
      statusRunning: 'Running',
      statusQueued: 'Queued',
      // Result-type empty-state hints
      resultHintText: 'Your generated text will appear here.',
      resultHintImage: 'Your generated image will appear here.',
      resultHintVideo: 'Your generated video will appear here.',
      resultHintAudio: 'Your generated audio clip will appear here.',
      resultHintMusic: 'Your generated music will appear here.',
      resultHintCode: 'Your generated code will appear here.',
      resultHintDocument: 'Your generated document will appear here.',
      resultHint3dModel: 'Your generated 3D model will appear here.',
      resultHintDefault: 'Your result will appear here.',
      // Header dropdown triggers
      headerPresetsTooltip: 'Presets',
      headerRunsTooltip: 'Recent runs',
    },
    prompts: {
      title: 'Prompt Library — One-Click AI Image & Video Recipes',
      description: 'Browse curated recipes for images and video. Upload a photo or describe your idea, generate instantly, then keep refining in chat.',
      topline: 'Prompt Library',
      subtitle: 'Ready-to-run recipes for images and video — copy, customize, and generate in one click.',
      searchPlaceholder: 'Search the library…',
      allPrompts: 'All recipes',
      filterByModel: 'Filter by model',
      filterByTag: 'Filter by tag',
      filterAll: 'All',
      modalityAll: 'All',
      modalityNew: 'New',
      modalityImage: 'Image',
      modalityVideo: 'Video',
      noResults: 'No recipes match your filters.',
      generate: 'Generate',
      generating: 'Starting…',
      configureTitle: 'Your inputs',
      uploadRequired: 'Photo upload',
      runStarted: 'Generation started — open your chats to view progress.',
      runFailed: 'Could not start generation',
      recipeTitle: 'Recipe',
      recipeCopied: 'Recipe copied to clipboard',
      recipeCopyFailed: 'Could not copy recipe',
      relatedTitle: 'More from the library',
      relatedRecipes: 'Related recipes',
      examplesTitle: 'Try these inputs',
      categoryTitle: 'Prompt Library — Gab AI',
      categoryDescription: 'Browse curated AI recipes on Gab AI. Copy the recipe or generate in one click.',
      categoryDescriptionNamed: 'Browse %NAME% recipes in the Prompt Library. Copy the recipe or generate in one click.',
      notFound: 'Recipe not found.',
      browsePrompts: 'Browse the library',
      seoKeywords: 'AI prompt library, image prompts, video prompts, AI art generator, photo to video',
      myFavorites: 'My favorites',
      noFavoritePromptsYet: 'Save recipes with the heart to see them here.',
      noFavoritePromptsMatch: 'No saved favorites match this filter.',
      countOne: '1 recipe',
      countMany: '%COUNT% recipes',
      requestPrompt: 'Request a Prompt',
      requestPromptPrefill: "I'd like to request a prompt recipe for:\n\n(Describe the image or video you want — input type, style, example idea, etc.)",
    },
    tasks: {
      title: 'Tasks',
      description: 'Create and manage automated AI tasks.',
      heroTitle: 'Tasks',
      heroSubtitle:
        'Reusable AI workflows you can run on demand or on a schedule. Start from a template, customize steps, and manage everything here.',
      myFavorites: 'My favorites',
      noTasksForFavorites: 'Create a task first, then tap the heart to save it here.',
      noFavoriteTasksMatch: 'No saved favorites in your current tasks.',
      noFavoriteTemplatesMatch: 'No saved favorite templates match this search.',
      noFavoriteTemplatesInCategory: 'No saved favorites in this category. Tap the heart on a template card to add some.',
      favoritesEmptyTitle: 'No favorites yet',
      favoritesEmptySubtitle:
        'Pin templates and tasks you use often — tap the heart on any card and they will show up here.',
      favoritesEmptyTemplatesHint: 'Favorite a template',
      favoritesEmptyTemplatesHintDesc: 'Browse the catalog and tap the heart on any template card.',
      favoritesEmptyTasksHint: 'Favorite a scheduled task',
      favoritesEmptyTasksHintDesc: 'Open one of your tasks and tap the heart to pin it here.',
      favoritesEmptyCategoryTitle: 'No favorites in this category',
      favoritesEmptyCategorySubtitle:
        'You have saved favorites elsewhere. Browse all templates or switch to another category.',
      favoritesEmptyBrowseAll: 'Browse all templates',
      catalogSort: 'Sort templates',
      catalogSortRelevant: 'Recommended',
      catalogSortPopular: 'Popular',
      catalogSortNameAsc: 'Name A–Z',
      catalogSortNameDesc: 'Name Z–A',
      catalogSortCategory: 'By category',
      myTasks: 'My Tasks',
      browseTemplates: 'Browse templates',
      loadingTasks: 'Loading tasks...',
      activeCount: '%COUNT% active',
      deleteTitle: 'Delete Task',
      deleteMessage: 'Are you sure you want to delete this task? This action cannot be undone.',
      deleteSuccess: 'Task deleted successfully',
      deleteFailed: 'Failed to delete task',
      taskTemplates: 'Task Templates',
      createCustom: 'Create Custom Task',
      searchPlaceholder: 'Search templates...',
      noTemplatesFound: 'No templates found matching "%QUERY%".',
      noTemplatesAvailable: 'No task templates available at the moment.',
      loadFailed: 'Unable to load tasks right now. Pull to refresh and try again.',
      templateLoadFailed: 'Unable to load task templates right now.',
      errorLoading: 'Error loading tasks: %ERROR%',
      browseTitle: 'Browse Task Templates',
      browseDescription: 'Browse and discover AI task templates.',
      browseSearchPlaceholder: 'Search for templates',
      // V1 catalog page chrome
      spotlight: 'Spotlight',
      newBadge: 'New',
      scheduleIt: 'Schedule it',
      scopeAll: 'All',
      scopeFeatured: 'Featured',
      browseEyebrow: 'Browse',
      categoriesEyebrow: 'Categories',
      resultsFor: 'Results for',
      featuredTemplates: 'Featured templates',
      allTemplates: 'All templates',
      templates: 'Templates',
      // Tasks hero — discovery strip (`CatalogDiscoveryHero` on /tasks)
      discoveryHeadline: 'Put AI to work for you with automated tasks.',
      discoveryTopline: 'Schedule a Task',
      discoverySubtitle:
        'A task is a reusable instruction you schedule once—then it runs automatically and delivers results where you want them.',
      discoveryHeadlineCategory: 'What should run next for %NAME%?',
      discoverySubtitleCategoryFallback:
        'Tap any chip to open setup for a %NAME% template—pick a schedule and delivery, and Gab AI handles the rest.',
      categoryMetaEyebrow: 'About this category',
      // Tasks page header + catalog chrome (redesign)
      headerHeadline: 'Work that runs on a schedule.',
      headerSubtitle:
        'Pick a template, set a time, and the Work agent researches, writes, and delivers — to a chat or your inbox — without you asking twice.',
      newTask: 'New task',
      myFavoriteTasks: 'Favorite tasks',
      showFewer: 'Show fewer',
      showAllCount: 'Show all %COUNT%',
      seeAllCount: 'See all %COUNT%',
      templateCount: '%COUNT% templates',
      templateCountIn: '%COUNT% templates in %NAME%',
      favoriteTemplatesCount: '%COUNT% favorite templates',
      settingsOne: '1 setting',
      settingsCount: '%COUNT% settings',
      colTask: 'Task',
      colSchedule: 'Schedule',
      colNext: 'Next run',
      colLast: 'Last run',
      howStep1Title: 'Pick a template',
      howStep1Body: 'Choose what you want done and fill in a few settings — sources, topics, tone.',
      howStep2Title: 'Set the schedule',
      howStep2Body: 'Daily, weekly, or monthly, at the time you want it. Turn on email if you want it in your inbox.',
      howStep3Title: 'Get the result',
      howStep3Body: 'The Work agent researches, writes, and attaches files on its own. Each run lands in a chat you can reply to.',
      heroEyebrow: 'Gab AI Tasks',
      heroCategoryEyebrow: 'Task category',
      searchPlaceholder: 'Search templates…',
      allTemplates: 'All templates',
      categoryTemplates: '%NAME% templates',
      templateCountSingle: '1 template',
      featuredSubtitle: 'Most-used templates this month',
      setUpTemplate: 'Set up',
      detailAtAGlance: 'At a glance',
      detailRuns: 'Runs',
      detailUses: 'Uses',
      detailYouConfigure: 'You configure',
      detailNoSettings: 'No settings to fill in. Schedule it and it runs as-is.',
      detailHowTemplatesWork: 'How templates work',
      detailCtaTitle: 'Put it on the calendar',
      detailCtaBody: 'One setup. The Work agent handles every run from here.',
      emailSettingsTitle: 'Task email settings',
      emailSettingsDescription: 'Stop or manage email delivery for this scheduled task.',
      emailSettingsBody: 'Turn off email delivery for this task. The task will keep running on its schedule; you just will not get results by email.',
      stopTaskEmails: 'Stop receiving this task by email',
      emailDisabledTitle: 'Email delivery turned off',
      emailDisabledBody: 'You will no longer receive emails for this task.',
      emailAlreadyDisabled: 'Email delivery for this task was already turned off.',
      emailDisabledSuccess: 'Email delivery disabled for this task',
      emailDisabledFailed: 'Failed to disable email delivery',
      manageThisTask: 'Manage this task',
      backToTasks: 'Back to tasks',
    },
    agents: {
      title: 'AI Bots',
      putBotToWork: 'Give Bot A Job',
      quickChatWithBot: 'Quick Chat With Bot',
      keyJobRoles: 'Key job roles',
      description: 'Explore and manage your AI bots.',
      seeAll: 'See all',
      myAgents: 'Your bots',
      searchPlaceholder: 'Search for bots',
      noAgentsFound: 'No bots found matching "%QUERY%".',
      noAgentsInCategory: 'No bots found in this category.',
      errorLoading: 'Error loading bots',
      noAgentsYet: 'Give a bot a job and your instructions. Come back to it whenever you need a hand.',
      createNew: 'Create New Bot',
      agentCount: '%COUNT% bots',
      agentCountSingle: '%COUNT% bot',
      searchTitle: 'Search Bots',
      searchPlaceholderFull: 'Search Bots',
      searchEmptyTitle: 'Find your next bot',
      searchEmptySubtitle: 'Search by name or job to find an AI teammate.',
      searchEmptyMessage: 'Search for bots',
      mine: 'Mine',
      heroTitle: 'A bot for the job.',
      heroSubtitle: 'Pick a teammate for writing, coding, research, and more. Give it a job and the context to get started.',
      featured: 'Featured',
      featuredAgents: 'Featured bots',
      featuredCount: '%COUNT% hand-picked',
      categoriesLabel: 'CATEGORIES',
      filterByCategory: 'FILTER BY CATEGORY',
      sortNameAZ: 'Name A–Z',
      sortNameZA: 'Name Z–A',
      sortNewest: 'Newest',
      sortOldest: 'Oldest',
      colAgent: 'Bot',
      colCategory: 'Category',
      colFocus: 'Focus',
      colFavorite: 'Save',
      addFavoriteTooltip: 'Add to favorites',
      removeFavoriteTooltip: 'Remove from favorites',
      colChat: 'Chat',
      whatTheyDo: 'What they do',
      jobsEyebrow: 'Start with a job',
      signInToFavorite: 'Sign in to favorite a bot',
      signInToFavoriteSubtitle: 'Favorites appear in your sidebar so you can start a new chat with that bot anytime.',
      signInToCreate: 'Sign in to create a bot',
      signInToCreateSubtitle: 'Save a bot with its own job and instructions to your account.',
      listView: 'List view',
      gridView: 'Grid view',
      browseAgents: 'Browse bots',
      seeAllArrow: 'See all →',
      noResults: 'No bots to show.',
      useThisAgent: 'Use this Bot',
      copyLink: 'Copy link',
      copyAllLinks: 'Copy all links',
      linksCopied: 'Copied %COUNT% bot links',
      privateLinkCopied: 'Link copied. This bot is private, so only you can open it.',
      linksCopyIncomplete: "Couldn't load every bot link. Try again.",
      agentActions: 'Bot actions',
      editAgent: 'Edit bot',
      deleteAgent: 'Delete bot',
      deleteAgentTitle: 'Delete %NAME%?',
      deleteAgentMessage: 'This removes the bot from your list. Existing chats with it are kept.',
      agentDeleted: 'Bot deleted',
      deleteAgentFailed: 'Failed to delete bot',
      intro: {
        eyebrow: 'BOTS',
        headline: 'AI teammates for your everyday work',
        lead: 'A bot is an AI teammate with a job and saved instructions. Choose one, add your context, and start a focused conversation.',
        fact1Title: 'Specialists, not generalists',
        fact1Body: 'Each bot starts with instructions for a particular job. You provide the goal, context, and constraints.',
        fact2Title: 'Use them anywhere',
        fact2Body: 'Open a chat with a bot, or type @ in any conversation to pull one in mid-thought.',
        fact3Title: 'Make your own',
        fact3Body: 'Give it a job and instructions. Bots run in Work mode with Plus, subject to credits and limits.',
        createTitle: 'Meet your first bot',
        createSubtitle: 'Takes about two minutes.',
        step1: 'Name it and describe the job.',
        step2: 'Write its instructions, or let us draft them.',
        step3: 'Use it privately anytime in chat.',
        createCta: 'Create a bot',
        manageOne: 'You have 1 bot',
        manageMany: 'You have %COUNT% bots',
        manageLink: 'Manage',
        signInHint: 'Free account required so your bots stay tied to you.',
        browseTitle: 'Explore bots',
        browseSubtitle: 'Find a specialist for the job you have in mind.',
      },
      agentDetailLoading: 'Loading bot…',
      agentNotFound: 'Bot not found',
      agentRemovedUnavailable: 'This bot may have been removed or is unavailable.',
      agentSeoMetaFallback:
        'Find a bot for your next job on Gab AI. Choose a specialty and start a focused chat.',
      agentMissingSlug: 'Missing bot link',
      whatIsAgentTitle: 'What is an AI bot?',
      whatIsAgentBody:
        'Bots are tuned assistants with their own instructions and style. You pick one, open a chat, and work in a context built for that job — writing, code, research, faith, and more.',
      capabilitiesEyebrow: 'Capabilities',
      inputsLabel: 'Inputs',
      outputsLabel: 'Outputs',
      starterPromptsTitle: 'Starter prompts',
      aboutAgent: 'About this bot',
      readyToChatTitle: 'Ready to start?',
      readyToChatBody: 'Open a conversation with this bot. Give it a job, add your context, and review the result.',
      relatedAgents: 'Related bots',
      sameCategoryAgents: 'More in this category',
      conversationsLabel: 'chats',
      categoryMetaEyebrow: 'About this category',
      // Long-form SEO below the catalog on /agents (no category selected)
      landingCatalogSeoSectionTitle: 'Pick the job before the chat',
      landingCatalogSeoSectionSubtitle:
        'Specialized bots for code, images, writing, research, faith, business, productivity, and more',
      landingCatalogSeoSectionCopy:
        'Bots are AI teammates with saved instructions for a particular job. Browse by category, read the description, and choose a starting point. Add your goal, context, and constraints, then review the results. Bots run in Work mode, which is available with Plus and uses credits.',
      landingCatalogSeoHowTitle: 'How to use this catalog',
      landingCatalogSeoHow1:
        'Start from the outcome—coding help, a visual style, long-form writing, research synthesis, spiritual guidance, finance questions, or something else—and pick the category that matches.',
      landingCatalogSeoHow2:
        'Open a bot you are curious about: read its description, capability chips, and starter prompts so you know what context it expects before you spend a message.',
      landingCatalogSeoHow3:
        'When you start a chat, state the goal, constraints, audience, and what “done” looks like. Bots perform best when they can see the same inputs you would give a specialist colleague.',
      landingCatalogSeoHow4:
        'Use “See all →” on any category row to open the full paginated list for that topic—ideal when you want to compare several bots in the same lane.',
      landingCatalogSeoHow5:
        'If you repeat the same workflow, create a custom bot from the My Bots path so your instructions and defaults stay one tap away.',
      landingCatalogSeoBestTitle: 'Best for',
      landingCatalogSeoBest1: 'Developers and students who need code, algorithms, APIs, or reviews—not vague coding guesses',
      landingCatalogSeoBest2: 'Designers, marketers, and game builders who want style-consistent images and visual concepts',
      landingCatalogSeoBest3: 'Writers, operators, and founders who want drafts, edits, strategy, and email in a focused voice',
      landingCatalogSeoBest4: 'Researchers and analysts who need synthesis, outlines, and structured explanations from sources you provide',
      landingCatalogSeoBest5: 'Anyone who is tired of re-explaining the same project context to a general-purpose chat',
      landingCatalogSeoBest6: 'Plus members using Plus-only bots and Work mode for multi-step jobs',
      landingCatalogSeoBest7: 'Teams browsing a shared catalog where everyone picks the same specialist for repeatable tasks',
      landingCatalogSeoFaqTitle: 'AI bots on Gab AI — FAQ',
      landingCatalogSeoFaq1Q: 'What is a “bot” here versus normal chat?',
      landingCatalogSeoFaq1A:
        'Each bot is a tuned profile with a role, instructions, and often structured inputs. You still chat naturally, but the model behaves like a specialist for that job instead of a catch-all assistant.',
      landingCatalogSeoFaq2Q: 'How do I choose the right bot?',
      landingCatalogSeoFaq2A:
        'Match category to intent first, then read the short description and starter prompts. If two bots overlap, pick the one whose examples are closest to your deliverable—debugging, poster layout, sermon outline, etc.',
      landingCatalogSeoFaq3Q: 'Are all bots available to every account?',
      landingCatalogSeoFaq3A:
        'Many bots are available on free accounts within normal usage limits. Some bots are marked Plus-only; those require an active Plus subscription or the appropriate entitlements.',
      landingCatalogSeoFaq4Q: 'Can I create my own bots?',
      landingCatalogSeoFaq4A:
        'Yes. Use My Bots to create custom bots with your own instructions and defaults so repeated workflows stay consistent without retyping the same preamble.',
      landingCatalogSeoFaq5Q: 'Do bots replace professionals, lawyers, doctors, or financial advisors?',
      landingCatalogSeoFaq5A:
        'No. Bots are software assistants for drafting, brainstorming, and productivity. They do not provide professional, legal, medical, or fiduciary advice; verify anything consequential in the real world.',
      landingCatalogSeoCardsTitle: 'Pick by the kind of work',
      landingCatalogSeoCard1Title: 'Code, data, and systems',
      landingCatalogSeoCard1Description:
        'When the input is snippets, errors, APIs, algorithms, or performance—start in Programming and related technical categories so the answer targets your stack and constraints.',
      landingCatalogSeoCard2Title: 'Visuals and creative direction',
      landingCatalogSeoCard2Description:
        'When you need a defined art direction—characters, posters, scenes, cards—use Image Generators and similar rows so style stays consistent instead of drifting every prompt.',
      landingCatalogSeoCard3Title: 'Words, strategy, and operations',
      landingCatalogSeoCard3Description:
        'For copy, email, research summaries, business framing, faith-and-life guidance, or productivity—pick the category that matches the audience and tone you need.',
      landingCatalogSeoCalloutTitle: 'One clear intent beats a kitchen-sink prompt',
      landingCatalogSeoCalloutCopy:
        'The category pages and bot cards are organized so you name one dominant goal per run. Mixing unrelated asks in a single message is what makes any model—including specialists—less reliable.',
    },
    topics: {
      title: 'Topics',
      browseLabel: 'All Topics',
      exploreCta: 'Explore with Gab AI',
      loading: 'Loading topic…',
      notFound: 'Topic not found',
      removedUnavailable: 'This page may have been removed or is unavailable.',
      missingSlug: 'Missing topic link',
      seoMetaFallback:
        'Reference guides for people, media, and culture on Gab AI — facts, timelines, and common questions. For research and learning, not roleplay.',
      researchEyebrow: 'Research & reference',
      researchCallout:
        'These guides are for learning and research — facts, timelines, and common questions about real people, media, and culture. They are not roleplay, impersonation, or “talk with” character chat.',
      guideEyebrow: 'Reference guide',
      guideTitle: 'Learn about this topic',
      guideBody:
        'These pages are reference and discovery guides — not roleplay. Read the FAQ, then open Gab AI to ask follow-up questions.',
      starterQuestions: 'Starter questions',
      relatedTopics: 'Related topics',
      relatedTags: 'Related tags',
      chatPlaceholder: 'Send message to %MODEL% about %TOPIC%',
      continueAskMore: 'Ask %MODEL% more',
      continueDigDeeper: 'Dig deeper',
      continueExplore: 'Keep exploring',
      conversationsLabel: 'explorations',
      searchPlaceholder: 'Search topics…',
      noResultsForQuery: 'No topics match "%QUERY%".',
      categoriesTitle: 'Categories',
      popularTags: 'Popular tags',
      feedbackButton: 'Feedback',
      feedbackEyebrow: 'Page feedback',
      feedbackSectionBody:
        'Request a revision, correction, update, removal, takedown, or report another issue with this page so we can review it.',
    },
    models: {
      title: 'AI Models',
      description: 'Explore and discover AI models by capability.',
      searchPlaceholder: 'Search for models',
      noModelsFound: 'No models found matching "%QUERY%"',
      companyNotFound: 'Company not found',
      goBack: 'Go back to all models',
      tagNotFound: 'Tag not found',
      searchTitle: 'Search Models',
      searchPlaceholderFull: 'Search AI Models',
      searchEmptyTitle: 'Find your next model',
      searchEmptySubtitle: 'Search by name or provider to explore our collection of AI models.',
      searchEmptyMessage: 'Search for AI models',
      plus: 'Plus',
      openSource: 'Open Source',
      subtitle: 'Browse every model available in your workspace, organized for fast discovery.',
      catalogSearchPlaceholder: 'Search by model, task, category and more...',
      tryPrefix: 'Try:',
      scopeAll: 'All',
      scopeFrequent: 'Frequent',
      scopeFavorites: 'Favorites',
      category: 'Category',
      clear: 'Clear',
      clearFilters: 'Clear filters',
      noCategoriesInScope: 'No categories in this scope.',
      noResults: 'No models match these filters.',
      emptyFrequent: "You haven't used any models yet.",
      emptyFavorites: "You haven't favorited any models yet.",
      showingResults: 'Showing %COUNT% of %TOTAL% results',
      filteredByCompany: 'Filtered by company',
      loadingMore: 'Loading more models…',
      scrollToLoadMore: 'Scroll for more',
      sortLabel: 'Sort',
      sortTrending: 'Trending',
      sortNewest: 'Newest',
      sortNameAZ: 'A → Z',
      sortCheapest: 'Cheapest',
      gridView: 'Grid view',
      listView: 'List view',
      colModel: 'Model',
      colCompany: 'Company',
      colInputs: 'Inputs',
      colOutputs: 'Outputs',
      colCost: 'Cost',
    },
    tags: {
      title: 'Tags',
      description: 'Browse topic tags for research and discovery — reference guides about culture and history, not character roleplay.',
      searchPlaceholder: 'Search tags…',
      noResultsForQuery: 'No tags match "%QUERY%".',
      notFound: 'Tag not found',
    },
    referral: {
      title: 'Refer a Friend',
      description: 'Share Gab AI with friends and earn credits.',
    },
    deck: {
      title: 'Deck - Multi-Chat View',
      description: 'View and interact with multiple AI conversations side by side.',
    },
    library: {
      title: 'Chat Library',
      description: 'Access your personal conversation history with various AI models.',
    },
    auth: {
      mfaTitle: 'Two\u2011factor authentication',
      mfaSubtitle: 'Enter your code to complete login',
      mfaMetaTitle: 'MFA Verification',
      mfaMetaDescription: 'Verify your identity to complete sign\u2011in.',
    },
    public: {
      tagline: 'All The Top AI Models In One Place',
      signIn: 'Sign In',
      signUp: 'Sign Up',
    },
    success: {
      headerTitle: 'Loading...',
    },
    paymentSuccessful: {
      metaTitle: 'Payment Successful',
      metaDescription: 'Your Gab AI purchase was successful.',
      title: 'Payment successful',
      subtitle: 'Thank you! Your purchase has been completed and your account has been updated.',
      continue: 'Continue to Gab AI',
      viewCredits: 'View credits',
      errorMetaTitle: 'Payment Not Completed',
      errorTitle: 'Payment not completed',
      errorSubtitle: 'Your bank did not approve the verification, so the purchase did not go through and nothing was added to your account. You can try again or use a different card.',
      errorRetry: 'Try again',
      errorContact: 'Still stuck? Contact support and we will help you finish the purchase.',
    },
  },
  emptyState: {
    tasks: {
      title: 'Your AI, Working For You',
      subtitle: 'Set up automated tasks and let AI deliver valuable information to you on a schedule. Get daily news briefings, research updates, devotionals, and more - all without lifting a finger.',
      createCustomTask: 'Create Custom Task',
      setItAndForgetIt: 'Set It and Forget It',
      setItAndForgetItDesc: 'Schedule tasks to run daily, weekly, or monthly. Your AI assistant works for you around the clock.',
      resultsInYourInbox: 'Results in Your Inbox',
      resultsInYourInboxDesc: 'Get results by email or saved to your Gab AI chat history — on the schedule you choose.',
      readyToUseTemplates: 'Ready-to-Use Templates',
      readyToUseTemplatesDesc: 'Choose from curated templates for news briefings, devotionals, research summaries, and more.',
      popularTemplates: 'Popular Templates to Get Started',
      taskIdeas: 'Task Ideas',
      dailyNewsBriefing: 'Daily news briefing',
      morningDevotional: 'Morning devotional',
      stockMarketSummary: 'Stock market summary',
      weeklyResearchDigest: 'Weekly research digest',
      industryNewsRoundup: 'Industry news roundup',
      dailyPrayerPrompts: 'Daily prayer prompts',
      bottomHint: 'Takes less than a minute to set up your first task',
    },
    memory: {
      title: 'Give Your AI a Memory',
      subtitle: 'Store key facts about yourself to personalize every conversation.',
      remembersYou: 'Remembers You',
      allChats: 'All Chats',
      fullControl: 'Full Control',
      buildProfileTitle: 'Build Your Memory Profile',
      buildProfileDesc: 'Answer a few quick questions to personalize your AI experience.',
      getStarted: 'Get Started',
      importFromAI: 'Import Memories From Another AI Tool',
      orAddManually: 'or add manually',
      exampleConcise: 'I prefer concise answers',
      exampleDeveloper: 'I\'m a software developer',
      exampleReact: 'My project uses React',
      exampleDarkMode: 'I like dark mode',
      exampleSpanish: 'I speak Spanish too',
      exampleName: 'Call me by my name',
    },
    files: {
      title: 'Your files, supercharged with AI',
      subtitle: 'Upload documents, images, and more to chat with them, search across them, and keep everything organized.',
      chatWithFiles: 'Chat with your files',
      chatWithFilesDesc: 'Upload documents and have AI-powered conversations about them',
      organizeWithCollections: 'Organize with collections',
      organizeWithCollectionsDesc: 'Group related files and chats together in collections',
      customAiBehavior: 'Custom AI behavior',
      customAiBehaviorDesc: 'Set instructions for how AI responds within each collection',
      uploadFiles: 'Upload files',
      createCollection: 'Create collection',
      dragDropHint: 'or drag and drop files anywhere on this page',
    },
  },
};

module.exports = TRANSLATIONS_ENGLISH;
